import React from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import Datetime from "react-datetime";
import DatePicker from 'react-date-picker';

import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';

import PropTypes from "prop-types";

import axios from 'axios'
import firebase, { db, storage, sendEmail, sendSMS } from "firebase/fbConfig.js"
import moment from 'moment'
import { v1 as uuidv1 } from 'uuid';
import Geocode from "react-geocode";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import VendorPicUpload from "components/CustomUpload/vendorPicUpload.jsx";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
import ShipFullScreenMap from "../../views/Maps/ShipFullScreenMap";
import FormLabel from '@material-ui/core/FormLabel';
import FullScreenMap from "../../views/Maps/ShipFullScreenMap";
import FlightSearchForm from "./FlightSearchForm";

import DateTimePicker from 'react-datetime-picker'


import PrototypeExploreAssignUser from '../../views/Explore/PrototypeExploreAssignUser.jsx';
import PartyFreightSummary from './PartyFreightSummary.jsx';
import { isEmail, isPhoneNumber, itemErrorDetails, onlyNumbers, onlyLettersAndWhitespace } from "../../store/actions/formActions.jsx";


const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Form extends React.Component {
  state = {
    comment: '',
    queryString: "",
    actionAssigned: false,
    assignedError: false,
    defaultLoaded: false,
    assigningAction: "",
    cardAnimaton: "cardHidden",
    messageSent: false,
    messageError: false,
    mapDataSaved: true
  }
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      shippingMode: '',
      pickUpServices: '',
      dropOffServices: '',
      services: '',
      items: [],
      itemCount: 1,
      userSet: false,
      step5: true,
      item2: false,
      item3: false,
      flightNumber: (this.state.orderData && (this.state.orderData.flight && this.state.orderData.flight.number)),
      matchingFlights: [],
      hideFlights: false,
      radius: 200,
      getAirportsLoaded: false,
      vendorsQualified: false,
      dropOffVendorsQualified: false,
      driverSelected: false,
      editOrder: false,
      documentsLoading: false,
      documentsLoaded: 0,
      // origin: (this.state.orderData && this.state.orderData.origin),
      // destination: (this.state.orderData && this.state.orderData.destination),
      originAirCarrier: {},
      destinationAirCarrier: {}
    };
    this.handleToggleServices = this.handleToggleServices.bind(this);
    this.handleToggleItemServices = this.handleToggleItemServices.bind(this);
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
    //console.log(this.state)
  }

  handleArrChange = (e, arr) => {
    let array = this.state.orderData[arr];
    array[e.target.id] = e.target.value;
    this.setState({
      [arr]: array
    })
  }

  handleItemChange = (e, i) => {
    var orderData = this.state.orderData;
    orderData.items[i][e.target.id || e.target.name] = e.target.value;
    console.log(orderData, e.target.id, e.target.value);
    this.setState({ orderData: orderData });
  }

  handleItemSelectChange = (e, i) => {
    const orderData = this.state.orderData;
    orderData.items[i][e.target.name] = e.target.value

    this.setState({ orderData: orderData });
  }

  handleDateChange = (date, obj) => {
    if (date) {
      let bucket = this.state.orderData[obj];
      bucket['date'] = date;
      this.setState({
        [obj]: bucket
      })
    }
  }

  handleDateTimeChange = (date, obj) => {
    if (date) {
      let bucket = this.state.orderData[obj];
      bucket['deliverBy'] = date;
      this.setState({
        [obj]: bucket
      })
    }
  }

  handleToggleItemServices(value, iterator) {
    var orderData = this.state.orderData;
    value = value.includes(" ") ? value.split(" ").join("") : value;
    orderData.items[iterator][`is${value}`] == true ? delete orderData.items[iterator][`is${value}`] : orderData.items[iterator][`is${value}`] = true;
    this.setState({ orderData: orderData });
  }


  handlePickUpDateChange = (pickUpDate) => {
    //console.log(pickUpDate._d)
    if (pickUpDate) {
      this.setState(() => ({ pickUpDate: pickUpDate, pickUpAPI: moment(pickUpDate).format('YYYY-MM-DD') }))
    }
  }

  handleDropOffDateChange = (dropOffDate) => {
    //console.log(dropOffDate)
    if (dropOffDate) {
      this.setState(() => ({ dropOffDate: dropOffDate }))
    }
  }

  // only make future selectable  
  valid = (current) => {
    return current.isAfter(Datetime.moment().subtract(1, 'day'));
  };


  handleSelectChange = (e) => {
    console.log(e.target.value)
    this.setState({
      [e.target.name]: e.target.value,
      pickUpDriverContactLoaded: false
    })
    // console.log(this.state)
  }

  handleSelectChangeObj = (e, obj) => {
    let bucket = this.state.orderData[obj];
    bucket[e.target.name] = e.target.value;
    this.setState({
      [obj]: bucket
    });
  }

  handleSelectChangeStateObj = (e, obj) => {
    let orderData = this.state.orderData;
    orderData[obj][e.target.name] = e.target.value;
    this.setState({
      orderData: orderData
    });
  }

  handleSelectDropOffVendorChange = (e) => {
    console.log(e.target.value)
    this.setState({
      [e.target.name]: e.target.value,
      dropOffDriverSelected: false,
      driversDropOffDataLoaded: false
    })
    // console.log(this.state)
  }

  handleSelectPickUpVendorChange = (e) => {
    console.log(e.target.value)
    console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
      driverSelected: false,
      driversPickUpDataLoaded: false
    })
    // console.log(this.state)
  }

  handleTogglePickupServices(value) {
    const { pickUpServices } = this.state;
    const currentIndex = pickUpServices.indexOf(value);
    const newPickUpServices = [...pickUpServices];

    if (currentIndex === -1) {
      newPickUpServices.push(value);
    } else {
      newPickUpServices.splice(currentIndex, 1);
    }

    this.setState({
      pickUpServices: newPickUpServices
    });
  }

  handleToggleDropOffServices(value) {
    const { dropOffServices } = this.state;
    const currentIndex = dropOffServices.indexOf(value);
    const newDropOffServices = [...dropOffServices];

    if (currentIndex === -1) {
      newDropOffServices.push(value);
    } else {
      newDropOffServices.splice(currentIndex, 1);
    }

    this.setState({
      dropOffServices: newDropOffServices
    });
  }

  handleToggleServices(value, obj) {
    var orderData = this.state.orderData;
    var services = orderData[obj]['services'];
    const index = services.indexOf(value);

    if (index !== -1) {
      services.splice(index, 1)
    } else {
      services.push(value)
    }

    orderData[obj]['services'] = services;

    this.setState({ orderData: orderData });
  }

  handleClickOpen = (modal) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
    });
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  uploadImage = (refString, pic) => {
    console.log("Uploading image");
    return new Promise((resolve, reject) => {
      // create storage ref
      var storageRef = storage.ref(refString);
      // upload pic
      var uploadTask = storageRef.put(pic);
      // update progress bar
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and 
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        var Progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.setState({ uploadProgress: 'Progress is ' + Progress + '% done' });

        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            this.setState({ uploadProgress: ' Upload is paused' });
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            this.setState({ uploadProgress: 'Upload is running' });
            break;
        }

      }, (error) => {
        // Handle unsuccessful uploads
        console.log(error)
      }, () => {
        // Handle successful uploads on complete
        // For instance, get the download URL: https://firebasestorage.googleapis.com/...
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          resolve(downloadURL)
        });
      })
    })
  }

  cancelOrder = () => {
    // update firestore document with PENDING and comment
    db.collection("haney-orders").doc(this.state.orderData.id).set({
      status: "canceled",
      canceledAt: new Date()
    }, { merge: true }).then(() => {
      db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
        status: "canceled",
        canceledAt: new Date()
      }, { merge: true }).then(async () => {
        // console.log(this.state.pickUpDriverContact.email)
        //const email = this.props.user.email

        // let subject = `Your order has been quoted!`
        // let html = `<p>Hello </p>`
        // html += `<p>Order #: ${this.state.orderData.id}</p><a href=https://haney-freightways-customer.web.app/quote/${this.state.orderData.id}>Go to Quote</a>`
        // // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
        // const emails = [this.state.orderUserData.email]
        // const attatchment = true;
        // const emailReturn = await sendEmail({
        //     emails,
        //     subject,
        //     html,
        //     attatchment
        // })

      }).then(() => {
        window.location.reload()
      })
    })
  }

  requestWaybillSig = (signUrl) => {

    // this.setState({
    //   eSigModal: true
    // });

    db.collection("haney-orders").doc(this.props.orderID).set({
      signatureRequested: new Date(),
    }, { merge: true }).then(async () => {
      console.log("requesting signature")

      const axios = require("axios");

      axios({
        "method": "POST",
        "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
        "data": {
          "sandbox": 0,
          "is_draft": 0,
          "embedded": 1,
          "title": `Haney Freightways Document House Waybill #${this.props.orderID}`,
          "message": "This is my general document message.",
          "use_signer_order": 0,
          "reminders": 1,
          "require_all_signers": 0,
          "custom_requester_name": "",
          "custom_requester_email": "",
          "redirect": `https://haney-freightways-vendor.web.app/order/${this.props.orderID}`,
          "redirect_decline": "https://haney-freightways-vendor.web.app/declined",
          "client": "",
          "expires": 1750513480,
          "embedded_signing_enabled": 1,
          "flexible_signing": 0,
          "use_hidden_tags": 0,
          "files": [{
            "name": "House Waybill",
            "file_url": "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FCustomer%20Docs%2FHouse%20Waybill%20Final%205.4.2020.pdf?alt=media&token=02fedb99-548e-4f90-ab02-30fb0a071665",
            "file_id": "",
            "file_base64": ""
          }],
          "signers": [{
            "id": 1,
            "name": "Shipper Signer",
            "email": this.state.orderData.origin.email,
            "order": 1,
            // "pin": "3874",
            "message": "This is my custom message to Shipper.",
            "deliver_email": "",
            "language": "en"
          }, {
            "id": 2,
            "name": this.state.dropOffDriverData.name,
            "email": this.state.dropOffDriverData.email,
            "order": 2,
            // "pin": "3874",
            "message": "This is my custom message to Driver.",
            "deliver_email": "",
            "language": "en"
          }, {
            "id": 3,
            "name": "Consignee Signer",
            "email": this.state.orderData.destination.email,
            "order": 3,
            // "pin": "3874",
            "message": "This is my custom message to Consignee.",
            "deliver_email": "",
            "language": "en"
          }],
          "recipients": [{
            "name": "Justin",
            "email": "development@kordspace.com",
            "language": "en"
          }, {
            "name": "Vendor",
            "email": this.props.user ? this.props.user.email : "justin@pondata.com",
            "language": "en"
          }],
          "meta": {
            "some_key": "some_value",
            "another_key": "another_value"
          },
          "fields": [
            [{
              "type": "signature",
              "x": "520",
              "y": "930",
              "width": "120",
              "height": "35",
              "page": "1",
              "signer": "1",
              "name": "",
              "identifier": "unique_field_identifier_1",
              "required": 1,
              "readonly": 0,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": "",
              "options": [],
              "group": ""
            }, {
              "type": "signature",
              "x": "50",
              "y": "995",
              "width": "120",
              "height": "35",
              "page": "1",
              "signer": "2",
              "name": "",
              "identifier": "unique_field_identifier_2",
              "required": 1,
              "readonly": 0,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": "",
              "options": [],
              "group": ""
            }, {
              "type": "signature",
              "x": "600",
              "y": "1010",
              "width": "150",
              "height": "35",
              "page": "1",
              "signer": "3",
              "name": "",
              "identifier": "unique_field_identifier_3",
              "required": 1,
              "readonly": 0,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": "",
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "150",
              "y": "213",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin Company Name",
              "identifier": "unique_field_identifier_4",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.businessName,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "150",
              "y": "230",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin Address",
              "identifier": "unique_field_identifier_5",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.address,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "100",
              "y": "243",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin City",
              "identifier": "unique_field_identifier_6",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.city,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "275",
              "y": "243",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin State",
              "identifier": "unique_field_identifier_7",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.state,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "360",
              "y": "243",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin Zip",
              "identifier": "unique_field_identifier_8",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.zip,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "140",
              "y": "257",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin Contact Name",
              "identifier": "unique_field_identifier_9",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.firstName + " " + this.state.orderData.origin.lastName,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "360",
              "y": "257",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin Reference No.",
              "identifier": "unique_field_identifier_10",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.referenceID,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "90",
              "y": "272",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin Phone",
              "identifier": "unique_field_identifier_11",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.phone,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "290",
              "y": "272",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin Cell",
              "identifier": "unique_field_identifier_12",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.email,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "150",
              "y": "317",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination Company Name",
              "identifier": "unique_field_identifier_13",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.businessName,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "150",
              "y": "333",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination Address",
              "identifier": "unique_field_identifier_14",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.address,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "100",
              "y": "348",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination City",
              "identifier": "unique_field_identifier_15",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.city,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "275",
              "y": "348",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination State",
              "identifier": "unique_field_identifier_16",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.state,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "360",
              "y": "348",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination Zip",
              "identifier": "unique_field_identifier_17",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.zip,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "140",
              "y": "363",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination Contact Name",
              "identifier": "unique_field_identifier_18",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.firstName + " " + this.state.orderData.destination.lastName,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "360",
              "y": "363",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination Reference No.",
              "identifier": "unique_field_identifier_19",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.referenceID,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "90",
              "y": "377",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination Phone",
              "identifier": "unique_field_identifier_20",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.phone,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "290",
              "y": "375",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination Cell",
              "identifier": "unique_field_identifier_21",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.email,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "150",
              "y": "421",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party Company Name",
              "identifier": "unique_field_identifier_22",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.businessName,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "150",
              "y": "437",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party Address",
              "identifier": "unique_field_identifier_23",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.address,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "100",
              "y": "452",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party City",
              "identifier": "unique_field_identifier_24",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.city,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "275",
              "y": "452",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party State",
              "identifier": "unique_field_identifier_25",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.state,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "360",
              "y": "452",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party Zip",
              "identifier": "unique_field_identifier_26",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.zip,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "140",
              "y": "467",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party Contact Name",
              "identifier": "unique_field_identifier_27",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.firstName + " " + this.state.orderData.thirdParty.lastName,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "360",
              "y": "467",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party Reference No.",
              "identifier": "unique_field_identifier_28",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.referenceID,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "90",
              "y": "481",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party Phone",
              "identifier": "unique_field_identifier_29",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.phone,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "290",
              "y": "480",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Third Party Cell",
              "identifier": "unique_field_identifier_30",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.thirdParty.email,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "50",
              "y": "524",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Origin Special Instructions",
              "identifier": "unique_field_identifier_31",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.origin.customExtraService,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "50",
              "y": "545",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Destination Special Instructions",
              "identifier": "unique_field_identifier_32",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.destination.customExtraService,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "600",
              "y": "218",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Waybill Number",
              "identifier": "unique_field_identifier_33",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.airWaybillNumber,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "482",
              "y": "328",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Dispatcher Name",
              "identifier": "unique_field_identifier_34",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.dispatcherData.name,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "482",
              "y": "348",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Dispatcher Phone",
              "identifier": "unique_field_identifier_35",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.dispatcherData.cellPhone,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "482",
              "y": "368",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Dispatcher Email",
              "identifier": "unique_field_identifier_36",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.dispatcherData.email,
              "options": [],
              "group": ""
            }, {
              "type": "checkbox",
              "x": "488",
              "y": "526",
              "width": "14",
              "height": "14",
              "page": "1",
              "signer": "1",
              "name": "Freight Charge Terms Prepaid",
              "identifier": "unique_field_identifier_37",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "value": ((this.state.orderData.billingParty == "Shipper") ? 1 : 0),
              "options": [],
              "group": ""
            }, {
              "type": "checkbox",
              "x": "555",
              "y": "526",
              "width": "14",
              "height": "14",
              "page": "1",
              "signer": "1",
              "name": "Freight Charge Terms Collect",
              "identifier": "unique_field_identifier_38",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "value": ((this.state.orderData.billingParty == "Consignee") ? 1 : 0),
              "options": [],
              "group": ""
            }, {
              "type": "checkbox",
              "x": "630",
              "y": "526",
              "width": "14",
              "height": "14",
              "page": "1",
              "signer": "1",
              "name": "Freight Charge Terms 3rd Party",
              "identifier": "unique_field_identifier_39",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "value": ((this.state.orderData.billingParty == "Third Party") ? 1 : 0),
              "options": [],
              "group": ""
            }, {
              "type": "checkbox",
              "x": "445",
              "y": "553",
              "width": "14",
              "height": "14",
              "page": "1",
              "signer": "1",
              "name": "Master bill of lading with attached underlying bills of lading.",
              "identifier": "unique_field_identifier_40",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "value": 0,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "50",
              "y": "630",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 1 Description",
              "identifier": "unique_field_identifier_41",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.items[0].description,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "385",
              "y": "630",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 1 Pieces",
              "identifier": "unique_field_identifier_42",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.items[0].quantity,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "455",
              "y": "630",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 1 Weight",
              "identifier": "unique_field_identifier_43",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.items[0].weight,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "505",
              "y": "630",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 1 Length",
              "identifier": "unique_field_identifier_44",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.items[0].length,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "540",
              "y": "630",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 1 Width",
              "identifier": "unique_field_identifier_45",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.items[0].width,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "580",
              "y": "630",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 1 Height",
              "identifier": "unique_field_identifier_46",
              "required": 1,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.items[0].height,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "620",
              "y": "630",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 1 Additional Shipper Information",
              "identifier": "unique_field_identifier_47",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": this.state.orderData.items[0].class + " " + this.state.orderData.items[0].unNumber + " " + this.state.orderData.items[0].properShippingName,
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "50",
              "y": "660",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 2 Description",
              "identifier": "unique_field_identifier_48",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].description : " "),
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "385",
              "y": "660",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 2 Pieces",
              "identifier": "unique_field_identifier_49",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].quantity : " "),
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "455",
              "y": "660",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 2 Weight",
              "identifier": "unique_field_identifier_50",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].weight : " "),
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "505",
              "y": "660",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 2 Length",
              "identifier": "unique_field_identifier_51",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].length : " "),
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "540",
              "y": "660",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 2 Width",
              "identifier": "unique_field_identifier_52",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].width : " "),
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "580",
              "y": "660",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 2 Height",
              "identifier": "unique_field_identifier_53",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].height : " "),
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "620",
              "y": "660",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Item 2 Additional Shipper Information",
              "identifier": "unique_field_identifier_54",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": (this.state.orderData.items[1] ? (this.state.orderData.items[1].class + " " + this.state.orderData.items[1].unNumber + " " + this.state.orderData.items[1].properShippingName) : " "),
              "options": [],
              "group": ""
            }, {
              "type": "text",
              "x": "720",
              "y": "865",
              "width": "300",
              "height": "17",
              "page": "1",
              "signer": "1",
              "name": "Total Declared Value",
              "identifier": "unique_field_identifier_55",
              "required": 0,
              "readonly": 1,
              "validation_type": "",
              "text_size": "",
              "text_color": "",
              "text_font": "",
              "text_style": "",
              "value": (this.state.orderData.items[1] ? (Number(this.state.orderData.items[0].declaredValue) + Number(this.state.orderData.items[1].declaredValue)) : this.state.orderData.items[0].declaredValue),
              "options": [],
              "group": ""
            },]
          ]
        }
        // "params": {
        //   "withFlightInfoOnly": "false"
        // }
      })
        .then((response) => {
          console.log(response);
          this.setState({
            signingURL: response.data.signers[0].embedded_signing_url,
            signingURL1: response.data.signers[0].embedded_signing_url,
            signingURL2: response.data.signers[1].embedded_signing_url,
            signingURL3: response.data.signers[2].embedded_signing_url,
            signatureURLLoaded: true,
          })
          db.collection("haney-orders").doc(this.props.orderID).set({
            dropOffRateConfirmHash: response.data.document_hash,
          }, { merge: true }).then(() => {
            console.log(response);
            // window.location.replace(this.state.signingURL)
          }, (error) => {
            console.log(error);
          });
        }, (error) => {
          console.log(error);
        });

    }).then(async () => {
      //   console.log("resetting password")
      //  const email = this.state.authInfo.email

      // let subject = `Your Haney Freightways profile has been created!`
      // let html = `<p>Hello,</p>`
      // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
      // html += `<a href="https://haney-freightways-customer.web.app/pages/login-page">Sign In</a>`
      // const emails = [this.state.authInfo.email]
      // const attatchment = true;

      // const emailReturn = await sendEmail({
      //     emails,
      //     subject,
      //     html
      //   }) 

    }).then(() => {
      // window.location.reload()
    })
  }

  assignPic = (files, itemIndex) => {
    const orderData = this.state.orderData;
    orderData.items[itemIndex].files = files;
    this.setState({ orderData: orderData });
  }

  removePicture = (i, j) => {
    this.setState(prevState => {
      const { orderData } = prevState;
      orderData.items[i].files.splice(j, 1);
      return ({
        orderData: orderData
      });
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const axios = require('axios');

    const main = async () => {

      this.setState({ documentsLoading: true })

      const documentRef = db.collection('haney-orders').doc(this.props.orderID);
      await documentRef.set({
        flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
        flight: this.state.flight ? this.state.flight : (this.state.orderData.flight ? this.state.orderData.flight : null),
        originAirlineDetails: this.state.originAirlineDetails ? this.state.originAirlineDetails : null,
        originAirport: this.state.originAirport ? this.state.originAirport : null,
        originAirCarrier: this.state.originAirCarrier ? this.state.originAirCarrier : null,
        destinationAirlineDetails: this.state.destinationAirlineDetails ? this.state.destinationAirlineDetails : null,
        destinationAirCarrier: this.state.destinationAirCarrier ? this.state.destinationAirCarrier : null,
        destinationAirport: this.state.destinationAirport ? this.state.destinationAirport : null,
        driverPickUp: this.state.driverPickUp ? this.state.driverPickUp : null,
        pickUpDriver: this.state.pickUpDriver ? this.state.pickUpDriver : null,
        dropOffDriver: this.state.dropOffDriver ? this.state.dropOffDriver : null,
        driverPickUpName: this.state.pickUpDriverName ? this.state.pickUpDriverName : null,
        driverPickUpEmail: this.state.pickUpDriverEmail ? this.state.pickUpDriverEmail : null,
        driverPickUpID: this.state.pickUpDriverID ? this.state.pickUpDriverID : null,
        vendorPickUp: this.state.vendorPickUp ? this.state.vendorPickUp : null,
        vendorDropOff: this.state.vendorDropOff ? this.state.vendorDropOff : null,
        vendorPickUpName: this.state.vendorPickUp ? this.state.vendorPickUp.name : null,
        vendorPickUpID: this.state.vendorPickUp ? this.state.vendorPickUp.id : null,
        driverDropOff: this.state.dropOffDriver ? this.state.dropOffDriver : null,
        driverDropOffName: this.state.dropOffDriverName ? this.state.dropOffDriverName : null,
        driverDropOffID: this.state.dropOffDriverID ? this.state.dropOffDriverID : null,
        vendorDropOffName: this.state.vendorDropOff ? this.state.vendorDropOff.name : null,
        vendorDropOffID: this.state.vendorDropOff ? this.state.vendorDropOff.id : null,
        pickUpRate: this.state.pickUpRate ? this.state.pickUpRate : null,
        pickUpRateStatus: "unconfirmed",
        dropOffRate: this.state.dropOffRate ? this.state.dropOffRate : null,
        dropOffRateStatus: "unconfirmed",
        status: "Dispatched",
        dispatcherID: this.props.authUser.uid,
        dispatcherEmail: this.props.user.email,
        dispatcherAssigned: new Date(),
        dispatchedAt: new Date(),
        origin: this.state.origin,
        destination: this.state.destination,
        bookingNumber: this.state.bookingNumber ? this.state.bookingNumber : null,
        airWaybillNumber: this.state.airWaybillNumber ? this.state.airWaybillNumber : null,
        serviceLevel: this.state.serviceLevel ? this.state.serviceLevel : null
      }, { merge: true })
        .then(async () => {

          const document = (await documentRef.get());

          const {
            origin, destination, thirdParty, items,
            billingParty, deliveryType, air, freightBillNumber,
            cargoAir, ground, ltl, airWaybillNumber,
            flight, driverPickUpEmail, vendorDropOff, serviceLevel,
            bookingNumber, originAirlineDetails, originAirCarrier,
            destinationAirlineDetails, serviceETA, driverDropOff,
            vendorPickUp, driverPickUp, pickUpDriver, pickUpDriverCell, dropOffDriver, driverDropOffEmail, status
          } = document.data();
          const orderID = document.id;



          const firstDocument = () => {
            return new Promise((resolve, reject) => {
              axios({
                "method": "POST",
                "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
                "data": {
                  "sandbox": 0,
                  "is_draft": 0,
                  "embedded": 1,
                  "title": `Haney Freightways Document ${(deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : "Bill of Lading"}House Waybill #${freightBillNumber}`,
                  "message": "This is my general document message.",
                  "use_signer_order": 0,
                  "reminders": 1,
                  "require_all_signers": 0,
                  "custom_requester_name": "",
                  "custom_requester_email": "",
                  "redirect": "",
                  "redirect_decline": "",
                  "client": "",
                  "expires": 1750513480,
                  "embedded_signing_enabled": 1,
                  "flexible_signing": 0,
                  "use_hidden_tags": 0,
                  "files": [{
                    "name": "House Waybill",
                    "file_url": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FCustomer%20Docs%2FHouse%20Waybill%20Final%20No%20Auto%20Calc%20Weight%206.15.2020.pdf?alt=media&token=1418c8a6-c837-43ac-8a42-b23717638f75" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FCustomer%20Docs%2FHaney Freightways%20Bill%20of%20Lading%20Final%20No%20Auto%20Calc%20Weight%206.16.2020.pdf?alt=media&token=3f3404fa-a892-46ab-bc10-7ccaea831c4d" : null)),
                    "file_id": "",
                    "file_base64": ""
                  }],
                  "signers": [{
                    "id": 1,
                    "name": " ",
                    "email": origin.email ? origin.email : "missingshipper@cargorx.com",
                    "order": 1,
                    // "pin": "3874",
                    "message": "This is my custom message to Shipper.",
                    "deliver_email": 0,
                    "language": "en"
                  }, {
                    "id": 2,
                    // "name": (this.state.driversDropOffData[0].firstName + this.state.driversDropOffData[0].firstName),
                    "name": " ",
                    // "email": (driverPickUpEmail ? driverPickUpEmail : (vendorPickUp.email ? vendorPickUp.email : "vendoralerts@cargorx.com")),
                    "email": "vendoralerts@cargorx.com",
                    "order": 2,
                    // "pin": "3874",
                    "message": "This is my custom message to Driver.",
                    "deliver_email": 0,
                    "language": "en"
                  }, {
                    "id": 3,
                    "name": " ",
                    "email": destination.email ? destination.email : "missingcons@cargorx.com",
                    "order": 3,
                    // "pin": "3874",
                    "message": "This is my custom message to Consignee.",
                    "deliver_email": 0,
                    "language": "en"
                  }],
                  "recipients": [{
                    "name": "Vendor Alerts",
                    "email": "vendoralerts@cargorx.com",
                    "language": "en"
                  }],
                  "meta": {
                    "some_key": "some_value",
                    "another_key": "another_value"
                  },
                  "fields": [
                    [{
                      "type": "signature",
                      "x": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "520" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "530" : "")),
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "930" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "945" : "")),
                      "width": "120",
                      "height": "35",
                      "page": "1",
                      "signer": "1",
                      "name": "",
                      "identifier": "unique_field_identifier_1",
                      "required": 1,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "signature",
                      "x": "50",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "995" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "1015" : "")),
                      "width": "120",
                      "height": "35",
                      "page": "1",
                      "signer": "2",
                      "name": "",
                      "identifier": "unique_field_identifier_2",
                      "required": 1,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "signature",
                      "x": "600",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "1010" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "1030" : "")),
                      "width": "150",
                      "height": "35",
                      "page": "1",
                      "signer": "3",
                      "name": "",
                      "identifier": "unique_field_identifier_3",
                      "required": 1,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "300",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "185" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "100" : "")),
                      "width": "300",
                      "height": "30",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Ready Date/Time",
                      "identifier": "unique_field_identifier_4",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": 14,
                      "text_color": "#FFFFFF",
                      "text_font": "",
                      "text_style": "B",
                      "value": origin.startTimeWindow ? (origin.date ? (moment(origin.date.toDate()).format('YYYY-MM-DD') + " " + origin.startTimeWindow) : " ") : (origin.date ? (moment(origin.date.toDate()).format('YYYY-MM-DD HH:mm')) : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "300",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "290" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "205" : "")),
                      "width": "300",
                      "height": "30",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Needed Date/Time",
                      "identifier": "unique_field_identifier_5",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": 14,
                      "text_color": "#FFFFFF",
                      "text_font": "",
                      "text_style": "B",
                      "value": (deliveryType == "Air" ? (moment(air.quoteETA.toDate()).format('YYYY-MM-DD HH:mm')) : (deliveryType == "Scheduled Air" ? (moment(cargoAir.quoteETA.toDate()).format('YYYY-MM-DD HH:mm')) : (deliveryType == "Ground" ? (moment(ground.quoteETA.toDate()).format('YYYY-MM-DD HH:mm')) : (deliveryType == "Additional Options" ? (moment(ltl.quoteETA.toDate()).format('YYYY-MM-DD HH:mm')) : ("hello"))))),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "150",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "213" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Company Name",
                      "identifier": "unique_field_identifier_6",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.businessName,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "150",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "230" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Address",
                      "identifier": "unique_field_identifier_7",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.address,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "100",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "243" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "158" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin City",
                      "identifier": "unique_field_identifier_8",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.city,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "275",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "243" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "158" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin State",
                      "identifier": "unique_field_identifier_9",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.state,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "360",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "243" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "158" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Zip",
                      "identifier": "unique_field_identifier_10",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.zip,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "140",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "257" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "172" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Contact Name",
                      "identifier": "unique_field_identifier_11",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.firstName + " " + origin.lastName,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "360",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "257" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "172" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Reference No.",
                      "identifier": "unique_field_identifier_12",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.referenceID,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "90",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "272" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "185" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Phone",
                      "identifier": "unique_field_identifier_13",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.phone,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "310",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "272" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "185" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Cell",
                      "identifier": "unique_field_identifier_14",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.email,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "150",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "317" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "230" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination Company Name",
                      "identifier": "unique_field_identifier_15",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.businessName,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "150",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "333" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "248" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination Address",
                      "identifier": "unique_field_identifier_16",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.address,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "100",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "348" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "260" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination City",
                      "identifier": "unique_field_identifier_17",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.city,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "275",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "348" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "260" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination State",
                      "identifier": "unique_field_identifier_18",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.state,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "360",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "348" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "260" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination Zip",
                      "identifier": "unique_field_identifier_19",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.zip,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "140",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "363" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "277" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination Contact Name",
                      "identifier": "unique_field_identifier_20",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.firstName + " " + destination.lastName,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "360",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "363" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "279" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination Reference No.",
                      "identifier": "unique_field_identifier_21",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.referenceID,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "90",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "377" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "290" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination Phone",
                      "identifier": "unique_field_identifier_22",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.phone,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "310",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "377" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "290" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination Cell",
                      "identifier": "unique_field_identifier_23",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.email,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "150",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "421" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "334" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party Company Name",
                      "identifier": "unique_field_identifier_24",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.businessName,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "150",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "437" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "350" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party Address",
                      "identifier": "unique_field_identifier_25",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.address,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "100",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "452" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "365" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party City",
                      "identifier": "unique_field_identifier_26",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.city,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "275",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "452" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "365" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party State",
                      "identifier": "unique_field_identifier_27",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.state,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "360",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "452" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "365" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party Zip",
                      "identifier": "unique_field_identifier_28",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.zip,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "140",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "467" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "380" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party Contact Name",
                      "identifier": "unique_field_identifier_29",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.firstName ? (thirdParty.firstName + " " + thirdParty.lastName) : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "360",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "467" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "380" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party Reference No.",
                      "identifier": "unique_field_identifier_30",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.referenceID,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "90",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "481" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "394" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party Phone",
                      "identifier": "unique_field_identifier_31",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.phone,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "310",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "480" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "393" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Third Party Cell",
                      "identifier": "unique_field_identifier_32",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": thirdParty.email,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "50",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "524" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "435" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Special Instructions",
                      "identifier": "unique_field_identifier_33",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.customExtraService,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "50",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "545" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "458" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Destination Special Instructions",
                      "identifier": "unique_field_identifier_34",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.customExtraService,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "600" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "620" : "")),
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "218" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "108" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Waybill Number",
                      "identifier": "unique_field_identifier_35",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": freightBillNumber,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "482",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "328" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Dispatcher Name",
                      "identifier": "unique_field_identifier_36",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "Kevin Kersting",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "482",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "348" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "163" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Dispatcher Phone",
                      "identifier": "unique_field_identifier_37",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "(303) 947-3066",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "482",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "368" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "183" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Dispatcher Email",
                      "identifier": "unique_field_identifier_38",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "kevin.kersting@cargorx.com",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "checkbox",
                      "x": "488",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "526" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "440" : "")),
                      "width": "14",
                      "height": "14",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Freight Charge Terms Prepaid",
                      "identifier": "unique_field_identifier_39",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "value": ((billingParty == "Shipper") ? 1 : 0),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "checkbox",
                      "x": "555",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "526" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "440" : "")),
                      "width": "14",
                      "height": "14",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Freight Charge Terms Collect",
                      "identifier": "unique_field_identifier_40",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "value": ((billingParty == "Consignee") ? 1 : 0),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "checkbox",
                      "x": "630",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "526" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "440" : "")),
                      "width": "14",
                      "height": "14",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Freight Charge Terms 3rd Party",
                      "identifier": "unique_field_identifier_41",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "value": ((billingParty == "Third Party") ? 1 : 0),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "checkbox",
                      "x": "445",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "553" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "466" : "")),
                      "width": "14",
                      "height": "14",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Master bill of lading with attached underlying bills of lading.",
                      "identifier": "unique_field_identifier_42",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "value": 0,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "50",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "543" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Description",
                      "identifier": "unique_field_identifier_43",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].description,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "385",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "543" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Pieces",
                      "identifier": "unique_field_identifier_44",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].quantity,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "455",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "543" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Weight",
                      "identifier": "unique_field_identifier_45",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].weight,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "505",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "543" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Length",
                      "identifier": "unique_field_identifier_46",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].length,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "540",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "543" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Width",
                      "identifier": "unique_field_identifier_47",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].width,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "580",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "543" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Height",
                      "identifier": "unique_field_identifier_48",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].height,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "620",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "543" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Additional Shipper Information",
                      "identifier": "unique_field_identifier_49",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0] ? items[0].class : " ") + " " + (items[0] ? items[0].unNumber : " ") + " " + (items[0] ? items[0].properShippingName : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "50",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "660" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "573" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 2 Description",
                      "identifier": "unique_field_identifier_50",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].description : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "385",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "660" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "573" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 2 Pieces",
                      "identifier": "unique_field_identifier_51",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].quantity : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "455",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "660" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "573" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 2 Weight",
                      "identifier": "unique_field_identifier_52",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].weight : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "505",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "660" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "573" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 2 Length",
                      "identifier": "unique_field_identifier_53",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].length : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "540",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "660" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "573" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 2 Width",
                      "identifier": "unique_field_identifier_54",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].width : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "580",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "660" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "573" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 2 Height",
                      "identifier": "unique_field_identifier_55",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].height : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "620",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "660" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "573" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 2 Additional Shipper Information",
                      "identifier": "unique_field_identifier_56",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].class : " ") + " " + (items[1] ? items[1].unNumber : " ") + " " + (items[1] ? items[1].properShippingName : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "50",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "603" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Description",
                      "identifier": "unique_field_identifier_57",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].description : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "385",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "603" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Pieces",
                      "identifier": "unique_field_identifier_58",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].quantity : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "455",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "603" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Weight",
                      "identifier": "unique_field_identifier_59",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].weight : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "505",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "603" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Length",
                      "identifier": "unique_field_identifier_60",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].length : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "540",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "603" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Width",
                      "identifier": "unique_field_identifier_61",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].width : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "580",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "603" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Height",
                      "identifier": "unique_field_identifier_62",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].height : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "620",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "603" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Additional Shipper Information",
                      "identifier": "unique_field_identifier_63",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].class : " ") + " " + (items[2] ? items[2].unNumber : " ") + " " + (items[2] ? items[2].properShippingName : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "50",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "630" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Description",
                      "identifier": "unique_field_identifier_64",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].description : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "385",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "630" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Pieces",
                      "identifier": "unique_field_identifier_65",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].quantity : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "455",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "630" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Weight",
                      "identifier": "unique_field_identifier_66",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].weight : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "505",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "630" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Length",
                      "identifier": "unique_field_identifier_67",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].length : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "540",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "630" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Width",
                      "identifier": "unique_field_identifier_68",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].width : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "580",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "630" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Height",
                      "identifier": "unique_field_identifier_69",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].height : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "620",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "630" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "630" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Item 1 Additional Shipper Information",
                      "identifier": "unique_field_identifier_70",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].class : " ") + " " + (items[3] ? items[3].unNumber : " ") + " " + (items[3] ? items[3].properShippingName : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "720" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "320" : "")),
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "865" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "875" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Total Declared Value",
                      "identifier": "unique_field_identifier_71",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      // "value": (items[1] ? (items[2] ? (Number(items[0].declaredValue) + Number(items[1].declaredValue) + Number(items[2].declaredValue)) : (Number(items[0].declaredValue) + Number(items[1].declaredValue))) : items[0].declaredValue),
                      "value": (items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      // "x": (deliveryType == "Air" ? "720" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "330" : "")),
                      // "y": (deliveryType == "Air" ? "865" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "858" : "")),
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "700" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "315" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Name",
                      "identifier": "unique_field_identifier_72",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? vendorPickUp.name : ""),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "385",
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "645" : "815"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Grand Total Pieces",
                      "identifier": "unique_field_identifier_73",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      // "value": (items[1] ? (Number(items[0].quantity) + Number(items[1].quantity)) : items[0].quantity),
                      "value": (items[0] ? Number(items[0].quantity) : 0) + (items[1] ? Number(items[1].quantity) : 0) + (items[2] ? Number(items[2].quantity) : 0) + (items[3] ? Number(items[3].quantity) : 0),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "455",
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "645" : "815"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Grand Total Weight",
                      "identifier": "unique_field_identifier_74",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      // "value": (items[1] ? (Number(items[0].weight) + Number(items[1].weight)) : items[0].weight),
                      "value": (items[0] ? Number(items[0].weight) : 0) + (items[1] ? Number(items[1].weight) : 0) + (items[2] ? Number(items[2].weight) : 0) + (items[3] ? Number(items[3].weight) : 0),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "53" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "760" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Handling Unit",
                      "identifier": "unique_field_identifier_75",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0] ? items[0].quantity : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "290" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "760" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Weight",
                      "identifier": "unique_field_identifier_76",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0] ? items[0].weight : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "345" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "760" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info HM UN",
                      "identifier": "unique_field_identifier_77",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0] ? items[0].unNumber : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "400" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "760" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Description",
                      "identifier": "unique_field_identifier_78",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0] ? items[0].description : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "795" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "760" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Class",
                      "identifier": "unique_field_identifier_79",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0] ? items[0].class : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "53" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "780" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Handling Unit",
                      "identifier": "unique_field_identifier_80",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].quantity : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "290" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "780" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Weight",
                      "identifier": "unique_field_identifier_81",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].weight : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "345" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "780" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info HM UN",
                      "identifier": "unique_field_identifier_82",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].unNumber : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "400" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "780" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Description",
                      "identifier": "unique_field_identifier_83",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].description : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "795" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "780" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Class",
                      "identifier": "unique_field_identifier_84",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? items[1].class : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "53" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "810" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Handling Unit",
                      "identifier": "unique_field_identifier_85",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].quantity : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "290" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "810" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Weight",
                      "identifier": "unique_field_identifier_86",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].weight : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "345" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "810" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info HM UN",
                      "identifier": "unique_field_identifier_87",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].unNumber : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "400" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "810" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Description",
                      "identifier": "unique_field_identifier_88",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].description : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "795" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "810" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Class",
                      "identifier": "unique_field_identifier_89",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[2] ? items[2].class : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "53" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "835" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Handling Unit",
                      "identifier": "unique_field_identifier_90",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].quantity : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "290" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "835" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Weight",
                      "identifier": "unique_field_identifier_91",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].weight : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "345" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "835" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info HM UN",
                      "identifier": "unique_field_identifier_92",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].unNumber : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "400" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "835" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Description",
                      "identifier": "unique_field_identifier_93",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].description : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "795" : "0"),
                      "y": ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "835" : "0"),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Info Class",
                      "identifier": "unique_field_identifier_94",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[3] ? items[3].class : " "),
                      "options": [],
                      "group": ""
                    }]
                  ]
                }
                // "params": {
                //   "withFlightInfoOnly": "false"
                // }
              })
                .then((response) => {
                  this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
                  resolve(response);
                })
                .catch((err) => {
                  console.log(err)
                  reject(err)
                })
            })
          }

          const secondDocument = () => {
            return new Promise((resolve, reject) => {
              axios({
                "method": "POST",
                "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
                "data": {
                  "sandbox": 0,
                  "is_draft": 0,
                  "embedded": 1,
                  "title": `Haney Freightways Sample Universal Waybill #${freightBillNumber}`,
                  "message": "This is my general document message.",
                  "use_signer_order": 0,
                  "reminders": 1,
                  "require_all_signers": 0,
                  "custom_requester_name": "",
                  "custom_requester_email": "",
                  "redirect": "",
                  "redirect_decline": "",
                  "client": "",
                  "expires": 1750513480,
                  "embedded_signing_enabled": 1,
                  "flexible_signing": 0,
                  "use_hidden_tags": 0,
                  "files": [{
                    "name": "House Waybill",
                    "file_url": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FSample%20Universal%20Air%20Waybill%20Clean%206.22.2020.pdf?alt=media&token=827f1f4d-d012-4e52-9077-a8a2a9b89942" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FCustomer%20Docs%2FHaney Freightways%20Bill%20of%20Lading%20Final%20No%20Auto%20Calc%20Weight%206.16.2020.pdf?alt=media&token=3f3404fa-a892-46ab-bc10-7ccaea831c4d" : null)),
                    "file_id": "",
                    "file_base64": ""
                  }],
                  "signers": [{
                    "id": 1,
                    "name": "Shipper Signer",
                    "email": (driverPickUpEmail ? driverPickUpEmail : "just@pon.com"),
                    "order": 1,
                    // "pin": "3874",
                    "message": "This is my custom message to Shipper.",
                    "deliver_email": 0,
                    "language": "en"
                  }],
                  "recipients": [{
                    "name": "Vendor Alerts",
                    "email": "vendoralerts@cargorx.com",
                    "language": "en"
                  }],
                  "meta": {
                    "some_key": "some_value",
                    "another_key": "another_value"
                  },
                  "fields": [
                    [{
                      "type": "signature",
                      "x": "520",
                      "y": "930",
                      "width": "120",
                      "height": "35",
                      "page": "1",
                      "signer": "1",
                      "name": "",
                      "identifier": "unique_field_identifier_1",
                      "required": 1,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "55",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "35" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "120" : "")),
                      "width": "300",
                      "height": "30",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Shipper Name",
                      "identifier": "unique_field_identifier_2",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "#000000",
                      "text_font": "",
                      "text_style": "",
                      "value": "Haney Freightways, LLC",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "55",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "48" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "235" : "")),
                      "width": "300",
                      "height": "30",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Shipper Address",
                      "identifier": "unique_field_identifier_3",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "#000000",
                      "text_font": "",
                      "text_style": "",
                      "value": "16600 E 33rd Dr, Unit 10",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "55",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "70" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Shipper Phone Number",
                      "identifier": "unique_field_identifier_4",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "Aurora, CO 80011 833-227-4679",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "55",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "127" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Co- Signee Name",
                      "identifier": "unique_field_identifier_5",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "'HOLD FOR PICK UP' - " + (flight ? flight.movement.airport.iata : " "),
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "60",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "140" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "CO-Signee Address",
                      "identifier": "unique_field_identifier_6",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorDropOff ? vendorDropOff.name : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "60",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "153" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Origin Address",
                      "identifier": "unique_field_identifier_7",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorDropOff ? vendorDropOff.phone : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "315",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "180" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "302",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Vendor Name",
                      "identifier": "unique_field_identifier_8",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "font_weight": "600",
                      "value": "'PREAPID BY SHIPPER'",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "315",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "200" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Service Level",
                      "identifier": "unique_field_identifier_9",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "Service Level: " + (serviceLevel ? serviceLevel.toUpperCase() : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "85",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "255" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Airport departure",
                      "identifier": "unique_field_identifier_10",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": flight ? flight.originAirport.substr(1) : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "325",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "255" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "references Number",
                      "identifier": "unique_field_identifier_11",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "#" + freightBillNumber,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "85",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "275" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Code ID",
                      "identifier": "unique_field_identifier_12",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": flight ? (flight.number ? (flight.number.substring(0, flight.number.lastIndexOf(" "))) : " ") : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "415",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "280" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Carrier Code",
                      "identifier": "unique_field_identifier_13",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].declaredValue,
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "95",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "300" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Airport Code",
                      "identifier": "unique_field_identifier_14",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": flight ? flight.movement.airport.iata : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "185",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "305" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Flight/Date",
                      "identifier": "unique_field_identifier_15",
                      "validation_type": "",
                      "text_size": "14px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": flight ? flight.number : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "185",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "320" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Flight/Date",
                      "identifier": "unique_field_identifier_16",
                      "validation_type": "",
                      "text_size": "14px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": moment(destination.deliverBy).format("MM/DD/YY"),
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "320",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "305" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "flight/Date",
                      "identifier": "unique_field_identifier_17",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].declaredValue,
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "250",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "305" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Flight/Date",
                      "identifier": "unique_field_identifier_18",
                      "validation_type": "",
                      "text_size": "14px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": flight ? flight.number : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "250",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "320" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Flight/Date",
                      "identifier": "unique_field_identifier_19",
                      "validation_type": "",
                      "text_size": "14px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": moment(destination.deliverBy).format("MM/DD/YY"),
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "140",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "335" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "143" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Booking Number",
                      "identifier": "unique_field_identifier_20",
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "Booking Number:" + " " + bookingNumber,
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "450",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "60" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Frieght Company Name",
                      "identifier": "unique_field_identifier_21",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": flight ? (flight.airline ? flight.airline.name : " ") : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "430",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "405" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "items",
                      "identifier": "unique_field_identifier_22",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items,
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "150",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "15" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Air Waybill Number",
                      "identifier": "unique_field_identifier_23",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": airWaybillNumber,
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "190",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "40" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Haney Freightways Account Number",
                      "identifier": "unique_field_identifier_24",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (originAirlineDetails[0] ? (originAirlineDetails[0].cargorxAccountNumber ? originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ",
                      "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].cargorxAccountNumber ? originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ") : (deliveryType == "Scheduled Air" ? (originAirCarrier.cargorxAccountNumber ? originAirCarrier.cargorxAccountNumber : " ") : " "),
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "430",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "400" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Freight description",
                      "identifier": "unique_field_identifier_25",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].description,
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "430",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "420" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Freight description",
                      "identifier": "unique_field_identifier_26",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? items[1].description : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "430",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "440" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Freight description",
                      "identifier": "unique_field_identifier_27",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? items[2].description : " ",
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "60",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "400" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Freight description",
                      "identifier": "unique_field_identifier_28",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? (items[2] ? (Number(items[0].quantity) + Number(items[1].quantity) + Number(items[2].quantity)) : (Number(items[0].quantity) + Number(items[1].quantity))) : items[0].quantity),
                      "options": [],
                      "group": ""
                    },
                    {
                      "type": "text",
                      "x": "100",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "400" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "OWNER",
                      "name": "Freight description",
                      "identifier": "unique_field_identifier_29",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "22px",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[1] ? (items[2] ? (Number(items[0].weight) + Number(items[1].weight) + Number(items[2].weight)) : (Number(items[0].weight) + Number(items[1].weight))) : items[0].weight),
                      "options": [],
                      "group": ""
                    }

                    ]
                  ]
                }
                // "params": {
                //   "withFlightInfoOnly": "false"
                // }
              })
                .then((response) => {
                  this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
                  resolve(response)
                })
                .catch((err) => {
                  console.log(err)
                  reject(err);
                })
            })
          }

          const thirdDocument = () => {
            return new Promise((resolve, reject) => {
              axios({
                "method": "POST",
                "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
                "data": {
                  "sandbox": 0,
                  "is_draft": 0,
                  "embedded": 1,
                  "title": `Haney Freightways Alert #${freightBillNumber}`,
                  "message": "This is my general document message.",
                  "use_signer_order": 0,
                  "reminders": 1,
                  "require_all_signers": 0,
                  "custom_requester_name": "",
                  "custom_requester_email": "",
                  "redirect": "",
                  "redirect_decline": "",
                  "client": "",
                  "expires": 1750513480,
                  "embedded_signing_enabled": 1,
                  "flexible_signing": 0,
                  "use_hidden_tags": 0,
                  "files": [{
                    "name": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "Air Pick Up Rate Confirmation" : "Ground Only Rate Confirmation",
                    "file_url": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FDelivery%20Vendor%20Driver%20Docs%2FPick-Up%20Dispatch%20_%20Rate%20Confirmation%20(Airline%20to%20Destination)%20Final%203.20.2020%20(1).pdf?alt=media&token=3ee1290f-a191-4cb4-bcce-501e7af2d171" : "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FVendor%20Driver%20Docs%2FGround%20Only%20Dispatch%20(Origin%20to%20Destination)%20Final%203.20.2020.pdf?alt=media&token=2da3c1da-541e-471b-bd6b-bb3d5c91c8a6",
                    "file_id": "",
                    "file_base64": ""
                  }],
                  "signers": [{
                    "id": 1,
                    "name": "Pick Up Driver",
                    "email": "justin@pondata.com",
                    "order": 1,
                    // "pin": "3874",
                    "message": "This is my custom message to Signer.",
                    "deliver_email": "",
                    "language": "en"
                  }],
                  "recipients": [{
                    "name": "Vendor Alerts",
                    "email": "vendoralerts@cargorx.com",
                    "language": "en"
                  }],
                  "meta": {
                    "some_key": "some_value",
                    "another_key": "another_value"
                  },
                  "fields": [
                    [{
                      "type": "text",
                      "x": "120",
                      "y": "225",
                      "width": "100",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Name",
                      "identifier": "unique_field_identifier_6",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "Kevin Kersting",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "120",
                      "y": "245",
                      "width": "100",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Phone",
                      "identifier": "unique_field_identifier_7",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "(303) 947-3066",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "120",
                      "y": "268",
                      "width": "150",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Email",
                      "identifier": "unique_field_identifier_8",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "kevin.kersting@cargorx.com",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "190",
                      "y": "297",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Ready Date/Time",
                      "identifier": "unique_field_identifier_9",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": moment(destination.deliverBy).format("MM/DD/YYYY HH:mm"),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "650",
                      "y": "225",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Waybill Number",
                      "identifier": "unique_field_identifier_10",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": freightBillNumber,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "672",
                      "y": "295",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Delivery Date/Time",
                      "identifier": "unique_field_identifier_11",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": moment(serviceETA.toDate()).format("MM/DD/YYYY HH:mm"),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "180",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "555" : "545",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Carrier Total Charges",
                      "identifier": "unique_field_identifier_12",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "130",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "405" : "395",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Carrier Name",
                      "identifier": "unique_field_identifier_13",
                      "required": 1,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorDropOff ? vendorDropOff.name : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "170",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "430" : "420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Carrier Pro Number",
                      "identifier": "unique_field_identifier_14",
                      "required": 0,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "115",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "450" : "440",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "phone",
                      "identifier": "unique_field_identifier_15",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorDropOff ? vendorDropOff.phone : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "115",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "470" : "460",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Email",
                      "identifier": "unique_field_identifier_16",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorDropOff ? vendorDropOff.email : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "180",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "493" : "483",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "DOT Number",
                      "identifier": "unique_field_identifier_17",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorDropOff ? vendorDropOff.dotNumber : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "180",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "515" : "505",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Contact Name",
                      "identifier": "unique_field_identifier_18",
                      "required": 0,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "225",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "537" : "527",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Pick-up Service Level",
                      "identifier": "unique_field_identifier_19",
                      "required": 0,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "175",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "600" : "590",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Print Name",
                      "identifier": "unique_field_identifier_20",
                      "required": 1,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "100",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "622" : "612",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Date",
                      "identifier": "unique_field_identifier_21",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": String(new Date()),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "510",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "407" : "397",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_22",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": driverDropOff ? driverDropOff.name : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "430" : "420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Phone",
                      "identifier": "unique_field_identifier_23",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": driverDropOff ? (driverDropOff.cellPhone ? driverDropOff.cellPhone : driverDropOff.directPhone) : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "452" : "442",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Email",
                      "identifier": "unique_field_identifier_24",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": driverDropOff ? driverDropOff.email : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "682",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Company Name",
                      "identifier": "unique_field_identifier_25",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": flight ? flight.movement.airport.icao : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "125",
                      "y": "705",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Address",
                      "identifier": "unique_field_identifier_26",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalAddress : " ") : " ",
                      "value": (deliveryType == "Air") ? (destinationAirlineDetails ? (destinationAirlineDetails[0] ? (destinationAirlineDetails[0].physicalAddress ? destinationAirlineDetails[0].physicalAddress : " ") : " ") : " ") : (deliveryType == "Scheduled Air" ? this.state.destinationAirCarrier.address : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "110",
                      "y": "728",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "City",
                      "identifier": "unique_field_identifier_27",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (deliveryType == "Air") ? (destinationAirlineDetails ? (destinationAirlineDetails[0] ? (destinationAirlineDetails[0].physicalCity ? destinationAirlineDetails[0].physicalCity : " ") : " ") : " ") : (deliveryType == "Scheduled Air" ? this.state.destinationAirCarrier.city : " "),
                      // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalCity : " ") : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "251",
                      "y": "728",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "State",
                      "identifier": "unique_field_identifier_28",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalState : " ") : " ",
                      "value": (deliveryType == "Air") ? (destinationAirlineDetails ? (destinationAirlineDetails[0] ? (destinationAirlineDetails[0].physicalState ? destinationAirlineDetails[0].physicalState : " ") : " ") : " ") : (deliveryType == "Scheduled Air" ? this.state.destinationAirCarrier.state : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "360",
                      "y": "728",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Zip",
                      "identifier": "unique_field_identifier_29",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (deliveryType == "Air") ? (destinationAirlineDetails ? (destinationAirlineDetails[0] ? (destinationAirlineDetails[0].physicalZip ? destinationAirlineDetails[0].physicalZip : " ") : " ") : " ") : (deliveryType == "Scheduled Air" ? this.state.destinationAirCarrier.zip : " "),
                      // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalZip : " ") : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "750",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Contact name",
                      "identifier": "unique_field_identifier_30",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "770",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Contact Phone",
                      "identifier": "unique_field_identifier_31",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "790",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Contact Email",
                      "identifier": "unique_field_identifier_32",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "255",
                      "y": "812",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_33",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "255",
                      "y": "836",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_34",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "255",
                      "y": "855",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_35",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "245",
                      "y": "880",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_36",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "605",
                      "y": "682",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_37",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.businessName,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "585",
                      "y": "702",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Delivery Address",
                      "identifier": "unique_field_identifier_38",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.address,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "510",
                      "y": "725",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Delivery City",
                      "identifier": "unique_field_identifier_39",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.city,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "760",
                      "y": "725",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Delivery Zip",
                      "identifier": "unique_field_identifier_40",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.zip,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "655",
                      "y": "725",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Delivery State",
                      "identifier": "unique_field_identifier_41",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.state,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "585",
                      "y": "750",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Destination Contact Name",
                      "identifier": "unique_field_identifier_42",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.firstName + " " + destination.firstName,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "585",
                      "y": "772",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Destination Contact Phone",
                      "identifier": "unique_field_identifier_43",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.phone,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "585",
                      "y": "792",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Destination Contact Email",
                      "identifier": "unique_field_identifier_44",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.email,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "660",
                      "y": "815",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Secondary Contact Name",
                      "identifier": "unique_field_identifier_45",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "660",
                      "y": "835",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Secondary Contact Phone",
                      "identifier": "unique_field_identifier_46",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "660",
                      "y": "855",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Secondary Contact Email",
                      "identifier": "unique_field_identifier_47",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "645",
                      "y": "877",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_48",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.referenceID ? destination.referenceID : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "575",
                      "y": "940",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_49",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.customExtraService ? destination.customExtraService : "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "575",
                      "y": "965",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_50",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "205",
                      "y": "940",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_51",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.customExtraService ? origin.customExtraService : "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "205",
                      "y": "965",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_52",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "70",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_53",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].quantity,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "965",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_54",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "70",
                      "y": "1400",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_55",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "70",
                      "y": "1420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_56",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "200",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_57",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].description,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "200",
                      "y": "1400",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_58",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "200",
                      "y": "1420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_59",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "355",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_60",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].weight,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "355",
                      "y": "1400",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_61",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "355",
                      "y": "1420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_62",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "430",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_63",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].length,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "430",
                      "y": "1400",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_64",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "430",
                      "y": "1420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_65",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_66",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].width,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": "1400",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_67",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": "1420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_68",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "590",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_69",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].height,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "590",
                      "y": "1400",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_70",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "590",
                      "y": "1420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_71",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "680",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_72",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0].unNumber ? items[0].unNumber : "N/A"),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "680",
                      "y": "1400",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_73",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "680",
                      "y": "1420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_74",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "770",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Hazmat",
                      "identifier": "unique_field_identifier_75",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0].isHazmat ? "Yes" : "No"),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "770",
                      "y": "1400",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_76",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "770",
                      "y": "1420",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_77",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }]
                  ]
                }
                // "params": {
                //   "withFlightInfoOnly": "false"
                // }
              })
                .then(response => {
                  this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
                  resolve(response);
                })
                .catch(err => {
                  console.log(err);
                  reject(err);
                })
            })
          }

          const fourthDocument = () => {
            return new Promise((resolve, reject) => {
              axios({
                "method": "POST",
                "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
                "data": {
                  "sandbox": 0,
                  "is_draft": 0,
                  "embedded": 1,
                  "title": `Haney Freightways Alert #${freightBillNumber}`,
                  "message": "This is my general document message.",
                  "use_signer_order": 0,
                  "reminders": 0,
                  "require_all_signers": 0,
                  "custom_requester_name": "",
                  "custom_requester_email": "",
                  "redirect": "",
                  "redirect_decline": "",
                  "client": "",
                  "expires": 1750513480,
                  "embedded_signing_enabled": 1,
                  "flexible_signing": 0,
                  "use_hidden_tags": 0,
                  "files": [{
                    "name": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "Air Pick Up Rate Confirmation" : "Ground Only Rate Confirmation",
                    "file_url": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FUNKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FUNKNOWN%20Shipper%20Air%20Pick%20Up%20(Origin%20to%20Airport)%203.20.2020.pdf?alt=media&token=79eccfb3-5b37-4efc-b7cd-93ec21b206de" : "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FVendor%20Driver%20Docs%2FGround%20Only%20Dispatch%20(Origin%20to%20Destination)%20Final%203.20.2020.pdf?alt=media&token=2da3c1da-541e-471b-bd6b-bb3d5c91c8a6",
                    "file_id": "",
                    "file_base64": ""
                  }],
                  "signers": [{
                    "id": 1,
                    "name": " ",
                    "email": vendorPickUp.email ? vendorPickUp.email : "vendoralerts@cargorx.com",
                    "order": 1,
                    // "pin": "3874",
                    "message": "This is my custom message to Signer.",
                    "deliver_email": "",
                    "language": "en"
                  }],
                  "recipients": [{
                    "name": "Vendor Alerts",
                    "email": "vendoralerts@cargorx.com",
                    "language": "en"
                  }],
                  "meta": {
                    "some_key": "some_value",
                    "another_key": "another_value"
                  },
                  "fields": [
                    [{
                      "type": "text",
                      "x": "120",
                      "y": "225",
                      "width": "100",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Name",
                      "identifier": "unique_field_identifier_6",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "Kevin Kersting",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "120",
                      "y": "245",
                      "width": "100",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Phone",
                      "identifier": "unique_field_identifier_7",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "(303) 947-3066",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "120",
                      "y": "268",
                      "width": "150",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Email",
                      "identifier": "unique_field_identifier_8",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "kevin.kersting@cargorx.com",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "190",
                      "y": "297",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Ready Date/Time",
                      "identifier": "unique_field_identifier_9",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (origin.endTimeWindow == null) ? String(origin.date ? moment(origin.date.toDate()).format('MM-DD-YYYY HH:mm') : " ") : (origin.date ? String(moment(origin.date.toDate()).format('MM-DD-YYYY')) + " " + (origin.startTimeWindow && String(origin.startTimeWindow)) : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "650",
                      "y": "225",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Waybill Number",
                      "identifier": "unique_field_identifier_10",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": this.state.orderData ? freightBillNumber : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "672",
                      "y": "295",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Haney Freightways Contact Delivery Date/Time",
                      "identifier": "unique_field_identifier_11",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? String(moment(origin.deliverBy).format('MM-DD-YYYY HH:mm')) : moment(this.state.orderData.serviceETA.toDate()).format('MM-DD-YYYY HH:mm'),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "180",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "555" : "545",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Carrier Total Charges",
                      "identifier": "unique_field_identifier_12",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "130",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "405" : "405",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Carrier Name",
                      "identifier": "unique_field_identifier_13",
                      "required": 1,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorPickUp.name ? vendorPickUp.name : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "170",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "430" : "430",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Carrier Pro Number",
                      "identifier": "unique_field_identifier_14",
                      "required": 0,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "115",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "450" : "450",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "phone",
                      "identifier": "unique_field_identifier_15",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorPickUp.phone ? vendorPickUp.phone : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "115",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "470" : "470",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Email",
                      "identifier": "unique_field_identifier_16",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorPickUp.email ? vendorPickUp.email : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "180",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "493" : "493",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "DOT Number",
                      "identifier": "unique_field_identifier_17",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": vendorPickUp.dotNumber ? vendorPickUp.dotNumber : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "180",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "515" : "515",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Contact Name",
                      "identifier": "unique_field_identifier_18",
                      "required": 0,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "225",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "537" : "537",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Pick-up Service Level",
                      "identifier": "unique_field_identifier_19",
                      "required": 0,
                      "readonly": 0,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": "",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "510",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "407" : "407",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_22",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": driverPickUp ? driverPickUp.name : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "430" : "430",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Phone",
                      "identifier": "unique_field_identifier_23",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": driverPickUp ? (driverPickUp.cellPhone ? driverPickUp.cellPhone : driverPickUp.directPhone) : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "452" : "452",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Email",
                      "identifier": "unique_field_identifier_24",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": driverPickUp ? driverPickUp.email : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "535" : "515",
                      "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "474" : "474",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Email",
                      "identifier": "unique_field_identifier_78",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": driverPickUp ? (driverPickUp.sta && ('STA: ' + driverPickUp.sta)) : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "672",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Company Name",
                      "identifier": "unique_field_identifier_25",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.businessName,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "125",
                      "y": "695",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Address",
                      "identifier": "unique_field_identifier_26",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.address,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "110",
                      "y": "718",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "City",
                      "identifier": "unique_field_identifier_27",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.city,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "251",
                      "y": "718",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "State",
                      "identifier": "unique_field_identifier_28",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.state,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "360",
                      "y": "718",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Zip",
                      "identifier": "unique_field_identifier_29",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.zip,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "740",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Contact name",
                      "identifier": "unique_field_identifier_30",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (origin.firstName ? origin.firstName : " ") + " " + (origin.lastName ? origin.lastName : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "760",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Contact Phone",
                      "identifier": "unique_field_identifier_31",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.phone ? origin.phone : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "780",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Contact Email",
                      "identifier": "unique_field_identifier_32",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.email ? origin.email : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "255",
                      "y": "802",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_33",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "255",
                      "y": "826",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_34",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "255",
                      "y": "845",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_35",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "245",
                      "y": "870",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_36",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.referenceID ? origin.referenceID : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "605",
                      "y": "870",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_81",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.referenceID ? destination.referenceID : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "605",
                      "y": "672",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_37",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Air") ? ((flight ? (flight.airline && flight.airline.name) : " ") + " " + (flight ? flight.originAirport : " ")) : (deliveryType == "Scheduled Air" ? (originAirCarrier.businessName + originAirCarrier.airCode) : destination.businessName)),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "585",
                      "y": "692",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Delivery Address",
                      "identifier": "unique_field_identifier_38",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].physicalAddress ? originAirlineDetails[0].physicalAddress : " ") : " ") : " ") : ((deliveryType == "Scheduled Air") ? originAirCarrier.address : destination.address),
                      // "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].cargorxAccountNumber ? originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ") : (deliveryType == "Scheduled Air" ? originAirCarrier.cargorxAccountNumber : " "),
                      // "value": ((deliveryType == "Air") ? (deliveryType == "Scheduled Air" ? (originAirCarrier.address) : originAirlineDetails[0].physicalAddress) : destination.address),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "510",
                      "y": "715",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Delivery City",
                      "identifier": "unique_field_identifier_39",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Air") ? (deliveryType == "Scheduled Air" ? (originAirCarrier.city) : destination.city) : destination.city),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "760",
                      "y": "715",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Delivery Zip",
                      "identifier": "unique_field_identifier_40",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Air") ? (deliveryType == "Scheduled Air" ? (originAirCarrier.zip) : destination.zip) : destination.zip),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "655",
                      "y": "715",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Delivery State",
                      "identifier": "unique_field_identifier_41",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Air") ? (deliveryType == "Scheduled Air" ? (originAirCarrier.state) : destination.state) : destination.state),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "585",
                      "y": "740",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Destination Contact Name",
                      "identifier": "unique_field_identifier_42",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : (destination.firstName + " " + destination.firstName)),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "585",
                      "y": "762",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Destination Contact Phone",
                      "identifier": "unique_field_identifier_43",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : destination.phone),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "585",
                      "y": "782",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Destination Contact Email",
                      "identifier": "unique_field_identifier_44",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : destination.email),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "660",
                      "y": "805",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Secondary Contact Name",
                      "identifier": "unique_field_identifier_45",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "660",
                      "y": "825",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Secondary Contact Phone",
                      "identifier": "unique_field_identifier_46",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "660",
                      "y": "845",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Secondary Contact Email",
                      "identifier": "unique_field_identifier_47",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "645",
                      "y": "867",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_48",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "575",
                      "y": "930",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_49",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": destination.customExtraService ? destination.customExtraService : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "575",
                      "y": "955",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_50",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "205",
                      "y": "930",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_51",
                      "required": 0,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": origin.customExtraService ? origin.customExtraService : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "205",
                      "y": "955",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_52",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "70",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_53",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].quantity,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "185",
                      "y": "955",
                      "width": "300",
                      "height": "17",
                      "page": "1",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_54",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "70",
                      "y": "256",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_55",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? items[1].quantity : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "70",
                      "y": "276",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_56",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? items[2].quantity : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "70",
                      "y": "296",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_156",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[3] ? items[3].quantity : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "200",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_57",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].description,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "200",
                      "y": "256",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_58",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? items[1].description : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "200",
                      "y": "276",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_59",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? items[2].description : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "200",
                      "y": "296",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_159",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[3] ? items[3].description : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "355",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_60",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].weight,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "355",
                      "y": "256",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_61",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? items[1].weight : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "355",
                      "y": "276",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_62",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? items[2].weight : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "355",
                      "y": "296",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_162",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[3] ? items[3].weight : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "430",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_63",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].length,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "430",
                      "y": "256",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_64",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? items[1].length : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "430",
                      "y": "276",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_65",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? items[2].length : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "430",
                      "y": "296",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_165",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[3] ? items[3].length : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_66",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].width,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": "256",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_67",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? items[1].width : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": "276",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_68",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? items[2].width : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "515",
                      "y": "296",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_168",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[3] ? items[3].width : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "590",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_69",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[0].height,
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "590",
                      "y": "256",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_70",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? items[1].height : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "590",
                      "y": "276",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_71",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? items[2].height : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "590",
                      "y": "296",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_171",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[3] ? items[3].height : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "680",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_72",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0].unNumber ? items[0].unNumber : " "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "680",
                      "y": "256",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_73",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? (items[1].unNumber ? items[1].unNumber : " ") : (" "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "680",
                      "y": "276",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_74",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? (items[2].unNumber ? items[2].unNumber : " ") : (" "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "680",
                      "y": "296",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_174",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[3] ? (items[3].unNumber ? items[3].unNumber : " ") : (" "),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "770",
                      "y": "236",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Hazmat",
                      "identifier": "unique_field_identifier_75",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (items[0].isHazmat ? "Yes" : "No"),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "770",
                      "y": "256",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_76",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[1] ? (items[1].isHazmat ? "Yes" : "No") : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "770",
                      "y": "276",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_77",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[2] ? (items[2].isHazmat ? "Yes" : "No") : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "770",
                      "y": "296",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Driver name",
                      "identifier": "unique_field_identifier_177",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": items[3] ? (items[3].isHazmat ? "Yes" : "No") : " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "145",
                      "y": "600",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "total declared value",
                      "identifier": "unique_field_identifier_80",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
                      "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? " " : (items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0),
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "160",
                      "y": "575",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "driver print name",
                      "identifier": "unique_field_identifier_84",
                      "required": 1,
                      "readonly": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? 0 : 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
                      "value": " ",
                      "options": [],
                      "group": ""
                    }, {
                      "type": "text",
                      "x": "85",
                      "y": "592",
                      "width": "300",
                      "height": "17",
                      "page": "2",
                      "signer": "1",
                      "name": "Date",
                      "identifier": "unique_field_identifier_83",
                      "required": 1,
                      "readonly": 1,
                      "validation_type": "",
                      "text_size": "",
                      "text_color": "",
                      "text_font": "",
                      "text_style": "",
                      "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? String(new Date()) : " ",
                      "options": [],
                      "group": ""
                    }]
                  ]
                }
                // "params": {
                //   "withFlightInfoOnly": "false"
                // }
              })
                .then(response => {
                  this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
                  resolve(response)
                })
                .catch(err => {
                  console.log(err);
                  reject(err);
                })
            })
          }

          const fifthDocument = () => {
            return new Promise((resolve, reject) => {
              axios({
                "method": "POST",
                "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
                "data": {
                  "sandbox": 0,
                  "is_draft": 0,
                  "embedded": 1,
                  "title": `Haney Freightways Alert #${freightBillNumber}`,
                  "message": "This is my general document message.",
                  "use_signer_order": 0,
                  "reminders": 0,
                  "require_all_signers": 0,
                  "custom_requester_name": "",
                  "custom_requester_email": "",
                  "redirect": "",
                  "redirect_decline": "",
                  "client": "",
                  "expires": 1750513480,
                  "embedded_signing_enabled": 1,
                  "flexible_signing": 0,
                  "use_hidden_tags": 0,
                  "files": [{
                    "name": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "Air Pick Up Rate Confirmation" : "Ground Only Rate Confirmation",
                    "file_url": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIdentification%20Validation%20Form%206.20.2020.pdf?alt=media&token=a3a9a0cc-b514-4865-a284-ce63ae5477fa" : "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIdentification%20Validation%20Form%206.20.2020.pdf?alt=media&token=a3a9a0cc-b514-4865-a284-ce63ae5477fa",
                    "file_id": "",
                    "file_base64": ""
                  }],
                  "signers": [{
                    "id": 1,
                    "name": "Pick Up Driver",
                    "email": "justin@pondata.co",
                    "order": 1,
                    // "pin": "3874",
                    "message": "This is my custom message to Signer.",
                    "deliver_email": "",
                    "language": "en"
                  }],
                  "recipients": [{
                    "name": "Vendor Alerts",
                    "email": "vendoralerts@cargorx.com",
                    "language": "en"
                  }],
                  "meta": {
                    "some_key": "some_value",
                    "another_key": "another_value"
                  },
                  "fields": [
                    [
                      //   {
                      //   "type": "dropdown",
                      //   "x": "500",
                      //   "y": "225",
                      //   "width": "55",
                      //   "height": "17",
                      //   "page": "1",
                      //   "signer": "OWNER",
                      //   "name": "ID TYPE",
                      //   "identifier": "unique_field_identifier_1",
                      //   "required": 1,
                      //   "readonly": 0,
                      //   "text_size": 16,
                      //   "text_color": "#FF0000",
                      //   "text_font": "arial",
                      //   "text_style": "BUI",
                      //   "validation_type": "",
                      //   "value": " ",
                      //   "options": [
                      //     "Government Issued",
                      //     "Company Issued"
                      //   ]
                      // },
                      {
                        "type": "text",
                        "x": "500",
                        "y": "225",
                        "width": "300",
                        "height": "17",
                        "page": "1",
                        "signer": "1",
                        "name": "ID TYPE",
                        "identifier": "unique_field_identifier_1",
                        "required": 1,
                        "readonly": 0,
                        "validation_type": "",
                        "text_size": "",
                        "text_color": "",
                        "text_font": "",
                        "text_style": "",
                        "value": " ",
                        "options": [],
                        "group": ""
                      },
                      // {
                      //   "type": "dropdown",
                      //   "x": "540",
                      //   "y": "273",
                      //   "width": "55",
                      //   "height": "17",
                      //   "page": "1",
                      //   "signer": "OWNER",
                      //   "name": "Matching Photo on ID?",
                      //   "identifier": "unique_field_identifier_2",
                      //   "required": 1,
                      //   "readonly": 0,
                      //   "text_size": 16,
                      //   "text_color": "#FF0000",
                      //   "text_font": "arial",
                      //   "text_style": "BUI",
                      //   "validation_type": "",
                      //   "value": " ",
                      //   "options": [
                      //     "Yes",
                      //     "No"
                      //   ]
                      // },
                      {
                        "type": "text",
                        "x": "500",
                        "y": "273",
                        "width": "300",
                        "height": "17",
                        "page": "1",
                        "signer": "1",
                        "name": "Matching Photo on ID?",
                        "identifier": "unique_field_identifier_2",
                        "required": 1,
                        "readonly": 0,
                        "validation_type": "",
                        "text_size": "",
                        "text_color": "",
                        "text_font": "",
                        "text_style": "",
                        "value": " ",
                        "options": [],
                        "group": ""
                      },
                      // {
                      //   "type": "dropdown",
                      //   "x": "540",
                      //   "y": "357",
                      //   "width": "55",
                      //   "height": "17",
                      //   "page": "1",
                      //   "signer": "OWNER",
                      //   "name": "Matching Photo on ID?",
                      //   "identifier": "unique_field_identifier_3",
                      //   "required": 1,
                      //   "readonly": 0,
                      //   "text_size": 16,
                      //   "text_color": "#FF0000",
                      //   "text_font": "arial",
                      //   "text_style": "BUI",
                      //   "validation_type": "",
                      //   "value": " ",
                      //   "options": [
                      //     "Yes",
                      //     "No"
                      //   ]
                      // }, 
                      {
                        "type": "text",
                        "x": "500",
                        "y": "357",
                        "width": "300",
                        "height": "17",
                        "page": "1",
                        "signer": "1",
                        "name": "Matching Photo on ID?",
                        "identifier": "unique_field_identifier_3",
                        "required": 1,
                        "readonly": 0,
                        "validation_type": "",
                        "text_size": "",
                        "text_color": "",
                        "text_font": "",
                        "text_style": "",
                        "value": " ",
                        "options": [],
                        "group": ""
                      },
                      // {
                      //   "type": "checkbox",
                      //   "x": "562",
                      //   "y": "273",
                      //   "width": "14",
                      //   "height": "14",
                      //   "page": "1",
                      //   "signer": "OWNER",
                      //   "name": "Matching Photo on ID?",
                      //   "identifier": "unique_field_identifier_37",
                      //   "required": 1,
                      //   "readonly": 0,
                      //   "validation_type": "",
                      //   "value": 0,
                      //   "options": [],
                      //   "group": ""
                      // }, 
                      // {
                      //   "type": "checkbox",
                      //   "x": "640",
                      //   "y": "265",
                      //   "width": "14",
                      //   "height": "14",
                      //   "page": "1",
                      //   "signer": "OWNER",
                      //   "name": "Freight Charge Terms Prepaid",
                      //   "identifier": "unique_field_identifier_38",
                      //   "required": 1,
                      //   "readonly": 0,
                      //   "validation_type": "",
                      //   "value": 0,
                      //   "options": [],
                      //   "group": ""
                      // }, 
                      {
                        "type": "text",
                        "x": "500",
                        "y": "310",
                        "width": "300",
                        "height": "17",
                        "page": "1",
                        "signer": "1",
                        "name": "type of id reviewed",
                        "identifier": "unique_field_identifier_4",
                        "required": 1,
                        "readonly": 0,
                        "validation_type": "",
                        "text_size": "",
                        "text_color": "",
                        "text_font": "",
                        "text_style": "",
                        "value": " ",
                        "options": [],
                        "group": ""
                      },
                      // {
                      //   "type": "checkbox",
                      //   "x": "560",
                      //   "y": "355",
                      //   "width": "14",
                      //   "height": "14",
                      //   "page": "1",
                      //   "signer": "OWNER",
                      //   "name": "Freight Charge Terms Prepaid",
                      //   "identifier": "unique_field_identifier_5",
                      //   "required": 1,
                      //   "readonly": 0,
                      //   "validation_type": "",
                      //   "value": 0,
                      //   "options": [],
                      //   "group": ""
                      // }, {
                      //   "type": "checkbox",
                      //   "x": "6000",
                      //   "y": "355",
                      //   "width": "14",
                      //   "height": "14",
                      //   "page": "1",
                      //   "signer": "OWNER",
                      //   "name": "Freight Charge Terms Prepaid",
                      //   "identifier": "unique_field_identifier_6",
                      //   "required": 1,
                      //   "readonly": 0,
                      //   "validation_type": "",
                      //   "value": 0,
                      //   "options": [],
                      //   "group": ""
                      // }, 
                      {
                        "type": "text",
                        "x": "500",
                        "y": "410",
                        "width": "300",
                        "height": "17",
                        "page": "1",
                        "signer": "1",
                        "name": "printed name",
                        "identifier": "unique_field_identifier_9",
                        "required": 1,
                        "readonly": 0,
                        "validation_type": "",
                        "text_size": "",
                        "text_color": "",
                        "text_font": "",
                        "text_style": "",
                        "value": " ",
                        "options": [],
                        "group": ""
                      }, {
                        "type": "text",
                        "x": "500",
                        "y": "460",
                        "width": "300",
                        "height": "17",
                        "page": "1",
                        "signer": "1",
                        "name": "shipper company name",
                        "identifier": "unique_field_identifier_8",
                        "required": 1,
                        "readonly": 0,
                        "validation_type": "",
                        "text_size": "",
                        "text_color": "",
                        "text_font": "",
                        "text_style": "",
                        "value": " ",
                        "options": [],
                        "group": ""
                      }, {
                        "type": "text",
                        "x": "500",
                        "y": "510",
                        "width": "300",
                        "height": "17",
                        "page": "1",
                        "signer": "1",
                        "name": "name of the iac employee",
                        "identifier": "unique_field_identifier_10",
                        "required": 1,
                        "readonly": 0,
                        "validation_type": "",
                        "text_size": "",
                        "text_color": "",
                        "text_font": "",
                        "text_style": "",
                        "value": " ",
                        "options": [],
                        "group": ""
                      }
                    ]
                  ]
                }
                // "params": {
                //   "withFlightInfoOnly": "false"
                // }
              })
                .then(response => {
                  this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
                  resolve(response);
                })
                .catch(err => {
                  console.log(err);
                  reject(err);
                })
            })
          }

          Promise.all([firstDocument(), secondDocument(), thirdDocument(), fourthDocument(), fifthDocument()])
            .then(results => {
              const [firstCall, secondCall, thirdCall, fourthCall, fifthCall] = results;
              console.log(results);

              const urls = {
                signingURLs: [
                  firstCall.data.signers[0].embedded_signing_url,
                  firstCall.data.signers[1].embedded_signing_url,
                  firstCall.data.signers[2].embedded_signing_url,
                ],
                signingSampleWayBill: secondCall.data.signers[0].embedded_signing_url,
                driverDropOffRateConURL: thirdCall.data.signers[0].embedded_signing_url,
                driverPickUpRateConURL: fourthCall.data.signers[0].embedded_signing_url,
                driverIVFURL: fifthCall.data.signers[0].embedded_signing_url
              }

              console.log('urls:', urls);

              const hashes = {
                bolHash: firstCall.data.document_hash,
                sampleWayBillHash: secondCall.data.document_hash,
                driverDropOffRateHash: thirdCall.data.document_hash,
                driverPickUpRateConHash: fourthCall.data.document_hash,
                driverIVF: fifthCall.data.document_hash,
              };

              console.log("hashes:", hashes);

              db.collection('haney-orders').doc(this.props.orderID).set({
                ...urls,
                ...hashes
              }, { merge: true })
                .then(() => {
                  console.log("Firestore urls & hashes set")

                  const firstEmail = () => {
                    return new Promise(async (resolve, reject) => {
                      let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Your Signature May be Required!`
                      let html = `<p>Thank you very much for shipping with Haney Freightways! Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`
                      html += `<p><b>Using Haney Freightways Customer App</b></p>`
                      html += `<p>The button below will take you to the Haney Freightways Customer Application.  If you don’t have a login yet, simply request one via shipping@cargorx.com.  We’ll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`
                      html += `<p>- All Haney Freightways orders involving your company will be isible by click "Orders" on the menu bar</p>`
                      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="150">`
                      html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
                      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`
                      html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents and access the e-sign version if you’ll be signing as the shipper contact.  If you aren’t signing as the shipper contact, the driver will have an e-signature version of the shipping document on his or her phone for the shipping contact to sign.</p>`
                      html += `<p>- You can also use the Customer App to track your shipments – certain shipment types allow you to see the driver’s location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`
                      html += `<p>- <b>New Transactions:</b> If you don’t have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>– you’ll be asked to complete certain missing fields later when you select and book your shipping option.</p>`
                      html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing – you won’t be asked for any missing information later when you select and book a shipping option.</p>`
                      html += `<a href="https://haney-freightways-customer.web.app"><button>Customer App</button></a>`
                      html += `<p><b>E-Document and e-Signature Link</b></p>`
                      html += `<p>If you aren’t able to access the customer application but did receive this message, you can access your electronic document using the link below.<p>`
                      html += `<p>The <b>${((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "Bill of Lading" : ""))}</b> requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  If you’d like a contact-free way to sign as the shipper, click the link below.</p>`
                      html += `<p>- To sign as the <b>Shipper</b>, please <a href="${urls.signingURLs[0]}">click here</a></p>`
                      html += `<p>Thanks for the opportunity to serve your company!</p>`
                      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
                      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
                      // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                      // const emails = [origin.email, "customeralerts@cargorx.com", "justin@pondata.com"]
                      // const emails = [origin.email, "customeralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
                      const emails = [origin.email, "justin@pondata.com"];
                      const attachment = true;
                      const emailReturn = await sendEmail({
                        emails,
                        subject,
                        html,
                        attachment
                      })
                      resolve(emailReturn);
                    })
                  }

                  const secondEmail = () => {
                    return new Promise(async (resolve, reject) => {
                      let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Please Get Signatures!`
                      let html = `<p>Thank you for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures.</p>`
                      html += `<p><b>Using Vendor Dispatch App</b></p>`
                      html += `<p>The button below will take you to the Haney Freightways Vendor Dispatcher Application. If you don't have a login yet, simply request one via shipping@cargorx.com. We'll send a link via email and text, which will allow you to log right in. If you have a profile click the button below, log in, and access the following:</p>`
                      html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`
                      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="150">`
                      html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
                      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`
                      html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents including the completed e-sign docs once all parties have signed – our preference is for the driver to obtain e-signatures, but we understand that paper might be necessary.  The driver is able to upload pictures of paper documents through the driver application and we send the driver a link to this app if we have the driver’s information when we dispatch the shipment.</p>`
                      html += `<p>- Within the shipment summary page, you will see a button the says “Confirm Rate” – if the Status above the button says “unconfirmed” in red text, please click on the button and e-sign the confirmation – if the status says “confirmed” in green text above the button, someone has already confirmed the rate.</p>`
                      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.40.04%20PM.png?alt=media&token=9fc33ea6-f2f4-4d8b-9d17-8e573f943592" height="100">`
                      html += `<p><b>- Call 833-227-4679 for answers to any questions you have – we’re here for you!</b></p>`
                      html += `<a href="https://haney-freightways-vendor.web.app"><button>Vendor App</button></a>`
                      html += `<p><b>E-Document and e-Signature Link</b></p>`
                      html += `<p>If a driver wasn’t assigned at the time of dispatch, a driver was assigned but they didn’t receive our dispatch alert, or a new driver is being used to complete some part of this job for your company, they can access the electronic documents and e-signatures by using the links below.  You simply need to forward the applicable link(s) below to the appropriate driver.</p>`
                      // html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. As the driver, you must <a href=${urls.driverPickUpRateConURL}>click here</a> to view and complete the applicable TSA verification.</p>`
                      html += `<p>The <b>Dispatch Alert</b> is similar to the Bill of Lading but is only used for informational purposes (it will not be signed).  To view the dispatch alert, <a href=${urls.driverPickUpRateConURL}>click here</a></p>`
                      html += `<p>The <b>${((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "Bill of Lading" : ""))}</b> requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (the driver), and the shipper to sign.</p>`
                      html += `<p>- To sign as the <b>pick-up driver</b>, please <a href="${urls.signingURLs[1]}">click here</a></p>`
                      html += `<p>- To sign as the <b>shipper</b>, please <a href="${urls.signingURLs[0]}">click here</a></p>`
                      html += `<p>- To sign as the <b>consignee</b>, please <a href="${urls.signingURLs[2]}">click here</a></p>`
                      if ((deliveryType == "Air" || deliveryType == "Scheduled Air")) {
                        html += `<p>The <b>Sample Airline Waybill</b> has been prefilled with all the necessary information to allow for a successful tender.  You can use this sample to fill out the actual waybill, or print and use for tender with the airline.  Please <a href="${urls.signingSampleWaybillURL}">view here</a></p>`
                        html += `<p>The <b>IAC Certificate</b> must be printed and tendered to the airline along with the waybill and freight. Please <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIAC%20Certificate%2011.8.2019%20(1).pdf?alt=media&token=4cc64b5d-d5cf-4627-b223-d099d8b6edab">view here</a></p>`
                      }
                      // if ((deliveryType == "Ground" || deliveryType == "Additional Options")) {
                      //   html += `<p>Please click the following link to have the consignee sign the <b>Bill of Lading</b> once they have agreed to take delivery: <a href="${urls.signingURLs[2]}">Sign Here</a></p>`
                      //   html += `<p>If the consignee has already signed, you will be notified as such when you click the consignee signature link.<p>`
                      // }
                      if (!origin.ksms && deliveryType == "Air") {
                        html += `<p>If you’ve received the Identification Validation Form it’s because the shipper is unknown to TSA and this form must be completed. Please <a href="${urls.driverIVFURL}">click here</a> and complete the form.</p>`
                      }
                      html += `<p>Thanks, and be safe out there!<p>`
                      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
                      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
                      // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                      // const emails = [(vendorPickUp.email && vendorPickUp.email), "vendoralerts@cargorx.com", "justin@pondata.com"]
                      // const emails = [vendorPickUp.email, "vendoralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
                      const emails = [vendorPickUp.email, "justin@pondata.com"];
                      const attachment = true;
                      const emailReturn = await sendEmail({
                        emails,
                        subject,
                        html,
                        attachment
                      })
                      resolve(emailReturn)
                    })
                  }

                  const thirdEmail = () => {
                    return new Promise(async (resolve, reject) => {
                      let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Please Get Signatures!`
                      let html = `<p>Thank you very much for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures and perform key driver functions.</p>`
                      html += `<p><b>Using the Driver App</b></p>`
                      html += `<p>The button below will take you to the Haney Freightways Driver Application.  You won’t need to log in and you won’t need to download anything to your phone!</p>`
                      html += `<p>Once you’re in, you’ll have access to the e-signatures we need for this order and some other helpful features.</p>`
                      html += `<p>- Click “allow location services” – our application uses geo-fencing to automatically update the status of this shipment.  Please do not close the browser window being used to access the driver application until your entire job has been completed.</p>`
                      html += `<p>- Click the <b>“Driver’s Signature”</b> button, compare the Haney Freightways bill to the freight being offered, and e-sign when you’re confident you have the right shipment.</p>`
                      html += `<p>- Click on the <b>“Shipper’s Signature”<b> button and either have them signon your phone, or type the shipper’s name in for them using the e-signature tool – if the shipper has already signed, the link will tell you so.</p>`
                      html += `<p>- Depending on the type of job you’re doing, other paperwork like TSA forms, air waybills, or labels may be available to you – if you see them, you need them.</p>`
                      html += `<p>- <b>Call 833-227-4679 for answers to any questions you have – we’re here for you!</b></p>`
                      html += `<a href="https://haney-freightways-driver.web.app/pages/upload/${orderID}"><button>Driver App</button></a>`
                      html += `<p><b>E-Document and E-Signature Link</b></p>`
                      html += `<p>If you aren’t able to access the driver application but did receive this message, you can access your electronic documents using the links below.</p>`
                      html += `<p>The <b>Dispatch Alert</b> is similar to the Bill of Lading but is only used for informational purposes (it will not be signed). To view the dispatch alert, <a href=${urls.driverPickUpRateConURL}>click here</a>.</p>`
                      html += `<p>The <b>${((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (the driver), and the shipper to sign.</p>`
                      html += `<p>- To sign as the <b>pick-up driver</b>, please <a href="${urls.signingURLs[1]}">click here</a></p>`
                      html += `<p>- To sign as the <b>shipper</b>, please <a href="${urls.signingURLs[0]}">click here</a></p>`
                      html += `<p>- To sign as the <b>consignee</b>, please <a href="${urls.signingURLs[2]}">click here</a></p>`
                      if ((deliveryType == "Air" || deliveryType == "Scheduled Air")) {
                        html += `<p>The <b>Sample Airline Waybill</b> has been prefilled with all the necessary information to allow for a successful tender.  You can use this sample to fill out the actual waybill, or print and use for tender with the airline.  Please <a href="${urls.signingSampleWaybillURL}">view here</a></p>`
                        html += `<p>The <b>IAC Certificate</b> must be printed and tendered to the airline along with the waybill and freight. Please <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIAC%20Certificate%2011.8.2019%20(1).pdf?alt=media&token=4cc64b5d-d5cf-4627-b223-d099d8b6edab">view here</a></p>`
                      }
                      // if ((deliveryType == "Ground" || deliveryType == "Additional Options")) {
                      //   html += `<p>Please click the following link to have the consignee sign the <b>Bill of Lading</b> once they have agreed to take delivery: <a href="${urls.signingURLs[2]}">Sign Here</a></p>`
                      //   html += `<p>If the consignee has already signed, you will be notified as such when you click the consignee signature link.<p>`
                      // }
                      if (!origin.ksms && deliveryType == "Air") {
                        html += `<p>If you’ve received the Identification Validation Form it’s because the shipper is unknown to TSA and this form must be completed. Please <a href="${urls.driverIVFURL}">click here</a> and complete the form.</p>`
                      }
                      html += `<p>Thanks, and be safe out there!<p>`
                      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`
                      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
                      // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                      // const emails = [(driverPickUpEmail && driverPickUpEmail), "vendoralerts@cargorx.com", "justin@pondata.com"]
                      // const emails = [driverPickUpEmail, "vendoralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
                      const emails = [driverPickUpEmail, "justin@pondata.com"];
                      const attachment = true;
                      const emailReturn = await sendEmail({
                        emails,
                        subject,
                        html,
                        attachment
                      })
                      resolve(emailReturn)
                    });
                  }

                  const fourthEmail = () => {
                    let body = 'Thank you for partnering with Haney Freightways! Below you will find the link to check in and sign the BOL.'
                    body += `\nhttps://haney-freightways-driver.web.app/pages/upload/${orderID}`
                    body += `\n\nDriver: ${urls.signingURLs[1]}`
                    body += `\n\nConsignee: ${urls.signingURLs[2]}`
                    let from = '+17205139929'
                    // let to = (driverPickUp.cell ? ("+1" +driverPickUp.cell) : '+17205139929')
                    let to = '+1' + pickUpDriver.cellPhone
                    // let angie = '+17204865666'
                    // let kevin = '+13039473066'
                    // let justin = '+13602417418'

                    return new Promise(async (resolve, reject) => {
                      const emailReturn = await sendSMS({
                        body, from, to
                      })
                      resolve(emailReturn)
                    })
                  }

                  const fifthEmail = () => {
                    return new Promise(async (resolve, reject) => {
                      if ((deliveryType == "Air" || deliveryType == "Scheduled Air")) {

                        let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Please Get Signatures!`
                        let html = `<p>Thank you for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures.</p>`
                        html += `<p><b>Using Vendor Dispatch App</b></p>`
                        html += `<p>The button below will take you to the Haney Freightways Vendor Dispatcher Application. If you don't have a login yet, simply request one via shipping@cargorx.com. We'll send a link via email and text, which will allow you to log right in. If you have a profile click the button below, log in, and access the following:</p>`
                        html += `<p>- All Haney Freightways orders involving your company will be isible by click "Orders" on the menu bar</p>`
                        html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="100">`
                        html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
                        html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="100">`
                        html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents including the completed e-sign docs once all parties have signed – our preference is for the driver to obtain e-signatures, but we understand that paper might be necessary.  The driver is able to upload pictures of paper documents through the driver application and we send the driver a link to this app if we have the driver’s information when we dispatch the shipment.</p>`
                        html += `<p>- Within the shipment summary page, you will see a button the says “Confirm Rate” – if the Status above the button says “unconfirmed” in red text, please click on the button and e-sign the confirmation – if the status says “confirmed” in green text above the button, someone has already confirmed the rate.</p>`
                        html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.40.04%20PM.png?alt=media&token=9fc33ea6-f2f4-4d8b-9d17-8e573f943592" height="100">`
                        html += `<p><b>Call 833-227-4679 for answers to any questions you have – we’re here for you!</b></p>`
                        html += `<a href="https://haney-freightways-vendor.web.app"><button>Vendor App</button></a>`
                        html += `<p><b>E-Document and e-Signature Link</b></p>`
                        html += `<p>If a driver wasn’t assigned at the time of dispatch, a driver was assigned but they didn’t receive our dispatch alert, or a new driver is being used to complete some part of this job for your company, they can access the electronic documents and e-signatures by using the links below.  You simply need to forward the applicable link(s) below to the appropriate driver.</p>`
                        html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. As the driver, you must <a href=${urls.driverDropOffRateConURL}>click here</a> to view and complete the applicable TSA verification.</p>`
                        html += `<p>The <b>${((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (the driver), and the shipper to sign.</p>`
                        html += `<p>- To sign as the <b>consignee</b>, please <a href="${urls.signingURLs[2]}">click here</a></p>`
                        html += `<p>The <b>Airline Air Waybill</b> is a critical piece of information.  Please take a picture of the actual airline airwaybill within the driver application – if you are unable to access the driver application, please obtain a hard copy and send back to Haney Freightways via email or snail mail.</p>`
                        html += `<p>Thanks, and be safe out there!<p>`
                        html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`
                        html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
                        // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                        // const emails = [(vendorDropOff.email && vendorDropOff.email), "vendoralerts@cargorx.com", "justin@pondata.com"]
                        // const emails = [vendorDropOff.email, "vendoralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
                        const emails = [vendorDropOff.email, "justin@pondata.com"];
                        const attachment = true;
                        const emailReturn = await sendEmail({
                          emails,
                          subject,
                          html,
                          attachment
                        })
                        resolve(emailReturn)
                      } else {
                        resolve("Wrong delivery type for fifth email")
                      }
                    })
                  }

                  const sixthEmail = () => {
                    return new Promise(async (resolve, reject) => {
                      if ((deliveryType == "Air" || deliveryType == "Scheduled Air")) {

                        let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Your Signature May be Required!`
                        let html = `<p>Thank you very much for shipping with Haney Freightways! Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`
                        html += `<p><b>E-Document and e-Signature Link</b></p>`
                        html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. As the driver, you must <a href=${urls.driverDropOffRateConURL}>click here</a> to view and complete the applicable TSA verification.</p>`
                        html += `<p>The <b>${((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (thedriver), and the shipper to sign.</p>`
                        html += `<p>- To sign as the <b>consignee</b>, please <a href="${urls.signingURLs[2]}">click here</a></p>`
                        html += `<p>The <b>Airline Air Waybill</b> is a critical piece of information.  Please take a picture of the actual airline airwaybill within the driver application – if you are unable to access the driver application, please obtain a hard copy and send back to Haney Freightways via email or snail mail.</p>`
                        html += `<p>Thanks, and be safe out there!<p>`
                        html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
                        html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
                        // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                        // const emails = [(driverDropOffEmail && driverDropOffEmail), "vendoralerts@cargorx.com", "justin@pondata.com"]
                        // const emails = [driverDropOffEmail, "vendoralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
                        const emails = [driverDropOffEmail, "justin@pondata.com"];
                        const attachment = true;
                        const emailReturn = await sendEmail({
                          emails,
                          subject,
                          html,
                          attachment
                        })
                        resolve(emailReturn);
                      } else {
                        resolve("Wrong delivery type for sixth email");
                      }
                    })

                  }

                  const seventhEmail = () => {
                    let subject = `Haney Freightways ${((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "Bill of Lading" : ""))} #${freightBillNumber}, Shipping Documents – Your Signature May be Required!`
                    let html = `<p>Thank you very much for shipping with Haney Freightways!  Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`
                    html += `<p><b>Using Haney Freightways Customer App</b></p>`
                    html += `<p>The "Customer App" button below will take you to the Haney Freightways Customer Application.  If you don’t have a login yet, simply request one via shipping@cargorx.com.  We’ll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`
                    html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`
                    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%202.07.50%20PM.png?alt=media&token=e7a63ce9-9179-4ac8-850f-cf6c14423ada" height="150">`
                    html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
                    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`
                    html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents and access the e-sign version.  If you won’t be the person signing for the delivery of this shipment, the driver will have an e-signature version of the shipping document on his or her phone for the for the person taking delivery.</p>`
                    html += `<p>- You can also use the Customer App to track your shipments – certain shipment types allow you to see the driver’s location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`
                    html += `<p>- <b>New Transactions:</b> If you don’t have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>– you’ll be asked to complete certain missing fields later when you select and book your shipping option.</p>`
                    html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing – you won’t be asked for any missing information later when you select and book a shipping option.</p>`
                    html += `<p>Please click the link below to verify shipment details. The link includes an e-signature, which we realize you won’t complete until your freight has been received.<p>`
                    html += `<a href="https://haney-freightways-customer.web.app"><button>Customer App</button></a>`
                    html += `<p><b>E-Document and e-Signature Link</b></p>`
                    html += `<p>If you aren’t able to access the customer application but did receive this message, you can access your electronic document using the link below.<p>`
                    html += `<p>The <b>${((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "Bill of Lading" : ""))}</b> requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature. If you’d like a contact-free way to sign at delivery, click the link below.</p>`
                    html += `<p>- To sign as the <b>Consignee</b> at the time of delivery, please <a href="${urls.signingURLs[2]}">click here</a></p>`
                    html += `<p>Thanks for the opportunity to serve your company!</p>`
                    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`
                    html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
                    // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                    // const emails = [destination.email, "customeralerts@cargorx.com", "justin@pondata.com"]
                    // const emails = [destination.email, "customeralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
                    const emails = [destination.email, "justin@pondata.com"];
                    const attachment = true;
                    return new Promise(async (resolve, reject) => {
                      const emailReturn = await sendEmail({
                        emails,
                        subject,
                        html,
                        attachment
                      })
                      resolve(emailReturn)
                    })
                  }

                  const eigthEmail = () => {
                    console.log(destination.email)

                    let subject = `Haney Freightways ${((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "House Waybill" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "Bill of Lading" : ""))} #${freightBillNumber} - Shipping Documents!`
                    let html = `<p>Thank you very much for shipping with Haney Freightways!  Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`
                    html += `<p><b>Using Haney Freightways Customer App</b></p>`
                    html += `<p>The "Customer App" button below will take you to the Haney Freightways Customer Application.  If you don’t have a login yet, simply request one via shipping@cargorx.com.  We’ll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`
                    html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`
                    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%202.07.50%20PM.png?alt=media&token=e7a63ce9-9179-4ac8-850f-cf6c14423ada" height="150">`
                    html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
                    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`
                    html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents.</p>`
                    html += `<p>- You can also use the Customer App to track your shipments – certain shipment types allow you to see the driver’s location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`
                    html += `<p>- <b>New Transactions:</b> If you don’t have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>– you’ll be asked to complete certain missing fields later when you select and book your shipping option.</p>`
                    html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing – you won’t be asked for any missing information later when you select and book a shipping option.</p>`
                    html += `<a href="https://haney-freightways-customer.web.app"><button>Customer App</button></a>`
                    html += `<p>Thanks for the opportunity to serve your company!</p>`
                    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`
                    html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
                    // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
                    // const emails = [thirdParty.email, "customeralerts@cargorx.com", "justin@pondata.com"]
                    // const emails = [(thirdParty ? thirdParty.email : ""), "customeralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
                    const emails = [(thirdParty ? thirdParty.email : ""), "justin@pondata.com"];
                    const attachment = true;
                    return new Promise(async (resolve, reject) => {
                      const emailReturn = await sendEmail({
                        emails,
                        subject,
                        html,
                        attachment
                      })
                      resolve(emailReturn)
                    })
                  }

                  Promise.all([firstEmail(), secondEmail(), thirdEmail(), fourthEmail(), fifthEmail(), sixthEmail(), seventhEmail(), eigthEmail()])
                    .then(results => {
                      console.log(results);
                      window.location.reload();
                    })

                })

            })
            .catch(err => {
              console.log(err);
            })


        })
        .catch(err => {
          console.log(err);
        })

    }

    main();
  }

  // handleSubmit = (e) => {
  //   e.preventDefault();
  //   db.collection("haney-orders").doc(this.state.orderData.id).set({
  //     // flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
  //     // flight: this.state.flight ? this.state.flight : (this.state.orderData.flight ? this.state.orderData.flight : null),
  //     // originAirport: this.state.originAirport ? this.state.originAirport : null,
  //     // destinationAirport: this.state.destinationAirport ? this.state.destinationAirport : null,
  //     // driverPickUpName: this.state.pickUpDriverName ? this.state.pickUpDriverName : null,
  //     // driverPickUpID: this.state.pickUpDriverID ? this.state.pickUpDriverID : null,
  //     // vendorPickUpName: this.state.vendorPickUp ? this.state.vendorPickUp.name : null,
  //     // vendorPickUpID: this.state.vendorPickUp ? this.state.vendorPickUp.id : null,
  //     // driverDropOffName: this.state.dropOffDriverName ? this.state.dropOffDriverName : null,
  //     // driverDropOffID: this.state.dropOffDriverID ? this.state.dropOffDriverID : null,
  //     // vendorDropOffName: this.state.vendorDropOff ? this.state.vendorDropOff.name : null,
  //     // vendorDropOffID: this.state.vendorDropOff ? this.state.vendorDropOff.id : null,
  //     // pickUpRate: this.state.pickUpRate ? this.state.pickUpRate : null,
  //     // pickUpRateStatus: "unconfirmed",
  //     // dropOffRate: this.state.dropOffRate ? this.state.dropOffRate : null, 
  //     // dropOffRateStatus: "unconfirmed",
  //     // status: "Dispatched",
  //     // dispatcherID: this.props.authUser.uid,
  //     // dispatcherEmail: this.props.user.email,
  //     // dispatcherAssigned: new Date(),
  //     // dispatchedAt: new Date(),
  //     // origin: this.state.origin,
  //     // destination: this.state.destination,
  //     // bookingNumber: this.state.bookingNumber ? this.state.bookingNumber : null,
  //     // airWaybillNumber: this.state.airWaybillNumber ? this.state.airWaybillNumber : null,
  //     serviceLevel: this.state.serviceLevel ? this.state.serviceLevel : null
  //   }, { merge: true }).then(async () => {
  //           console.log("requesting signature")

  //           const axios = require("axios");

  //           axios({
  //             "method": "POST",
  //             "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
  //             "data": {
  //               "sandbox": 0,
  //               "is_draft": 0,
  //               "embedded": 1,
  //               "title": `Haney Freightways Document ${(this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : "Bill of Lading"}House Waybill #${this.state.orderData.freightBillNumber}`,
  //               "message": "This is my general document message.",
  //               "use_signer_order": 0,
  //               "reminders": 1,
  //               "require_all_signers": 0,
  //               "custom_requester_name": "",
  //               "custom_requester_email": "",
  //               "redirect": "",
  //               "redirect_decline": "",
  //               "client": "",
  //               "expires": 1750513480,
  //               "embedded_signing_enabled": 1,
  //               "flexible_signing": 0,
  //               "use_hidden_tags": 0,
  //               "files": [{
  //                 "name": "House Waybill",
  //                 "file_url": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FCustomer%20Docs%2FHouse%20Waybill%20Final%20No%20Auto%20Calc%20Weight%206.15.2020.pdf?alt=media&token=1418c8a6-c837-43ac-8a42-b23717638f75" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FCustomer%20Docs%2FHaney Freightways%20Bill%20of%20Lading%20Final%20No%20Auto%20Calc%20Weight%206.16.2020.pdf?alt=media&token=3f3404fa-a892-46ab-bc10-7ccaea831c4d" : null)),
  //                 "file_id": "",
  //                 "file_base64": ""
  //               }],
  //               "signers": [{
  //                 "id": 1,
  //                 "name": " ",
  //                 "email": this.state.orderData.origin.email ? this.state.orderData.origin.email : "missingshipper@cargorx.com",
  //                 "order": 1,
  //                 // "pin": "3874",
  //                 "message": "This is my custom message to Shipper.",
  //                 "deliver_email": 0,
  //                 "language": "en"
  //               }, {
  //                 "id": 2,
  //                 // "name": (this.state.driversDropOffData[0].firstName + this.state.driversDropOffData[0].firstName),
  //                 "name": " ",
  //                 // "email": (this.state.driverPickUpEmail ? this.state.driverPickUpEmail : (this.state.vendorPickUp.email ? this.state.vendorPickUp.email : "vendoralerts@cargorx.com")),
  //                 "email": "vendoralerts@cargorx.com",
  //                 "order": 2,
  //                 // "pin": "3874",
  //                 "message": "This is my custom message to Driver.",
  //                 "deliver_email": 0,
  //                 "language": "en"
  //               }, {
  //                 "id": 3,
  //                 "name": " ",
  //                 "email": this.state.orderData.destination.email ? this.state.orderData.destination.email : "missingcons@cargorx.com",
  //                 "order": 3,
  //                 // "pin": "3874",
  //                 "message": "This is my custom message to Consignee.",
  //                 "deliver_email": 0,
  //                 "language": "en"
  //               }],
  //               "recipients": [{
  //                 "name": "Vendor Alerts",
  //                 "email": "vendoralerts@cargorx.com",
  //                 "language": "en"
  //               }],
  //               "meta": {
  //                 "some_key": "some_value",
  //                 "another_key": "another_value"
  //               },
  //               "fields": [
  //                 [{
  //                   "type": "signature",
  //                   "x": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "520" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "530" : "")),
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "930" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "950" : "")),
  //                   "width": "120",
  //                   "height": "35",
  //                   "page": "1",
  //                   "signer": "1",
  //                   "name": "",
  //                   "identifier": "unique_field_identifier_1",
  //                   "required": 1,
  //                   "readonly": 0,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": "",
  //                   "options": [],
  //                   "group": ""
  //                 },{
  //                   "type": "signature",
  //                   "x": "50",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "995" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "1015" : "")),
  //                   "width": "120",
  //                   "height": "35",
  //                   "page": "1",
  //                   "signer": "2",
  //                   "name": "",
  //                   "identifier": "unique_field_identifier_2",
  //                   "required": 1,
  //                   "readonly": 0,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": "",
  //                   "options": [],
  //                   "group": ""
  //                 },{
  //                   "type": "signature",
  //                   "x": "600",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "1010" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "1030" : "")),
  //                   "width": "150",
  //                   "height": "35",
  //                   "page": "1",
  //                   "signer": "3",
  //                   "name": "",
  //                   "identifier": "unique_field_identifier_3",
  //                   "required": 1,
  //                   "readonly": 0,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": "",
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "300",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "185" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "100" : "")),
  //                   "width": "300",
  //                   "height": "30",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Ready Date/Time",
  //                   "identifier": "unique_field_identifier_56",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": 14,
  //                   "text_color": "#FFFFFF",
  //                   "text_font": "",
  //                   "text_style": "B",
  //                   "value": this.state.orderData.origin.startTimeWindow ? (this.state.orderDataNormal.origin.date ? (moment(this.state.orderDataNormal.origin.date.toDate()).format('YYYY-MM-DD') + " " + this.state.orderData.origin.startTimeWindow) : " ") : (this.state.orderDataNormal.origin.date ? (moment(this.state.orderDataNormal.origin.date.toDate()).format('YYYY-MM-DD HH:mm')) : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "300",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "290" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "205" : "")),
  //                   "width": "300",
  //                   "height": "30",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Needed Date/Time",
  //                   "identifier": "unique_field_identifier_57",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": 14,
  //                   "text_color": "#FFFFFF",
  //                   "text_font": "",
  //                   "text_style": "B",
  //                   "value": (this.state.orderData.deliveryType == "Air" ? (moment(this.state.orderData.air.quoteETA.toDate()).format('YYYY-MM-DD HH:mm')) : (this.state.orderData.deliveryType == "Scheduled Air" ? (moment(this.state.orderData.cargoAir.quoteETA.toDate()).format('YYYY-MM-DD HH:mm')) : (this.state.orderData.deliveryType == "Ground" ? (moment(this.state.orderData.ground.quoteETA.toDate()).format('YYYY-MM-DD HH:mm')) : (this.state.orderData.deliveryType == "Additional Options" ? (moment(this.state.orderData.ltl.quoteETA.toDate()).format('YYYY-MM-DD HH:mm')) : ("hello"))))),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "150",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "213" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin Company Name",
  //                   "identifier": "unique_field_identifier_4",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.businessName,
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "150",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "230" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin Address",
  //                   "identifier": "unique_field_identifier_5",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.address,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "100",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "243" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "158" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin City",
  //                   "identifier": "unique_field_identifier_6",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.city,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "275",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "243" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "158" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin State",
  //                   "identifier": "unique_field_identifier_7",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.state,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "360",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "243" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "158" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin Zip",
  //                   "identifier": "unique_field_identifier_8",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.zip,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "140",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "257" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "172" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin Contact Name",
  //                   "identifier": "unique_field_identifier_9",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.firstName + " " + this.state.orderData.origin.lastName,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "360",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "257" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "172" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin Reference No.",
  //                   "identifier": "unique_field_identifier_10",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.referenceID,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "90",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "272" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "185" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin Phone",
  //                   "identifier": "unique_field_identifier_11",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.phone,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "310",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "272" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "185" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin Cell",
  //                   "identifier": "unique_field_identifier_12",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.email,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "150",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "317" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "230" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination Company Name",
  //                   "identifier": "unique_field_identifier_13",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.businessName,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "150",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "333" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "248" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination Address",
  //                   "identifier": "unique_field_identifier_14",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.address,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "100",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "348" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "260" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination City",
  //                   "identifier": "unique_field_identifier_15",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.city,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "275",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "348" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "260" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination State",
  //                   "identifier": "unique_field_identifier_16",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.state,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "360",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "348" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "260" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination Zip",
  //                   "identifier": "unique_field_identifier_17",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.zip,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "140",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "363" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "277" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination Contact Name",
  //                   "identifier": "unique_field_identifier_18",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.firstName + " " + this.state.orderData.destination.lastName,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "360",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "363" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "279" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination Reference No.",
  //                   "identifier": "unique_field_identifier_19",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.referenceID,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "90",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "377" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "290" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination Phone",
  //                   "identifier": "unique_field_identifier_20",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.phone,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "310",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "377" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "290" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination Cell",
  //                   "identifier": "unique_field_identifier_21",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.email,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "150",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "421" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "334" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party Company Name",
  //                   "identifier": "unique_field_identifier_22",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.businessName,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "150",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "437" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "350" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party Address",
  //                   "identifier": "unique_field_identifier_23",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.address,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "100",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "452" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "365" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party City",
  //                   "identifier": "unique_field_identifier_24",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.city,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "275",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "452" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "365" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party State",
  //                   "identifier": "unique_field_identifier_25",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.state,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "360",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "452" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "365" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party Zip",
  //                   "identifier": "unique_field_identifier_26",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.zip,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "140",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "467" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "380" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party Contact Name",
  //                   "identifier": "unique_field_identifier_27",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.firstName ? (this.state.orderData.thirdParty.firstName + " " + this.state.orderData.thirdParty.lastName) : " ",
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "360",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "467" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "380" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party Reference No.",
  //                   "identifier": "unique_field_identifier_28",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.referenceID,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "90",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "481" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "394" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party Phone",
  //                   "identifier": "unique_field_identifier_29",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.phone,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "310",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "480" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "393" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Third Party Cell",
  //                   "identifier": "unique_field_identifier_30",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.thirdParty.email,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "50",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "524" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "435" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Origin Special Instructions",
  //                   "identifier": "unique_field_identifier_31",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.origin.customExtraService,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "50",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "545" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "458" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Destination Special Instructions",
  //                   "identifier": "unique_field_identifier_32",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.destination.customExtraService,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "600" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "620" : "")),
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "218" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "108" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Waybill Number",
  //                   "identifier": "unique_field_identifier_33",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.freightBillNumber,
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "482",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "328" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Dispatcher Name",
  //                   "identifier": "unique_field_identifier_34",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": "Kevin Kersting",
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "482",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "348" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "163" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Dispatcher Phone",
  //                   "identifier": "unique_field_identifier_35",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": "(303) 947-3066",
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "text",
  //                   "x": "482",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "368" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "183" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Dispatcher Email",
  //                   "identifier": "unique_field_identifier_36",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": "kevin.kersting@cargorx.com",
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "checkbox",
  //                   "x": "488",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "526" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "440" : "")),
  //                   "width": "14",
  //                   "height": "14",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Freight Charge Terms Prepaid",
  //                   "identifier": "unique_field_identifier_37",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "value": ((this.state.orderData.billingParty == "Shipper") ? 1 : 0),
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "checkbox",
  //                   "x": "555",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "526" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "440" : "")),
  //                   "width": "14",
  //                   "height": "14",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Freight Charge Terms Collect",
  //                   "identifier": "unique_field_identifier_38",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "value": ((this.state.orderData.billingParty == "Consignee") ? 1 : 0),
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "checkbox",
  //                   "x": "630",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "526" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "440" : "")),
  //                   "width": "14",
  //                   "height": "14",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Freight Charge Terms 3rd Party",
  //                   "identifier": "unique_field_identifier_39",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "value": ((this.state.orderData.billingParty == "Third Party") ? 1 : 0),
  //                   "options": [],
  //                   "group": ""
  //                 },  {
  //                   "type": "checkbox",
  //                   "x": "445",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "553" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "466" : "")),
  //                   "width": "14",
  //                   "height": "14",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Master bill of lading with attached underlying bills of lading.",
  //                   "identifier": "unique_field_identifier_40",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "value": 0,
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "50",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "630" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "543" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 1 Description",
  //                   "identifier": "unique_field_identifier_41",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.items[0].description,
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "385",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "630" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "543" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 1 Pieces",
  //                   "identifier": "unique_field_identifier_42",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.items[0].quantity,
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "455",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "630" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "543" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 1 Weight",
  //                   "identifier": "unique_field_identifier_43",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.items[0].weight,
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "505",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "630" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "543" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 1 Length",
  //                   "identifier": "unique_field_identifier_44",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.items[0].length,
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "540",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "630" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "543" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 1 Width",
  //                   "identifier": "unique_field_identifier_45",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.items[0].width,
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "580",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "630" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "543" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 1 Height",
  //                   "identifier": "unique_field_identifier_46",
  //                   "required": 1,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": this.state.orderData.items[0].height,
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "620",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "630" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "543" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 1 Additional Shipper Information",
  //                   "identifier": "unique_field_identifier_47",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[0].class ? this.state.orderData.items[0].class : " ") + " " + (this.state.orderData.items[0].unNumber ? this.state.orderData.items[0].unNumber : " ") + " " + (this.state.orderData.items[0].properShippingName ? this.state.orderData.items[0].properShippingName : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "50",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "660" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "573" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 2 Description",
  //                   "identifier": "unique_field_identifier_48",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].description : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "385",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "660" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "573" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 2 Pieces",
  //                   "identifier": "unique_field_identifier_49",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].quantity : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "455",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "660" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "573" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 2 Weight",
  //                   "identifier": "unique_field_identifier_50",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].weight : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "505",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "660" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "573" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 2 Length",
  //                   "identifier": "unique_field_identifier_51",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].length : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "540",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "660" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "573" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 2 Width",
  //                   "identifier": "unique_field_identifier_52",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].width : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "580",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "660" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "573" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 2 Height",
  //                   "identifier": "unique_field_identifier_53",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].height : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "620",
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "660" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "573" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Item 2 Additional Shipper Information",
  //                   "identifier": "unique_field_identifier_54",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? ((this.state.orderData.items[1].class && this.state.orderData.items[1].class) + " " + (this.state.orderData.items[1].unNumber && this.state.orderData.items[1].unNumber) + " " + (this.state.orderData.items[1].properShippingName && this.state.orderData.items[1].properShippingName)) : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "720" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "320" : "")),
  //                   "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "865" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "875" : "")),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Total Declared Value",
  //                   "identifier": "unique_field_identifier_55",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? (this.state.orderData.items[2] ? (Number(this.state.orderData.items[0].declaredValue) + Number(this.state.orderData.items[1].declaredValue) + Number(this.state.orderData.items[2].declaredValue)) : (Number(this.state.orderData.items[0].declaredValue) + Number(this.state.orderData.items[1].declaredValue))) : this.state.orderData.items[0].declaredValue),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   // "x": (this.state.orderData.deliveryType == "Air" ? "720" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "330" : "")),
  //                   // "y": (this.state.orderData.deliveryType == "Air" ? "865" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "858" : "")),
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "700" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "315" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Name",
  //                   "identifier": "unique_field_identifier_58",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? this.state.vendorPickUp.name : ""),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "385",
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "645" : "815"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Grand Total Pieces",
  //                   "identifier": "unique_field_identifier_59",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? (Number(this.state.orderData.items[0].quantity) + Number(this.state.orderData.items[1].quantity)) : this.state.orderData.items[0].quantity),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": "455",
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "645" : "815"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Grand Total Weight",
  //                   "identifier": "unique_field_identifier_60",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? (Number(this.state.orderData.items[0].weight) + Number(this.state.orderData.items[1].weight)) : this.state.orderData.items[0].weight),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "53" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "760" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info Handling Unit",
  //                   "identifier": "unique_field_identifier_61",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[0] ? this.state.orderData.items[0].quantity : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "290" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "760" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info Weight",
  //                   "identifier": "unique_field_identifier_62",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[0] ? this.state.orderData.items[0].weight : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "345" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "760" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info HM UN",
  //                   "identifier": "unique_field_identifier_63",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[0] ? this.state.orderData.items[0].unNumber : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "400" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "760" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info Description",
  //                   "identifier": "unique_field_identifier_64",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? " " : (this.state.orderData.items[0] ? this.state.orderData.items[0].description : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "795" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "760" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info Class",
  //                   "identifier": "unique_field_identifier_65",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[0] ? this.state.orderData.items[0].class : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "53" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "780" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info Handling Unit",
  //                   "identifier": "unique_field_identifier_66",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].quantity : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "290" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "780" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info Weight",
  //                   "identifier": "unique_field_identifier_67",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].weight : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "345" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "780" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info HM UN",
  //                   "identifier": "unique_field_identifier_68",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].unNumber : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "400" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "780" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info Description",
  //                   "identifier": "unique_field_identifier_69",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].description : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }, {
  //                   "type": "text",
  //                   "x": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "795" : "0"),
  //                   "y": ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "780" : "0"),
  //                   "width": "300",
  //                   "height": "17",
  //                   "page": "1",
  //                   "signer": "OWNER",
  //                   "name": "Carrier Info Class",
  //                   "identifier": "unique_field_identifier_70",
  //                   "required": 0,
  //                   "readonly": 1,
  //                   "validation_type": "",
  //                   "text_size": "",
  //                   "text_color": "",
  //                   "text_font": "",
  //                   "text_style": "",
  //                   "value": (this.state.orderData.items[1] ? this.state.orderData.items[1].class : " "),
  //                   "options": [],
  //                   "group": ""
  //                 }]
  //               ]
  //             }
  //             // "params": {
  //             //   "withFlightInfoOnly": "false"
  //             // }
  //           })
  //           .then((response) => {
  //             console.log(response);
  //             this.setState({
  //               signingURL: response.data.signers[0].embedded_signing_url,
  //               signingURL1: response.data.signers[0].embedded_signing_url,
  //               signingURL2: response.data.signers[1].embedded_signing_url,
  //               signingURL3: response.data.signers[2].embedded_signing_url,
  //               signatureURLLoaded: true,
  //             })
  //             db.collection("haney-orders").doc(this.props.orderID).set({
  //               bolHash: response.data.document_hash,
  //               signingURLs: [this.state.signingURL1, this.state.signingURL2, this.state.signingURL3]
  //             }, { merge: true }).then(async () => {
  //               console.log("requesting signature")

  //               const axios = require("axios");

  //               axios({
  //                 "method": "POST",
  //                 "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
  //                 "data": {
  //                   "sandbox": 0,
  //                   "is_draft": 0,
  //                   "embedded": 1,
  //                   "title": `Haney Freightways Sample Universal Waybill #${this.state.orderData.freightBillNumber}`,
  //                   "message": "This is my general document message.",
  //                   "use_signer_order": 0,
  //                   "reminders": 1,
  //                   "require_all_signers": 0,
  //                   "custom_requester_name": "",
  //                   "custom_requester_email": "",
  //                   "redirect": "",
  //                   "redirect_decline": "",
  //                   "client": "",
  //                   "expires": 1750513480,
  //                   "embedded_signing_enabled": 1,
  //                   "flexible_signing": 0,
  //                   "use_hidden_tags": 0,
  //                   "files": [{
  //                     "name": "House Waybill",
  //                     "file_url": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FSample%20Universal%20Air%20Waybill%20Clean%206.22.2020.pdf?alt=media&token=827f1f4d-d012-4e52-9077-a8a2a9b89942" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FCustomer%20Docs%2FHaney Freightways%20Bill%20of%20Lading%20Final%20No%20Auto%20Calc%20Weight%206.16.2020.pdf?alt=media&token=3f3404fa-a892-46ab-bc10-7ccaea831c4d" : null)),
  //                     "file_id": "",
  //                     "file_base64": ""
  //                   }],
  //                   "signers": [{
  //                     "id": 1,
  //                     "name": "Shipper Signer",
  //                     "email": (this.state.pickUpDriverEmail ? this.state.pickUpDriverEmail : "just@pon.com"),
  //                     "order": 1,
  //                     // "pin": "3874",
  //                     "message": "This is my custom message to Shipper.",
  //                     "deliver_email": 0,
  //                     "language": "en"
  //                   }],
  //                   "recipients": [{
  //                     "name": "Vendor Alerts",
  //                     "email": "vendoralerts@cargorx.com",
  //                     "language": "en"
  //                   }],
  //                   "meta": {
  //                     "some_key": "some_value",
  //                     "another_key": "another_value"
  //                   },
  //                   "fields": [
  //                     [{
  //                       "type": "signature",
  //                       "x": "520",
  //                       "y": "930",
  //                       "width": "120",
  //                       "height": "35",
  //                       "page": "1",
  //                       "signer": "1",
  //                       "name": "",
  //                       "identifier": "unique_field_identifier_1",
  //                       "required": 1,
  //                       "readonly": 0,
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": "",
  //                       "options": [],
  //                       "group": ""
  //                     }, {
  //                       "type": "text",
  //                       "x": "55",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "35" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "120" : "")),
  //                       "width": "300",
  //                       "height": "30",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Shipper Name",
  //                       "identifier": "unique_field_identifier_2",
  //                       "required": 1,
  //                       "readonly": 1,
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "#000000",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": "Haney Freightways, LLC",
  //                       "options": [],
  //                       "group": ""
  //                     }, {
  //                       "type": "text",
  //                       "x": "55",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "48" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "235" : "")),
  //                       "width": "300",
  //                       "height": "30",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Shipper Address",
  //                       "identifier": "unique_field_identifier_3",
  //                       "required": 1,
  //                       "readonly": 1,
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "#000000",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": "16600 E 33rd Dr, Unit 10",
  //                       "options": [],
  //                       "group": ""
  //                     }, {
  //                       "type": "text",
  //                       "x": "55",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "70" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Shipper Phone Number",
  //                       "identifier": "unique_field_identifier_4",
  //                       "required": 1,
  //                       "readonly": 1,
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": "Aurora, CO 80011 833-227-4679",
  //                       "options": [],
  //                       "group": ""
  //                     },
  //                     {
  //                       "type": "text",
  //                       "x": "55",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "127" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Co- Signee Name",
  //                       "identifier": "unique_field_identifier_5",
  //                       "required": 1,
  //                       "readonly": 1,
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": "'HOLD FOR PICK UP' - " + (this.state.flight ? this.state.flight.movement.airport.iata : " "),
  //                       "options": [],
  //                       "group": ""
  //                     },
  //                      {
  //                       "type": "text",
  //                       "x": "60",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "140" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "CO-Signee Address",
  //                       "identifier": "unique_field_identifier_6",                    
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": this.state.vendorDropOff ? this.state.vendorDropOff.name : " ",
  //                       "options": [],
  //                       "group": ""
  //                     },
  //                     {
  //                       "type": "text",
  //                       "x": "60",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "153" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Origin Address",
  //                       "identifier": "unique_field_identifier_7",
  //                       "required": 1,
  //                       "readonly": 1,
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": this.state.vendorDropOff ? this.state.vendorDropOff.phone : " ",
  //                       "options": [],
  //                       "group": ""
  //                     }, 
  //                     {
  //                       "type": "text",
  //                       "x": "315",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "180" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "302",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Vendor Name",
  //                       "identifier": "unique_field_identifier_8",                    
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "font_weight":"600",
  //                       "value": "'PREAPID BY SHIPPER'",
  //                       "options": [],
  //                       "group": ""
  //                     },
  //                     {
  //                       "type": "text",
  //                       "x": "315",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "200" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Service Level",
  //                       "identifier": "unique_field_identifier_9",                    
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": "Service Level: " + (this.state.serviceLevel ? this.state.serviceLevel.toUpperCase() : " "),
  //                       "options": [],
  //                       "group": ""
  //                     },  {
  //                       "type": "text",
  //                       "x": "85",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "255" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Airport departure",
  //                       "identifier": "unique_field_identifier_10",                    
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": this.state.flight ? this.state.flight.originAirport.substr(1) : " ", 
  //                       "options": [],
  //                       "group": ""
  //                     },
  //                     {
  //                       "type": "text",
  //                       "x": "325",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "255" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "references Number",
  //                       "identifier": "unique_field_identifier_11",                    
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": "#" + this.state.orderData.freightBillNumber,
  //                       "options": [],
  //                       "group": ""
  //                     },  {
  //                       "type": "text",
  //                       "x": "85",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "275" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Carrier Code ID",
  //                       "identifier": "unique_field_identifier_12",                    
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": this.state.flight ? (this.state.flight.number ? (this.state.flight.number.substring(0, this.state.flight.number.lastIndexOf(" "))) : " ") : " ",
  //                       "options": [],
  //                       "group": ""
  //                     }, {
  //                       "type": "text",
  //                       "x": "415",
  //                       "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "280" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                       "width": "300",
  //                       "height": "17",
  //                       "page": "1",
  //                       "signer": "OWNER",
  //                       "name": "Carrier Code",
  //                       "identifier": "unique_field_identifier_13",                    
  //                       "validation_type": "",
  //                       "text_size": "",
  //                       "text_color": "",
  //                       "text_font": "",
  //                       "text_style": "",
  //                       "value": this.state.orderData.items[0].declaredValue,
  //                       "options": [],
  //                       "group": ""
  //                     }, 
  //                     {
  //                         "type": "text",
  //                         "x": "95",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "300" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Airport Code",
  //                         "identifier": "unique_field_identifier_14",                    
  //                         "validation_type": "",
  //                         "text_size": "",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.flight ? this.state.flight.movement.airport.iata : " ", 
  //                         "options": [],
  //                         "group": ""
  //                       },
  //                        {
  //                         "type": "text",
  //                         "x": "185",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "305" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Flight/Date",
  //                         "identifier": "unique_field_identifier_15",                    
  //                         "validation_type": "",
  //                         "text_size": "14px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.flight ? this.state.flight.number : " ",
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "185",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "320" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Flight/Date",
  //                         "identifier": "unique_field_identifier_16",                    
  //                         "validation_type": "",
  //                         "text_size": "14px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": moment(this.state.destination.deliverBy).format("MM/DD/YY"),
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                        {
  //                         "type": "text",
  //                         "x": "320",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "305" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "flight/Date",
  //                         "identifier": "unique_field_identifier_17",                    
  //                         "validation_type": "",
  //                         "text_size": "",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.orderData.items[0].declaredValue,
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "250",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "305" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Flight/Date",
  //                         "identifier": "unique_field_identifier_18",                    
  //                         "validation_type": "",
  //                         "text_size": "14px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.flight ? this.state.flight.number : " ",
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "250",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "320" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Flight/Date",
  //                         "identifier": "unique_field_identifier_19",                    
  //                         "validation_type": "",
  //                         "text_size": "14px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": moment(this.state.destination.deliverBy).format("MM/DD/YY"),
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "140",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "335" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "143" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Booking Number",
  //                         "identifier": "unique_field_identifier_20",                    
  //                         "validation_type": "",
  //                         "text_size": "",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": "Booking Number:" + " " +  this.state.bookingNumber,
  //                         "options": [],
  //                         "group": ""
  //                       },
  //                       {
  //                         "type": "text",
  //                         "x": "450",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "60" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Frieght Company Name",
  //                         "identifier": "unique_field_identifier_21",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.flight ? (this.state.flight.airline ? this.state.flight.airline.name : " ") : " ",
  //                         "options": [],
  //                         "group": ""
  //                       },
  //                       {
  //                         "type": "text",
  //                         "x": "430",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "405" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "items",
  //                         "identifier": "unique_field_identifier_22",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.orderData.items,
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "150",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "15" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Air Waybill Number",
  //                         "identifier": "unique_field_identifier_23",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.airWaybillNumber,
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "190",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "40" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Haney Freightways Account Number",
  //                         "identifier": "unique_field_identifier_24",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         // "value": (this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? (this.state.originAirlineDetails[0] ? (this.state.originAirlineDetails[0].cargorxAccountNumber ? this.state.originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ",
  //                         "value": (this.state.orderData.deliveryType == "Air") ? (this.state.originAirlineDetails ? (this.state.originAirlineDetails[0] ? (this.state.originAirlineDetails[0].cargorxAccountNumber ? this.state.originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ") : (this.state.orderData.deliveryType == "Scheduled Air" ? (this.state.originAirCarrier.cargorxAccountNumber ? this.state.originAirCarrier.cargorxAccountNumber : " ") : " "),
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "430",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "400" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Freight description",
  //                         "identifier": "unique_field_identifier_25",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.orderData.items[0].description,
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "430",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "420" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Freight description",
  //                         "identifier": "unique_field_identifier_26",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.orderData.items[1] ? this.state.orderData.items[1].description : " ",
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "430",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "440" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Freight description",
  //                         "identifier": "unique_field_identifier_27",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": this.state.orderData.items[2] ? this.state.orderData.items[2].description : " ",
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "60",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "400" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Freight description",
  //                         "identifier": "unique_field_identifier_28",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": (this.state.orderData.items[1] ? (this.state.orderData.items[2] ? (Number(this.state.orderData.items[0].quantity) + Number(this.state.orderData.items[1].quantity) + Number(this.state.orderData.items[2].quantity)) : (Number(this.state.orderData.items[0].quantity) + Number(this.state.orderData.items[1].quantity))) : this.state.orderData.items[0].quantity),
  //                         "options": [],
  //                         "group": ""
  //                       }, 
  //                       {
  //                         "type": "text",
  //                         "x": "100",
  //                         "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "400" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "126" : "")),
  //                         "width": "300",
  //                         "height": "17",
  //                         "page": "1",
  //                         "signer": "OWNER",
  //                         "name": "Freight description",
  //                         "identifier": "unique_field_identifier_29",
  //                         "required": 1,
  //                         "readonly": 1,
  //                         "validation_type": "",
  //                         "text_size": "22px",
  //                         "text_color": "",
  //                         "text_font": "",
  //                         "text_style": "",
  //                         "value": (this.state.orderData.items[1] ? (this.state.orderData.items[2] ? (Number(this.state.orderData.items[0].weight) + Number(this.state.orderData.items[1].weight) + Number(this.state.orderData.items[2].weight)) : (Number(this.state.orderData.items[0].weight) + Number(this.state.orderData.items[1].weight))) : this.state.orderData.items[0].weight),
  //                         "options": [],
  //                         "group": ""
  //                       } 

  //                    ]
  //                   ]
  //                 }
  //                 // "params": {
  //                 //   "withFlightInfoOnly": "false"
  //                 // }
  //               })
  //               .then((response) => {
  //                 console.log(response);
  //                 this.setState({
  //                   signingSampleWaybillURL: response.data.signers[0].embedded_signing_url,
  //                   signatureURLLoaded: true,
  //                 })
  //                 db.collection("haney-orders").doc(this.props.orderID).set({
  //                   sampleWayBillHash: response.data.document_hash,
  //                   signingSampleWaybillURL: response.data.signers[0].embedded_signing_url
  //                 }, { merge: true }).then(async () => {
  //                   console.log("requesting signature")

  //                   const axios = require("axios");

  //                   axios({
  //                     "method": "POST",
  //                     "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
  //                     "data": {
  //                       "sandbox": 0,
  //                       "is_draft": 0,
  //                       "embedded": 1,
  //                       "title": `Haney Freightways Alert #${this.state.orderData.freightBillNumber}`,
  //                       "message": "This is my general document message.",
  //                       "use_signer_order": 0,
  //                       "reminders": 1,
  //                       "require_all_signers": 0,
  //                       "custom_requester_name": "",
  //                       "custom_requester_email": "",
  //                       "redirect": "",
  //                       "redirect_decline": "",
  //                       "client": "",
  //                       "expires": 1750513480,
  //                       "embedded_signing_enabled": 1,
  //                       "flexible_signing": 0,
  //                       "use_hidden_tags": 0,
  //                       "files": [{
  //                         "name": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "Air Pick Up Rate Confirmation": "Ground Only Rate Confirmation",
  //                         "file_url": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FDelivery%20Vendor%20Driver%20Docs%2FPick-Up%20Dispatch%20_%20Rate%20Confirmation%20(Airline%20to%20Destination)%20Final%203.20.2020%20(1).pdf?alt=media&token=3ee1290f-a191-4cb4-bcce-501e7af2d171" : "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FVendor%20Driver%20Docs%2FGround%20Only%20Dispatch%20(Origin%20to%20Destination)%20Final%203.20.2020.pdf?alt=media&token=2da3c1da-541e-471b-bd6b-bb3d5c91c8a6",
  //                         "file_id": "",
  //                         "file_base64": ""
  //                       }],
  //                       "signers": [{
  //                         "id": 1,
  //                         "name": "Pick Up Driver",
  //                         "email": "justin@pondata.com",
  //                         "order": 1,
  //                         // "pin": "3874",
  //                         "message": "This is my custom message to Signer.",
  //                         "deliver_email": "",
  //                         "language": "en"
  //                       }],
  //                       "recipients": [{
  //                         "name": "Vendor Alerts",
  //                         "email": "vendoralerts@cargorx.com",
  //                         "language": "en"
  //                       }],
  //                       "meta": {
  //                         "some_key": "some_value",
  //                         "another_key": "another_value"
  //                       },
  //                       "fields": [
  //                         [{
  //                           "type": "text",
  //                           "x": "120",
  //                           "y": "225",
  //                           "width": "100",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Haney Freightways Contact Name",
  //                           "identifier": "unique_field_identifier_6",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": "Kevin Kersting",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "120",
  //                           "y": "245",
  //                           "width": "100",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Haney Freightways Contact Phone",
  //                           "identifier": "unique_field_identifier_7",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": "(303) 947-3066",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "120",
  //                           "y": "268",
  //                           "width": "150",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Haney Freightways Contact Email",
  //                           "identifier": "unique_field_identifier_8",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": "kevin.kersting@cargorx.com",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "190",
  //                           "y": "297",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Haney Freightways Contact Ready Date/Time",
  //                           "identifier": "unique_field_identifier_9",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": moment(this.state.orderData.destination.deliverBy).format("MM/DD/YYYY HH:mm"),
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "650",
  //                           "y": "225",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Haney Freightways Contact Waybill Number",
  //                           "identifier": "unique_field_identifier_10",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.freightBillNumber,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "672",
  //                           "y": "295",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Haney Freightways Contact Delivery Date/Time",
  //                           "identifier": "unique_field_identifier_11",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": moment(this.state.orderData.serviceETA.toDate()).format("MM/DD/YYYY HH:mm"),
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "180",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "555" : "545",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Carrier Total Charges",
  //                           "identifier": "unique_field_identifier_12",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "130",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "405" : "395",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Carrier Name",
  //                           "identifier": "unique_field_identifier_13",
  //                           "required": 1,
  //                           "readonly": 0,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.vendorDropOff ? this.state.vendorDropOff.name : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "170",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "430" : "420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Carrier Pro Number",
  //                           "identifier": "unique_field_identifier_14",
  //                           "required": 0,
  //                           "readonly": 0,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": "",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "115",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "450" : "440",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "phone",
  //                           "identifier": "unique_field_identifier_15",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.vendorDropOff ? this.state.vendorDropOff.phone : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "115",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "470" : "460",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Email",
  //                           "identifier": "unique_field_identifier_16",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.vendorDropOff ? this.state.vendorDropOff.email : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "180",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "493" : "483",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "DOT Number",
  //                           "identifier": "unique_field_identifier_17",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.vendorDropOff ? this.state.vendorDropOff.dotNumber : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "180",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "515" : "505",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Contact Name",
  //                           "identifier": "unique_field_identifier_18",
  //                           "required": 0,
  //                           "readonly": 0,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "225",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "537" : "527",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Pick-up Service Level",
  //                           "identifier": "unique_field_identifier_19",
  //                           "required": 0,
  //                           "readonly": 0,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "175",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "600" : "590",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Print Name",
  //                           "identifier": "unique_field_identifier_20",
  //                           "required": 1,
  //                           "readonly": 0,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "100",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "622" : "612",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Date",
  //                           "identifier": "unique_field_identifier_21",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": String(new Date()),
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "510",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "407" : "397",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_22",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.dropOffDriver ? this.state.dropOffDriver.name : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "515",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "430" : "420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Phone",
  //                           "identifier": "unique_field_identifier_23",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.dropOffDriver ? (this.state.dropOffDriver.cellPhone ? this.state.dropOffDriver.cellPhone : this.state.dropOffDriver.directPhone) : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "515",
  //                           "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "452" : "442",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Email",
  //                           "identifier": "unique_field_identifier_24",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.dropOffDriver ? this.state.dropOffDriver.email : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "185",
  //                           "y": "682",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Company Name",
  //                           "identifier": "unique_field_identifier_25",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.flight ? this.state.flight.movement.airport.icao : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "125",
  //                           "y": "705",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Address",
  //                           "identifier": "unique_field_identifier_26",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           // "value": (this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0].physicalAddress : " ") : " ",
  //                           "value": (this.state.orderData.deliveryType == "Air") ? (this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? (this.state.destinationAirlineDetails[0].physicalAddress ? this.state.destinationAirlineDetails[0].physicalAddress : " ") : " ") : " ") : (this.state.orderData.deliveryType == "Scheduled Air" ? this.state.destinationAirCarrier.address : " "),
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "110",
  //                           "y": "728",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "City",
  //                           "identifier": "unique_field_identifier_27",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": (this.state.orderData.deliveryType == "Air") ? (this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? (this.state.destinationAirlineDetails[0].physicalCity ? this.state.destinationAirlineDetails[0].physicalCity : " ") : " ") : " ") : (this.state.orderData.deliveryType == "Scheduled Air" ? this.state.destinationAirCarrier.city : " "),
  //                           // "value": (this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0].physicalCity : " ") : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "251",
  //                           "y": "728",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "State",
  //                           "identifier": "unique_field_identifier_28",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           // "value": (this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0].physicalState : " ") : " ",
  //                           "value": (this.state.orderData.deliveryType == "Air") ? (this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? (this.state.destinationAirlineDetails[0].physicalState ? this.state.destinationAirlineDetails[0].physicalState : " ") : " ") : " ") : (this.state.orderData.deliveryType == "Scheduled Air" ? this.state.destinationAirCarrier.state : " "),
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "360",
  //                           "y": "728",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Zip",
  //                           "identifier": "unique_field_identifier_29",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": (this.state.orderData.deliveryType == "Air") ? (this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? (this.state.destinationAirlineDetails[0].physicalZip ? this.state.destinationAirlineDetails[0].physicalZip : " ") : " ") : " ") : (this.state.orderData.deliveryType == "Scheduled Air" ? this.state.destinationAirCarrier.zip : " "),
  //                           // "value": (this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0].physicalZip : " ") : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "185",
  //                           "y": "750",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Contact name",
  //                           "identifier": "unique_field_identifier_30",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "185",
  //                           "y": "770",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Contact Phone",
  //                           "identifier": "unique_field_identifier_31",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "185",
  //                           "y": "790",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Contact Email",
  //                           "identifier": "unique_field_identifier_32",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "255",
  //                           "y": "812",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_33",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "255",
  //                           "y": "836",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_34",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "255",
  //                           "y": "855",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_35",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "245",
  //                           "y": "880",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_36",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "605",
  //                           "y": "682",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_37",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.businessName,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "585",
  //                           "y": "702",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Delivery Address",
  //                           "identifier": "unique_field_identifier_38",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.address,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "510",
  //                           "y": "725",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Delivery City",
  //                           "identifier": "unique_field_identifier_39",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.city,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "760",
  //                           "y": "725",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Delivery Zip",
  //                           "identifier": "unique_field_identifier_40",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.zip,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "655",
  //                           "y": "725",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Delivery State",
  //                           "identifier": "unique_field_identifier_41",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.state,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "585",
  //                           "y": "750",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Destination Contact Name",
  //                           "identifier": "unique_field_identifier_42",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.firstName + " " + this.state.orderData.destination.firstName,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "585",
  //                           "y": "772",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Destination Contact Phone",
  //                           "identifier": "unique_field_identifier_43",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.phone,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "585",
  //                           "y": "792",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Destination Contact Email",
  //                           "identifier": "unique_field_identifier_44",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.email,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "660",
  //                           "y": "815",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Secondary Contact Name",
  //                           "identifier": "unique_field_identifier_45",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "660",
  //                           "y": "835",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Secondary Contact Phone",
  //                           "identifier": "unique_field_identifier_46",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "660",
  //                           "y": "855",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Secondary Contact Email",
  //                           "identifier": "unique_field_identifier_47",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "645",
  //                           "y": "877",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_48",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.referenceID ? this.state.orderData.destination.referenceID : " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "575",
  //                           "y": "940",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_49",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.destination.customExtraService ? this.state.orderData.destination.customExtraService : "",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "575",
  //                           "y": "965",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_50",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "205",
  //                           "y": "940",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_51",
  //                           "required": 0,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.origin.customExtraService ? this.state.orderData.origin.customExtraService : "",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "205",
  //                           "y": "965",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_52",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "70",
  //                           "y": "236",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "2",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_53",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.items[0].quantity,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "185",
  //                           "y": "965",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_54",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "70",
  //                           "y": "1400",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_55",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "70",
  //                           "y": "1420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_56",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "200",
  //                           "y": "236",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "2",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_57",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.items[0].description,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "200",
  //                           "y": "1400",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_58",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "200",
  //                           "y": "1420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_59",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "355",
  //                           "y": "236",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "2",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_60",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.items[0].weight,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "355",
  //                           "y": "1400",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_61",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "355",
  //                           "y": "1420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_62",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "430",
  //                           "y": "236",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "2",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_63",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.items[0].length,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "430",
  //                           "y": "1400",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_64",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "430",
  //                           "y": "1420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_65",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "515",
  //                           "y": "236",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "2",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_66",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.items[0].width,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "515",
  //                           "y": "1400",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_67",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "515",
  //                           "y": "1420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_68",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "590",
  //                           "y": "236",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "2",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_69",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": this.state.orderData.items[0].height,
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "590",
  //                           "y": "1400",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_70",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "590",
  //                           "y": "1420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_71",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "680",
  //                           "y": "236",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "2",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_72",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": (this.state.orderData.items[0].unNumber ? this.state.orderData.items[0].unNumber : "N/A"),
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "680",
  //                           "y": "1400",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_73",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "680",
  //                           "y": "1420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_74",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "770",
  //                           "y": "236",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "2",
  //                           "signer": "1",
  //                           "name": "Hazmat",
  //                           "identifier": "unique_field_identifier_75",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": (this.state.orderData.items[0].isHazmat ? "Yes" : "No"),
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "770",
  //                           "y": "1400",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_76",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }, {
  //                           "type": "text",
  //                           "x": "770",
  //                           "y": "1420",
  //                           "width": "300",
  //                           "height": "17",
  //                           "page": "1",
  //                           "signer": "1",
  //                           "name": "Driver name",
  //                           "identifier": "unique_field_identifier_77",
  //                           "required": 1,
  //                           "readonly": 1,
  //                           "validation_type": "",
  //                           "text_size": "",
  //                           "text_color": "",
  //                           "text_font": "",
  //                           "text_style": "",
  //                           "value": " ",
  //                           "options": [],
  //                           "group": ""
  //                         }]
  //                       ]
  //                     }
  //                     // "params": {
  //                     //   "withFlightInfoOnly": "false"
  //                     // }
  //                   })
  //                   .then((response) => {
  //                     console.log(response);
  //                     this.setState({
  //                       driverDropOffRateConURL: response.data.signers[0].embedded_signing_url,
  //                       signatureURLLoaded: true,
  //                     })
  //                     db.collection("haney-orders").doc(this.props.orderID).set({
  //                       driverDropOffRateHash: response.data.document_hash,
  //                       driverDropOffRateConURL: response.data.signers[0].embedded_signing_url,
  //                     }, { merge: true }).then(async () => {
  //                       console.log("requesting signature")

  //                       const axios = require("axios");

  //                       axios({
  //                         "method": "POST",
  //                         "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
  //                         "data": {
  //                           "sandbox": 0,
  //                           "is_draft": 0,
  //                           "embedded": 1,
  //                           "title": `Haney Freightways Alert #${this.state.orderData.freightBillNumber}`,
  //                           "message": "This is my general document message.",
  //                           "use_signer_order": 0,
  //                           "reminders": 0,
  //                           "require_all_signers": 0,
  //                           "custom_requester_name": "",
  //                           "custom_requester_email": "",
  //                           "redirect": "",
  //                           "redirect_decline": "",
  //                           "client": "",
  //                           "expires": 1750513480,
  //                           "embedded_signing_enabled": 1,
  //                           "flexible_signing": 0,
  //                           "use_hidden_tags": 0,
  //                           "files": [{
  //                             "name": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "Air Pick Up Rate Confirmation": "Ground Only Rate Confirmation",
  //                             "file_url": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FKNOWN%20Shipper%20Air%20Pick-Up%20(Origin%20to%20Airline)%20Final%206.24.2020.pdf?alt=media&token=052a4a8e-6791-43d2-9c03-41f42c90ddfd" : "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FVendor%20Driver%20Docs%2FGround%20Only%20Dispatch%20(Origin%20to%20Destination)%20Final%203.20.2020.pdf?alt=media&token=2da3c1da-541e-471b-bd6b-bb3d5c91c8a6",
  //                             "file_id": "",
  //                             "file_base64": ""
  //                           }],
  //                           "signers": [{
  //                             "id": 1,
  //                             "name": " ",
  //                             "email": this.state.vendorPickUp.email ? this.state.vendorPickUp.email : "vendoralerts@cargorx.com",
  //                             "order": 1,
  //                             // "pin": "3874",
  //                             "message": "This is my custom message to Signer.",
  //                             "deliver_email": "",
  //                             "language": "en"
  //                           }],
  //                           "recipients": [{
  //                             "name": "Vendor Alerts",
  //                             "email": "vendoralerts@cargorx.com",
  //                             "language": "en"
  //                           }],
  //                           "meta": {
  //                             "some_key": "some_value",
  //                             "another_key": "another_value"
  //                           },
  //                           "fields": [
  //                             [{
  //                               "type": "text",
  //                               "x": "120",
  //                               "y": "225",
  //                               "width": "100",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Haney Freightways Contact Name",
  //                               "identifier": "unique_field_identifier_6",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": "Kevin Kersting",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "120",
  //                               "y": "245",
  //                               "width": "100",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Haney Freightways Contact Phone",
  //                               "identifier": "unique_field_identifier_7",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": "(303) 947-3066",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "120",
  //                               "y": "268",
  //                               "width": "150",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Haney Freightways Contact Email",
  //                               "identifier": "unique_field_identifier_8",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": "kevin.kersting@cargorx.com",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "190",
  //                               "y": "297",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Haney Freightways Contact Ready Date/Time",
  //                               "identifier": "unique_field_identifier_9",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": (this.state.orderData.origin.endTimeWindow == null) ? String(this.state.orderDataNormal.origin.date ? moment(this.state.orderDataNormal.origin.date.toDate()).format('MM-DD-YYYY HH:mm') : " ") : (this.state.orderDataNormal.origin.date ? String(moment(this.state.orderDataNormal.origin.date.toDate()).format('MM-DD-YYYY')) + " " + (this.state.orderData.origin.startTimeWindow && String(this.state.orderData.origin.startTimeWindow)) : " "),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "650",
  //                               "y": "225",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Haney Freightways Contact Waybill Number",
  //                               "identifier": "unique_field_identifier_10",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData ? this.state.orderData.freightBillNumber : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "672",
  //                               "y": "295",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Haney Freightways Contact Delivery Date/Time",
  //                               "identifier": "unique_field_identifier_11",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? String(moment(this.state.orderData.origin.deliverBy).format('MM-DD-YYYY HH:mm')) : moment(this.state.orderData.serviceETA.toDate()).format('MM-DD-YYYY HH:mm'),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "180",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "555" : "545",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Carrier Total Charges",
  //                               "identifier": "unique_field_identifier_12",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "130",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "405" : "405",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Carrier Name",
  //                               "identifier": "unique_field_identifier_13",
  //                               "required": 1,
  //                               "readonly": 0,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.vendorPickUp.name ? this.state.vendorPickUp.name : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "170",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "430" : "430",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Carrier Pro Number",
  //                               "identifier": "unique_field_identifier_14",
  //                               "required": 0,
  //                               "readonly": 0,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": "",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "115",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "450" : "450",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "phone",
  //                               "identifier": "unique_field_identifier_15",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.vendorPickUp.phone ? this.state.vendorPickUp.phone : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "115",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "470" : "470",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Email",
  //                               "identifier": "unique_field_identifier_16",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.vendorPickUp.email ? this.state.vendorPickUp.email : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "180",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "493" : "493",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "DOT Number",
  //                               "identifier": "unique_field_identifier_17",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.vendorPickUp.dotNumber ? this.state.vendorPickUp.dotNumber : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "180",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "515" : "515",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Contact Name",
  //                               "identifier": "unique_field_identifier_18",
  //                               "required": 0,
  //                               "readonly": 0,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "225",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "537" : "537",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Pick-up Service Level",
  //                               "identifier": "unique_field_identifier_19",
  //                               "required": 0,
  //                               "readonly": 0,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": "",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "510",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "407" : "407",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_22",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.pickUpDriver ? this.state.pickUpDriver.name : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "515",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "430" : "430",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Phone",
  //                               "identifier": "unique_field_identifier_23",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.pickUpDriver ? (this.state.pickUpDriver.cellPhone ? this.state.pickUpDriver.cellPhone : this.state.pickUpDriver.directPhone) : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "515",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "452" : "452",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Email",
  //                               "identifier": "unique_field_identifier_24",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.pickUpDriver ? this.state.pickUpDriver.email : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "535" : "515",
  //                               "y": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "474" : "474",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Email",
  //                               "identifier": "unique_field_identifier_78",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.pickUpDriver ? (this.state.pickUpDriver.sta && ('STA: ' + this.state.pickUpDriver.sta)) : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "185",
  //                               "y": "672",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Company Name",
  //                               "identifier": "unique_field_identifier_25",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.businessName,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "125",
  //                               "y": "695",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Address",
  //                               "identifier": "unique_field_identifier_26",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.address,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "110",
  //                               "y": "718",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "City",
  //                               "identifier": "unique_field_identifier_27",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.city,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "251",
  //                               "y": "718",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "State",
  //                               "identifier": "unique_field_identifier_28",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.state,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "360",
  //                               "y": "718",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Zip",
  //                               "identifier": "unique_field_identifier_29",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.zip,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "185",
  //                               "y": "740",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Contact name",
  //                               "identifier": "unique_field_identifier_30",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": (this.state.orderData.origin.firstName ? this.state.orderData.origin.firstName : " ") + " " + (this.state.orderData.origin.lastName ? this.state.orderData.origin.lastName : " "),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "185",
  //                               "y": "760",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Contact Phone",
  //                               "identifier": "unique_field_identifier_31",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.phone ? this.state.orderData.origin.phone : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "185",
  //                               "y": "780",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Contact Email",
  //                               "identifier": "unique_field_identifier_32",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.email ? this.state.orderData.origin.email : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "255",
  //                               "y": "802",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_33",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "255",
  //                               "y": "826",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_34",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "255",
  //                               "y": "845",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_35",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "245",
  //                               "y": "870",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_36",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.referenceID ? this.state.orderData.origin.referenceID : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "605",
  //                               "y": "870",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_81",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.destination.referenceID ? this.state.orderData.destination.referenceID : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "605",
  //                               "y": "672",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_37",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air") ? ((this.state.flight ? (this.state.flight.airline && this.state.flight.airline.name) : " ") + " " + (this.state.flight ? this.state.flight.originAirport : " ")) : (this.state.orderData.deliveryType == "Scheduled Air" ? (this.state.originAirCarrier.businessName + this.state.originAirCarrier.airCode) : this.state.orderData.destination.businessName)),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "585",
  //                               "y": "692",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Delivery Address",
  //                               "identifier": "unique_field_identifier_38",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": (this.state.orderData.deliveryType == "Air") ? (this.state.originAirlineDetails ? (this.state.originAirlineDetails[0] ? (this.state.originAirlineDetails[0].physicalAddress ? this.state.originAirlineDetails[0].physicalAddress : " ") : " ") : " ") : ((this.state.orderData.deliveryType == "Scheduled Air") ? this.state.originAirCarrier.address : this.state.orderData.destination.address),
  //                               // "value": (this.state.orderData.deliveryType == "Air") ? (this.state.originAirlineDetails ? (this.state.originAirlineDetails[0] ? (this.state.originAirlineDetails[0].cargorxAccountNumber ? this.state.originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ") : (this.state.orderData.deliveryType == "Scheduled Air" ? this.state.originAirCarrier.cargorxAccountNumber : " "),
  //                               // "value": ((this.state.orderData.deliveryType == "Air") ? (this.state.orderData.deliveryType == "Scheduled Air" ? (this.state.originAirCarrier.address) : this.state.originAirlineDetails[0].physicalAddress) : this.state.orderData.destination.address),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "510",
  //                               "y": "715",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Delivery City",
  //                               "identifier": "unique_field_identifier_39",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air") ? (this.state.orderData.deliveryType == "Scheduled Air" ? (this.state.originAirCarrier.city) : this.state.orderData.destination.city) : this.state.orderData.destination.city),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "760",
  //                               "y": "715",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Delivery Zip",
  //                               "identifier": "unique_field_identifier_40",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air") ? (this.state.orderData.deliveryType == "Scheduled Air" ? (this.state.originAirCarrier.zip) : this.state.orderData.destination.zip) : this.state.orderData.destination.zip),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "655",
  //                               "y": "715",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Delivery State",
  //                               "identifier": "unique_field_identifier_41",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air") ? (this.state.orderData.deliveryType == "Scheduled Air" ? (this.state.originAirCarrier.state) : this.state.orderData.destination.state) : this.state.orderData.destination.state),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "585",
  //                               "y": "740",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Destination Contact Name",
  //                               "identifier": "unique_field_identifier_42",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? " " : (this.state.orderData.destination.firstName + " " + this.state.orderData.destination.firstName)),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "585",
  //                               "y": "762",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Destination Contact Phone",
  //                               "identifier": "unique_field_identifier_43",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? " " : this.state.orderData.destination.phone),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "585",
  //                               "y": "782",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Destination Contact Email",
  //                               "identifier": "unique_field_identifier_44",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? " " : this.state.orderData.destination.email),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "660",
  //                               "y": "805",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Secondary Contact Name",
  //                               "identifier": "unique_field_identifier_45",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "660",
  //                               "y": "825",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Secondary Contact Phone",
  //                               "identifier": "unique_field_identifier_46",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "660",
  //                               "y": "845",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Secondary Contact Email",
  //                               "identifier": "unique_field_identifier_47",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "645",
  //                               "y": "867",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_48",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "575",
  //                               "y": "930",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_49",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.destination.customExtraService ? this.state.orderData.destination.customExtraService : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "575",
  //                               "y": "955",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_50",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "205",
  //                               "y": "930",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_51",
  //                               "required": 0,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.origin.customExtraService ? this.state.orderData.origin.customExtraService : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "205",
  //                               "y": "955",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_52",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "70",
  //                               "y": "236",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_53",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[0].quantity,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "185",
  //                               "y": "955",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "1",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_54",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "70",
  //                               "y": "256",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_55",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[1] ? this.state.orderData.items[1].quantity : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "70",
  //                               "y": "276",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_56",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[2] ? this.state.orderData.items[2].quantity : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "200",
  //                               "y": "236",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_57",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[0].description,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "200",
  //                               "y": "256",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_58",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[1] ? this.state.orderData.items[1].description : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "200",
  //                               "y": "276",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_59",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[2] ? this.state.orderData.items[2].description : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "355",
  //                               "y": "236",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_60",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[0].weight,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "355",
  //                               "y": "256",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_61",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[1] ? this.state.orderData.items[1].weight : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "355",
  //                               "y": "276",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_62",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[2] ? this.state.orderData.items[2].weight : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "430",
  //                               "y": "236",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_63",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[0].length,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "430",
  //                               "y": "256",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_64",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[1] ? this.state.orderData.items[1].length : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "430",
  //                               "y": "276",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_65",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[2] ? this.state.orderData.items[2].length : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "515",
  //                               "y": "236",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_66",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[0].width,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "515",
  //                               "y": "256",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_67",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[1] ? this.state.orderData.items[1].width : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "515",
  //                               "y": "276",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_68",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[2] ? this.state.orderData.items[2].width : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "590",
  //                               "y": "236",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_69",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[0].height,
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "590",
  //                               "y": "256",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_70",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[1] ? this.state.orderData.items[1].height : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "590",
  //                               "y": "276",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_71",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[2] ? this.state.orderData.items[2].height : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "680",
  //                               "y": "236",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_72",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": (this.state.orderData.items[0].unNumber ? this.state.orderData.items[0].unNumber : " "),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "680",
  //                               "y": "256",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_73",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[1] ? (this.state.orderData.items[1].unNumber ? this.state.orderData.items[1].unNumber : " ") : (" "),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "680",
  //                               "y": "276",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_74",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[2] ? (this.state.orderData.items[2].unNumber ? this.state.orderData.items[2].unNumber : " ") : (" "),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "770",
  //                               "y": "236",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Hazmat",
  //                               "identifier": "unique_field_identifier_75",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": (this.state.orderData.items[0].isHazmat ? "Yes" : "No"),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "770",
  //                               "y": "256",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_76",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[1] ? (this.state.orderData.items[1].isHazmat ? "Yes" : "No") : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "770",
  //                               "y": "276",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Driver name",
  //                               "identifier": "unique_field_identifier_77",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": this.state.orderData.items[2] ? (this.state.orderData.items[2].isHazmat ? "Yes" : "No") : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "145",
  //                               "y": "600",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Destination Contact Phone",
  //                               "identifier": "unique_field_identifier_80",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? " " : ((this.state.orderData.items[0] ? Number(this.state.orderData.items[0].declaredValue) : 0) + (this.state.orderData.items[1] ? Number(this.state.orderData.items[1].declaredValue) : 0) + (this.state.orderData.items[2] ? Number(this.state.orderData.items[2].declaredValue) : 0) + (this.state.orderData.items[3] ? Number(this.state.orderData.items[3].declaredValue) : 0))),
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "155",
  //                               "y": "605",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Destination Contact Phone",
  //                               "identifier": "unique_field_identifier_82",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": (this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? (this.state.pickUpDriver ? this.state.pickUpDriver.name : " ") : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }, {
  //                               "type": "text",
  //                               "x": "105",
  //                               "y": "620",
  //                               "width": "300",
  //                               "height": "17",
  //                               "page": "2",
  //                               "signer": "1",
  //                               "name": "Destination Contact Phone",
  //                               "identifier": "unique_field_identifier_83",
  //                               "required": 1,
  //                               "readonly": 1,
  //                               "validation_type": "",
  //                               "text_size": "",
  //                               "text_color": "",
  //                               "text_font": "",
  //                               "text_style": "",
  //                               "value": (this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? String(new Date()) : " ",
  //                               "options": [],
  //                               "group": ""
  //                             }]
  //                           ]
  //                         }
  //                         // "params": {
  //                         //   "withFlightInfoOnly": "false"
  //                         // }
  //                       })
  //                       .then((response) => {
  //                         console.log(response);
  //                         this.setState({
  //                           driverPickUpRateConURL: response.data.signers[0].embedded_signing_url,
  //                           signatureURLLoaded: true,

  //                         })
  //                         db.collection("haney-orders").doc(this.props.orderID).set({
  //                           driverPickUpRateConHash: response.data.document_hash,
  //                           driverPickUpRateConURL: response.data.signers[0].embedded_signing_url,
  //                           // flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
  //                           // flight: this.state.flight ? this.state.flight : (this.state.orderData.flight ? this.state.orderData.flight : null),
  //                           // originAirport: this.state.originAirport ? this.state.originAirport : null,
  //                           // originAirCarrier: this.state.originAirCarrier ? this.state.originAirCarrier : null,
  //                           // destinationAirCarrier: this.state.destinationAirCarrier ? this.state.destinationAirCarrier : null,
  //                           // destinationAirport: this.state.destinationAirport ? this.state.destinationAirport : null,
  //                           // driverPickUpName: this.state.pickUpDriverName ? this.state.pickUpDriverName : null,
  //                           // driverPickUpID: this.state.pickUpDriverID ? this.state.pickUpDriverID : null,
  //                           // vendorPickUpName: this.state.vendorPickUp ? this.state.vendorPickUp.name : null,
  //                           // vendorPickUpID: this.state.vendorPickUp ? this.state.vendorPickUp.id : null,
  //                           // driverDropOffName: this.state.dropOffDriverName ? this.state.dropOffDriverName : null,
  //                           // driverDropOffID: this.state.dropOffDriverID ? this.state.dropOffDriverID : null,
  //                           // vendorDropOffName: this.state.vendorDropOff ? this.state.vendorDropOff.name : null,
  //                           // vendorDropOffID: this.state.vendorDropOff ? this.state.vendorDropOff.id : null,
  //                           // pickUpRate: this.state.pickUpRate ? this.state.pickUpRate : null,
  //                           // pickUpRateStatus: "unconfirmed",
  //                           // dropOffRate: this.state.dropOffRate ? this.state.dropOffRate : null, 
  //                           // dropOffRateStatus: "unconfirmed",
  //                           // status: "Dispatched",
  //                           // dispatcherID: this.props.authUser.uid,
  //                           // dispatcherEmail: this.props.user.email,
  //                           // dispatcherAssigned: new Date(),
  //                           // dispatchedAt: new Date(),
  //                           // origin: this.state.origin,
  //                           // destination: this.state.destination,
  //                           // bookingNumber: this.state.bookingNumber ? this.state.bookingNumber : null,
  //                           // airWaybillNumber: this.state.airWaybillNumber ? this.state.airWaybillNumber : null,
  //                           // serviceLevel: this.state.serviceLevel ? this.state.serviceLevel : null                      
  //                         }, { merge: true }).then(async () => {
  //                           console.log("requesting signature")

  //                           const axios = require("axios");

  //                           axios({
  //                             "method": "POST",
  //                             "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
  //                             "data": {
  //                               "sandbox": 0,
  //                               "is_draft": 0,
  //                               "embedded": 1,
  //                               "title": `Haney Freightways Alert #${this.state.orderData.freightBillNumber}`,
  //                               "message": "This is my general document message.",
  //                               "use_signer_order": 0,
  //                               "reminders": 0,
  //                               "require_all_signers": 0,
  //                               "custom_requester_name": "",
  //                               "custom_requester_email": "",
  //                               "redirect": "",
  //                               "redirect_decline": "",
  //                               "client": "",
  //                               "expires": 1750513480,
  //                               "embedded_signing_enabled": 1,
  //                               "flexible_signing": 0,
  //                               "use_hidden_tags": 0,
  //                               "files": [{
  //                                 "name": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "Air Pick Up Rate Confirmation": "Ground Only Rate Confirmation",
  //                                 "file_url": ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) ? "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIdentification%20Validation%20Form%206.20.2020.pdf?alt=media&token=a3a9a0cc-b514-4865-a284-ce63ae5477fa" : "https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIdentification%20Validation%20Form%206.20.2020.pdf?alt=media&token=a3a9a0cc-b514-4865-a284-ce63ae5477fa",
  //                                 "file_id": "",
  //                                 "file_base64": ""
  //                               }],
  //                               "signers": [{
  //                                 "id": 1,
  //                                 "name": "Pick Up Driver",
  //                                 "email": "justin@pondata.co",
  //                                 "order": 1,
  //                                 // "pin": "3874",
  //                                 "message": "This is my custom message to Signer.",
  //                                 "deliver_email": "",
  //                                 "language": "en"
  //                               }],
  //                               "recipients": [{
  //                                 "name": "Vendor Alerts",
  //                                 "email": "vendoralerts@cargorx.com",
  //                                 "language": "en"
  //                               }],
  //                               "meta": {
  //                                 "some_key": "some_value",
  //                                 "another_key": "another_value"
  //                               },
  //                               "fields": [
  //                                 [
  //                                 //   {
  //                                 //   "type": "dropdown",
  //                                 //   "x": "500",
  //                                 //   "y": "225",
  //                                 //   "width": "55",
  //                                 //   "height": "17",
  //                                 //   "page": "1",
  //                                 //   "signer": "OWNER",
  //                                 //   "name": "ID TYPE",
  //                                 //   "identifier": "unique_field_identifier_1",
  //                                 //   "required": 1,
  //                                 //   "readonly": 0,
  //                                 //   "text_size": 16,
  //                                 //   "text_color": "#FF0000",
  //                                 //   "text_font": "arial",
  //                                 //   "text_style": "BUI",
  //                                 //   "validation_type": "",
  //                                 //   "value": " ",
  //                                 //   "options": [
  //                                 //     "Government Issued",
  //                                 //     "Company Issued"
  //                                 //   ]
  //                                 // },
  //                                 {
  //                                   "type": "text",
  //                                   "x": "500",
  //                                   "y": "225",
  //                                   "width": "300",
  //                                   "height": "17",
  //                                   "page": "1",
  //                                   "signer": "1",
  //                                   "name": "ID TYPE",
  //                                   "identifier": "unique_field_identifier_1",
  //                                   "required": 1,
  //                                   "readonly": 0,
  //                                   "validation_type": "",
  //                                   "text_size": "",
  //                                   "text_color": "",
  //                                   "text_font": "",
  //                                   "text_style": "",
  //                                   "value": " ",
  //                                   "options": [],
  //                                   "group": ""
  //                                 },
  //                                 // {
  //                                 //   "type": "dropdown",
  //                                 //   "x": "540",
  //                                 //   "y": "273",
  //                                 //   "width": "55",
  //                                 //   "height": "17",
  //                                 //   "page": "1",
  //                                 //   "signer": "OWNER",
  //                                 //   "name": "Matching Photo on ID?",
  //                                 //   "identifier": "unique_field_identifier_2",
  //                                 //   "required": 1,
  //                                 //   "readonly": 0,
  //                                 //   "text_size": 16,
  //                                 //   "text_color": "#FF0000",
  //                                 //   "text_font": "arial",
  //                                 //   "text_style": "BUI",
  //                                 //   "validation_type": "",
  //                                 //   "value": " ",
  //                                 //   "options": [
  //                                 //     "Yes",
  //                                 //     "No"
  //                                 //   ]
  //                                 // },
  //                                 {
  //                                   "type": "text",
  //                                   "x": "500",
  //                                   "y": "273",
  //                                  "width": "300",
  //                                   "height": "17",
  //                                   "page": "1",
  //                                   "signer": "1",
  //                                   "name": "Matching Photo on ID?",
  //                                   "identifier": "unique_field_identifier_2",
  //                                   "required": 1,
  //                                   "readonly": 0,
  //                                   "validation_type": "",
  //                                   "text_size": "",
  //                                   "text_color": "",
  //                                   "text_font": "",
  //                                   "text_style": "",
  //                                   "value": " ",
  //                                   "options": [],
  //                                   "group": ""
  //                                 },
  //                                 // {
  //                                 //   "type": "dropdown",
  //                                 //   "x": "540",
  //                                 //   "y": "357",
  //                                 //   "width": "55",
  //                                 //   "height": "17",
  //                                 //   "page": "1",
  //                                 //   "signer": "OWNER",
  //                                 //   "name": "Matching Photo on ID?",
  //                                 //   "identifier": "unique_field_identifier_3",
  //                                 //   "required": 1,
  //                                 //   "readonly": 0,
  //                                 //   "text_size": 16,
  //                                 //   "text_color": "#FF0000",
  //                                 //   "text_font": "arial",
  //                                 //   "text_style": "BUI",
  //                                 //   "validation_type": "",
  //                                 //   "value": " ",
  //                                 //   "options": [
  //                                 //     "Yes",
  //                                 //     "No"
  //                                 //   ]
  //                                 // }, 
  //                                 {
  //                                   "type": "text",
  //                                   "x": "500",
  //                                   "y": "357",
  //                                  "width": "300",
  //                                   "height": "17",
  //                                   "page": "1",
  //                                   "signer": "1",
  //                                   "name": "Matching Photo on ID?",
  //                                   "identifier": "unique_field_identifier_3",
  //                                   "required": 1,
  //                                   "readonly": 0,
  //                                   "validation_type": "",
  //                                   "text_size": "",
  //                                   "text_color": "",
  //                                   "text_font": "",
  //                                   "text_style": "",
  //                                   "value": " ",
  //                                   "options": [],
  //                                   "group": ""
  //                                 },
  //                                 // {
  //                                 //   "type": "checkbox",
  //                                 //   "x": "562",
  //                                 //   "y": "273",
  //                                 //   "width": "14",
  //                                 //   "height": "14",
  //                                 //   "page": "1",
  //                                 //   "signer": "OWNER",
  //                                 //   "name": "Matching Photo on ID?",
  //                                 //   "identifier": "unique_field_identifier_37",
  //                                 //   "required": 1,
  //                                 //   "readonly": 0,
  //                                 //   "validation_type": "",
  //                                 //   "value": 0,
  //                                 //   "options": [],
  //                                 //   "group": ""
  //                                 // }, 
  //                                 // {
  //                                 //   "type": "checkbox",
  //                                 //   "x": "640",
  //                                 //   "y": "265",
  //                                 //   "width": "14",
  //                                 //   "height": "14",
  //                                 //   "page": "1",
  //                                 //   "signer": "OWNER",
  //                                 //   "name": "Freight Charge Terms Prepaid",
  //                                 //   "identifier": "unique_field_identifier_38",
  //                                 //   "required": 1,
  //                                 //   "readonly": 0,
  //                                 //   "validation_type": "",
  //                                 //   "value": 0,
  //                                 //   "options": [],
  //                                 //   "group": ""
  //                                 // }, 
  //                                 {
  //                                   "type": "text",
  //                                   "x": "500",
  //                                   "y": "310",
  //                                   "width": "300",
  //                                   "height": "17",
  //                                   "page": "1",
  //                                   "signer": "1",
  //                                   "name": "type of id reviewed",
  //                                   "identifier": "unique_field_identifier_4",
  //                                   "required": 1,
  //                                   "readonly": 0,
  //                                   "validation_type": "",
  //                                   "text_size": "",
  //                                   "text_color": "",
  //                                   "text_font": "",
  //                                   "text_style": "",
  //                                   "value": " ",
  //                                   "options": [],
  //                                   "group": ""
  //                                 }, 
  //                                 // {
  //                                 //   "type": "checkbox",
  //                                 //   "x": "560",
  //                                 //   "y": "355",
  //                                 //   "width": "14",
  //                                 //   "height": "14",
  //                                 //   "page": "1",
  //                                 //   "signer": "OWNER",
  //                                 //   "name": "Freight Charge Terms Prepaid",
  //                                 //   "identifier": "unique_field_identifier_5",
  //                                 //   "required": 1,
  //                                 //   "readonly": 0,
  //                                 //   "validation_type": "",
  //                                 //   "value": 0,
  //                                 //   "options": [],
  //                                 //   "group": ""
  //                                 // }, {
  //                                 //   "type": "checkbox",
  //                                 //   "x": "6000",
  //                                 //   "y": "355",
  //                                 //   "width": "14",
  //                                 //   "height": "14",
  //                                 //   "page": "1",
  //                                 //   "signer": "OWNER",
  //                                 //   "name": "Freight Charge Terms Prepaid",
  //                                 //   "identifier": "unique_field_identifier_6",
  //                                 //   "required": 1,
  //                                 //   "readonly": 0,
  //                                 //   "validation_type": "",
  //                                 //   "value": 0,
  //                                 //   "options": [],
  //                                 //   "group": ""
  //                                 // }, 
  //                                 {
  //                                   "type": "text",
  //                                   "x": "500",
  //                                   "y": "410",
  //                                   "width": "300",
  //                                   "height": "17",
  //                                   "page": "1",
  //                                   "signer": "1",
  //                                   "name": "printed name",
  //                                   "identifier": "unique_field_identifier_9",
  //                                   "required": 1,
  //                                   "readonly": 0,
  //                                   "validation_type": "",
  //                                   "text_size": "",
  //                                   "text_color": "",
  //                                   "text_font": "",
  //                                   "text_style": "",
  //                                   "value": " ",
  //                                   "options": [],
  //                                   "group": ""
  //                                 }, {
  //                                   "type": "text",
  //                                   "x": "500",
  //                                   "y": "460",
  //                                   "width": "300",
  //                                   "height": "17",
  //                                   "page": "1",
  //                                   "signer": "1",
  //                                   "name": "shipper company name",
  //                                   "identifier": "unique_field_identifier_8",
  //                                   "required": 1,
  //                                   "readonly": 0,
  //                                   "validation_type": "",
  //                                   "text_size": "",
  //                                   "text_color": "",
  //                                   "text_font": "",
  //                                   "text_style": "",
  //                                   "value": " ",
  //                                   "options": [],
  //                                   "group": ""
  //                                 }, {
  //                                   "type": "text",
  //                                   "x": "500",
  //                                   "y": "510",
  //                                   "width": "300",
  //                                   "height": "17",
  //                                   "page": "1",
  //                                   "signer": "1",
  //                                   "name": "name of the iac employee",
  //                                   "identifier": "unique_field_identifier_10",
  //                                   "required": 1,
  //                                   "readonly": 0,
  //                                   "validation_type": "",
  //                                   "text_size": "",
  //                                   "text_color": "",
  //                                   "text_font": "",
  //                                   "text_style": "",
  //                                   "value": " ",
  //                                   "options": [],
  //                                   "group": ""
  //                                 }
  //                                 ]
  //                               ]
  //                             }
  //                             // "params": {
  //                             //   "withFlightInfoOnly": "false"
  //                             // }
  //                           })
  //                           .then((response) => {
  //                             console.log(response);
  //                             this.setState({
  //                               driverIVFURL: response.data.signers[0].embedded_signing_url,
  //                               signatureURLLoaded: true,

  //                             })
  //                             db.collection("haney-orders").doc(this.props.orderID).set({
  //                               driverIVF: response.data.document_hash,
  //                               driverIVFURL: response.data.signers[0].embedded_signing_url,
  //                               flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
  //                               flight: this.state.flight ? this.state.flight : (this.state.orderData.flight ? this.state.orderData.flight : null),
  //                               originAirlineDetails: this.state.originAirlineDetails ? this.state.originAirlineDetails : null,
  //                               originAirport: this.state.originAirport ? this.state.originAirport : null,
  //                               originAirCarrier: this.state.originAirCarrier ? this.state.originAirCarrier : null,
  //                               destinationAirlineDetails: this.state.destinationAirlineDetails ? this.state.destinationAirlineDetails : null,
  //                               destinationAirCarrier: this.state.destinationAirCarrier ? this.state.destinationAirCarrier : null,
  //                               destinationAirport: this.state.destinationAirport ? this.state.destinationAirport : null,
  //                               driverPickUp: this.state.driverPickUp ? this.state.driverPickUp : null,
  //                               driverPickUpName: this.state.pickUpDriverName ? this.state.pickUpDriverName : null,
  //                               driverPickUpEmail: this.state.pickUpDriverEmail ? this.state.pickUpDriverEmail : null,
  //                               driverPickUpID: this.state.pickUpDriverID ? this.state.pickUpDriverID : null,
  //                               vendorPickUp: this.state.vendorPickUp ? this.state.vendorPickUp : null,
  //                               vendorPickUpName: this.state.vendorPickUp ? this.state.vendorPickUp.name : null,
  //                               vendorPickUpID: this.state.vendorPickUp ? this.state.vendorPickUp.id : null,
  //                               driverDropOff: this.state.dropOffDriver ? this.state.dropOffDriver : null,
  //                               driverDropOffName: this.state.dropOffDriverName ? this.state.dropOffDriverName : null,
  //                               driverDropOffID: this.state.dropOffDriverID ? this.state.dropOffDriverID : null,
  //                               vendorDropOffName: this.state.vendorDropOff ? this.state.vendorDropOff.name : null,
  //                               vendorDropOffID: this.state.vendorDropOff ? this.state.vendorDropOff.id : null,
  //                               pickUpRate: this.state.pickUpRate ? this.state.pickUpRate : null,
  //                               pickUpRateStatus: "unconfirmed",
  //                               dropOffRate: this.state.dropOffRate ? this.state.dropOffRate : null, 
  //                               dropOffRateStatus: "unconfirmed",
  //                               status: "Dispatched",
  //                               dispatcherID: this.props.authUser.uid,
  //                               dispatcherEmail: this.props.user.email,
  //                               dispatcherAssigned: new Date(),
  //                               dispatchedAt: new Date(),
  //                               origin: this.state.origin,
  //                               destination: this.state.destination,
  //                               bookingNumber: this.state.bookingNumber ? this.state.bookingNumber : null,
  //                               airWaybillNumber: this.state.airWaybillNumber ? this.state.airWaybillNumber : null,
  //                               serviceLevel: this.state.serviceLevel ? this.state.serviceLevel : null                      
  //                             }, { merge: true })
  //                           }, (error) => {
  //                             console.log(error);
  //                           }).then(async () => {
  //                             console.log(this.state.orderData.origin.email)
  //                             //const email = this.props.user.email

  //                             let subject = `Haney Freightways #${this.state.orderData.freightBillNumber} Shipping Documents - Your Signature May be Required!`
  //                             let html = `<p>Thank you very much for shipping with Haney Freightways! Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`
  //                             html += `<p><b>Using Haney Freightways Customer App</b></p>`
  //                             html += `<p>The button below will take you to the Haney Freightways Customer Application.  If you don’t have a login yet, simply request one via shipping@cargorx.com.  We’ll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`
  //                             html += `<p>- All Haney Freightways orders involving your company will be isible by click "Orders" on the menu bar</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="100">`
  //                             html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=ee9e7f64-b731-4919-b6b3-2d1ffae42f6f" height="100">`
  //                             html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents and access the e-sign version if you’ll be signing as the shipper contact.  If you aren’t signing as the shipper contact, the driver will have an e-signature version of the shipping document on his or her phonefor the shipping contact to sign.</p>`
  //                             html += `<p>- You can also use the Customer App to track your shipments – certain shipment types allow you to see the driver’s location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`
  //                             html += `<p>- <b>New Transactions:</b> If you don’t have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>– you’ll be asked to complete certain missing fields later when you select and book your shipping option.</p>`
  //                             html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing – you won’t be asked for any missing information later when you select and book a shipping option.</p>`
  //                             html += `<a href="https://haney-freightways-customer.web.app"><button>Customer App</button></a>`
  //                             html += `<p><b>E-Document and e-Signature Link</b></p>`
  //                             html += `<p>If you aren’t able to access the customer application but did receive this message, you can access your electronic document using the link below.<p>`
  //                             html += `<p>The <b>${((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (thedriver), and the shipper to sign.</p>`
  //                             html += `<p>- To sign as the <b>Shipper</b>, please <a href="${this.state.signingURL1}">click here</a></p>`
  //                             html += `<p>Thanks for the opportunity to serve your company!</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
  //                             html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //                             // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //                             const emails = [this.state.orderData.origin.email, "customeralerts@cargorx.com", "justin@pondata.com"]
  //                             const attatchment = true;
  //                             const emailReturn = await sendEmail({
  //                               emails,
  //                               subject,
  //                               html,
  //                               attatchment
  //                             })

  //                           }).then(async () => {
  //                             console.log(this.state.pickUpDriverEmail)
  //                             //const email = this.props.user.email

  //                             let subject = `Haney Freightways #${this.state.orderData.freightBillNumber} Shipping Documents - Please Get Signatures!`
  //                             let html = `<p>Thank you for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures.</p>`
  //                             html += `<p><b>Using Vendor Dispatch App</b></p>`
  //                             html += `<p>The button below will take you to the Haney Freightways Vendor Dispatcher Application. If you don't have a login yet, simply request one via shipping@cargorx.com. We'll send a link via email and text, which will allow you to log right in. If you have a profile click the button below, log in, and access the following:</p>`
  //                             html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="100">`
  //                             html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=ee9e7f64-b731-4919-b6b3-2d1ffae42f6f" height="100">`
  //                             html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents including the completed e-sign docs once all parties have signed – our preference is for the driver to obtain e-signatures, but we understand that paper might be necessary.  The driver is able to upload pictures of paper documents through the driver application and we send the driver a link to this app if we have the driver’s information when we dispatch the shipment.</p>`
  //                             html += `<p>- Within the shipment summary page, you will see a button the says “Confirm Rate” – if the Status above the button says “unconfirmed” in red text, please click on the button and e-sign the confirmation – if the status says “confirmed” in green text above the button, someone has already confirmed the rate.</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.40.04%20PM.png?alt=media&token=9fc33ea6-f2f4-4d8b-9d17-8e573f943592" height="100">`
  //                             html += `<p><b>Call 833-227-4679 for answers to any questions you have – we’re here for you!</b></p>`
  //                             html += `<a href="https://haney-freightways-vendor.web.app"><button>Vendor App</button></a>`
  //                             html += `<p><b>E-Document and e-Signature Link</b></p>`
  //                             html += `<p>If a driver wasn’t assigned at the time of dispatch, a driver was assigned but they didn’t receive our dispatch alert, or a new driver is being used to complete some part of this job for your company, they can access the electronic documents and e-signatures by using the links below.  You simply need to forward the applicable link(s) below to the appropriate driver.</p>`
  //                             html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. As the driver, you must <a href=${this.state.driverPickUpRateConURL}>click here</a> to view and complete the applicable TSA verification.</p>`
  //                             html += `<p>The <b>${((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (thedriver), and the shipper to sign.</p>`
  //                             html += `<p>- To sign as the <b>pick-up driver</b>, please <a href="${this.state.signingURL2}">click here</a></p>`
  //                             html += `<p>- To sign as the <b>shipper</b>, please <a href="${this.state.signingURL1}">click here</a></p>`
  //                             html += `<p>- To sign as the <b>consignee</b>, please <a href="${this.state.signingURL3}">click here</a></p>`
  //                             if ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) {
  //                             html += `<p>The <b>Sample Airline Waybill</b> has been prefilled with all the necessary information to allow for a successful tender.  You can use this sample to fill out the actual waybill, or print and use for tender with the airline.  Please <a href="${this.state.signingSampleWaybillURL}">view here</a></p>`
  //                             html += `<p>The <b>IAC Certificate</b> must be printed and tendered to the airline along with the waybill and freight. Please <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIAC%20Certificate%2011.8.2019%20(1).pdf?alt=media&token=4cc64b5d-d5cf-4627-b223-d099d8b6edab">view here</a></p>`
  //                             }
  //                             if ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options")) {
  //                               html += `<p>Please click the following link to have the consignee sign the <b>Bill of Lading</b> once they have agreed to take delivery: <a href="${this.state.signingURL3}">Sign Here</a></p>`
  //                               html += `<p>If the consignee has already signed, you will be notified as such when you click the consignee signature link.<p>`
  //                             }
  //                             if (!this.state.orderData.origin.ksms && this.state.orderData.deliveryType == "Air") {
  //                               html += `<p>If you’ve received the Identification Validation Form it’s because the shipper is unknown to TSA and this form must be completed. Please <a href="${this.state.driverIVFURL}">click here</a> and complete the form.</p>`
  //                             }
  //                             html += `<p>Thanks, and be safe out there!<p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
  //                             html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //                             // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //                             const emails = [(this.state.vendorPickUp.email && this.state.vendorPickUp.email), "vendoralerts@cargorx.com", "justin@pondata.com"]
  //                             const attatchment = true;
  //                             const emailReturn = await sendEmail({
  //                               emails,
  //                               subject,
  //                               html,
  //                               attatchment
  //                             })

  //                           }).then(async () => {
  //                             console.log(this.state.pickUpDriverEmail)
  //                             //const email = this.props.user.email

  //                             let subject = `Haney Freightways #${this.state.orderData.freightBillNumber} Shipping Documents - Please Get Signatures!`
  //                             let html = `<p>Thank you for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures.</p>`
  //                             html += `<p><b>E-Document and e-Signature Link</b></p>`
  //                             html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. As the driver, you must <a href=${this.state.driverPickUpRateConURL}>click here</a> to view and complete the applicable TSA verification.</p>`
  //                             html += `<p>The <b>${((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (thedriver), and the shipper to sign.</p>`
  //                             html += `<p>- To sign as the <b>pick-up driver</b>, please <a href="${this.state.signingURL2}">click here</a></p>`
  //                             html += `<p>- To sign as the <b>shipper</b>, please <a href="${this.state.signingURL1}">click here</a></p>`
  //                             html += `<p>- To sign as the <b>consignee</b>, please <a href="${this.state.signingURL3}">click here</a></p>`
  //                             if ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) {
  //                             html += `<p>The <b>Sample Airline Waybill</b> has been prefilled with all the necessary information to allow for a successful tender.  You can use this sample to fill out the actual waybill, or print and use for tender with the airline.  Please <a href="${this.state.signingSampleWaybillURL}">view here</a></p>`
  //                             html += `<p>The <b>IAC Certificate</b> must be printed and tendered to the airline along with the waybill and freight. Please <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIAC%20Certificate%2011.8.2019%20(1).pdf?alt=media&token=4cc64b5d-d5cf-4627-b223-d099d8b6edab">view here</a></p>`
  //                             }
  //                             if ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options")) {
  //                               html += `<p>Please click the following link to have the consignee sign the <b>Bill of Lading</b> once they have agreed to take delivery: <a href="${this.state.signingURL3}">Sign Here</a></p>`
  //                               html += `<p>If the consignee has already signed, you will be notified as such when you click the consignee signature link.<p>`
  //                             }
  //                             if (!this.state.orderData.origin.ksms && this.state.orderData.deliveryType == "Air") {
  //                               html += `<p>If you’ve received the Identification Validation Form it’s because the shipper is unknown to TSA and this form must be completed. Please <a href="${this.state.driverIVFURL}">click here</a> and complete the form.</p>`
  //                             }
  //                             html += `<p>Thanks, and be safe out there!<p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`
  //                             html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //                             // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //                             const emails = [(this.state.pickUpDriverEmail && this.state.pickUpDriverEmail), "vendoralerts@cargorx.com", "justin@pondata.com"]
  //                             const attatchment = true;
  //                             const emailReturn = await sendEmail({
  //                               emails,
  //                               subject,
  //                               html,
  //                               attatchment
  //                             })

  //                           }).then(async () => {
  //                             console.log("texting driver")
  //                             // console.log(this.state.authInfo.phoneNumber)
  //                             //const email = this.props.user.email

  //                             // let subject = `Your Haney Freightways profile has been created!`
  //                             // let html = `<p>Hello,</p>`
  //                             // html += `Please reset yout password in the following email and sign in to the platform using the link below.`
  //                             // html += `<a href="https://haney-freightways-customer.web.app/pages/login-page">Sign In</a>`
  //                             // const emails = [this.state.authInfo.email]
  //                             // const attatchment = true;

  //                             let body = 'Thank you for partnering with Haney Freightways! Below you will find the link to check in.'
  //                             body += `\nhttps://haney-freightways-driver.web.app/pages/upload/${this.state.orderData.id}`
  //                             let from = '+17205139929'
  //                             let to = (this.state.pickUpDriver.cell ? ("+1" + this.state.pickUpDriver.cell) : '+17205139929')

  //                             console.log("triggering text function")
  //                             const emailReturn = await sendSMS({
  //                                 body, from, to
  //                             })

  //                         }).then(async () => {
  //                           console.log(this.state.pickUpDriverEmail)
  //                           //const email = this.props.user.email
  //                           if ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) {

  //                           let subject = `Haney Freightways #${this.state.orderData.freightBillNumber} Shipping Documents - Please Get Signatures!`
  //                           let html = `<p>Thank you for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures.</p>`
  //                           html += `<p><b>Using Vendor Dispatch App</b></p>`
  //                           html += `<p>The button below will take you to the Haney Freightways Vendor Dispatcher Application. If you don't have a login yet, simply request one via shipping@cargorx.com. We'll send a link via email and text, which will allow you to log right in. If you have a profile click the button below, log in, and access the following:</p>`
  //                           html += `<p>- All Haney Freightways orders involving your company will be isible by click "Orders" on the menu bar</p>`
  //                           html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="100">`
  //                           html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
  //                           html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=ee9e7f64-b731-4919-b6b3-2d1ffae42f6f" height="100">`
  //                           html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents including the completed e-sign docs once all parties have signed – our preference is for the driver to obtain e-signatures, but we understand that paper might be necessary.  The driver is able to upload pictures of paper documents through the driver application and we send the driver a link to this app if we have the driver’s information when we dispatch the shipment.</p>`
  //                           html += `<p>- Within the shipment summary page, you will see a button the says “Confirm Rate” – if the Status above the button says “unconfirmed” in red text, please click on the button and e-sign the confirmation – if the status says “confirmed” in green text above the button, someone has already confirmed the rate.</p>`
  //                           html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.40.04%20PM.png?alt=media&token=9fc33ea6-f2f4-4d8b-9d17-8e573f943592" height="100">`
  //                           html += `<p><b>Call 833-227-4679 for answers to any questions you have – we’re here for you!</b></p>`
  //                           html += `<a href="https://haney-freightways-vendor.web.app"><button>Vendor App</button></a>`
  //                           html += `<p><b>E-Document and e-Signature Link</b></p>`
  //                           html += `<p>If a driver wasn’t assigned at the time of dispatch, a driver was assigned but they didn’t receive our dispatch alert, or a new driver is being used to complete some part of this job for your company, they can access the electronic documents and e-signatures by using the links below.  You simply need to forward the applicable link(s) below to the appropriate driver.</p>`
  //                           html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. As the driver, you must <a href=${this.state.driverPickUpRateConURL}>click here</a> to view and complete the applicable TSA verification.</p>`
  //                           html += `<p>The <b>${((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (thedriver), and the shipper to sign.</p>`
  //                           html += `<p>- To sign as the <b>consignee</b>, please <a href="${this.state.signingURL3}">click here</a></p>`
  //                           html += `<p>The <b>Airline Air Waybill</b> is a critical piece of information.  Please take a picture of the actual airline airwaybill within the driver application – if you are unable to access the driver application, please obtain a hard copy and send back to Haney Freightways via email or snail mail.</p>`
  //                           html += `<p>Thanks, and be safe out there!<p>`
  //                           html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`
  //                           html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //                           // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //                           const emails = [(this.state.vendorDropOff.email && this.state.vendorDropOff.email), "vendoralerts@cargorx.com", "justin@pondata.com"]
  //                           const attatchment = true;
  //                           const emailReturn = await sendEmail({
  //                             emails,
  //                             subject,
  //                             html,
  //                             attatchment
  //                           })
  //                         } else {
  //                           null
  //                         }

  //                         }).then(async () => {
  //                           console.log(this.state.pickUpDriverEmail)
  //                           //const email = this.props.user.email

  //                           if ((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air")) {

  //                           let subject = `Haney Freightways #${this.state.orderData.freightBillNumber} Shipping Documents - Your Signature May be Required!`
  //                           let html = `<p>Thank you very much for shipping with Haney Freightways! Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`
  //                           html += `<p><b>E-Document and e-Signature Link</b></p>`
  //                           html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. As the driver, you must <a href=${this.state.driverPickUpRateConURL}>click here</a> to view and complete the applicable TSA verification.</p>`
  //                           html += `<p>The <b>${((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (thedriver), and the shipper to sign.</p>`
  //                           html += `<p>- To sign as the <b>consignee</b>, please <a href="${this.state.signingURL3}">click here</a></p>`
  //                           html += `<p>The <b>Airline Air Waybill</b> is a critical piece of information.  Please take a picture of the actual airline airwaybill within the driver application – if you are unable to access the driver application, please obtain a hard copy and send back to Haney Freightways via email or snail mail.</p>`
  //                           html += `<p>Thanks, and be safe out there!<p>`
  //                           html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
  //                           html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //                           // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //                           const emails = [(this.state.dropOffDriverEmail && this.state.dropOffDriverEmail), "vendoralerts@cargorx.com", "justin@pondata.com"]
  //                           const attatchment = true;
  //                           const emailReturn = await sendEmail({
  //                             emails,
  //                             subject,
  //                             html,
  //                             attatchment
  //                           })
  //                         } else {
  //                           null
  //                         }
  //                         }).then(async () => {
  //                             console.log(this.state.orderData.destination.email)
  //                             //const email = this.props.user.email

  //                             let subject = `Haney Freightways ${((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} #${this.state.orderData.freightBillNumber}, Please Sign!`
  //                             let html = `<p>Thank you very much for shipping with Haney Freightways!  Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`
  //                             html += `<p><b>Using Haney Freightways Customer App</b></p>`
  //                             html += `<p>The "Customer App" button below will take you to the Haney Freightways Customer Application.  If you don’t have a login yet, simply request one via shipping@cargorx.com.  We’ll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`
  //                             html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%202.07.50%20PM.png?alt=media&token=e7a63ce9-9179-4ac8-850f-cf6c14423ada" height="200">`
  //                             html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="200">`
  //                             html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents and access the e-sign version if you’ll be signing as the shipper contact.  If you aren’t signing as the shipper contact, the driver will have an e-signature version of the shipping document on his or her phonefor the shipping contact to sign.</p>`
  //                             html += `<p>- You can also use the Customer App to track your shipments – certain shipment types allow you to see the driver’s location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`
  //                             html += `<p>- <b>New Transactions:</b> If you don’t have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>– you’ll be asked to complete certain missing fields later when you select and book your shipping option.</p>`
  //                             html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing – you won’t be asked for any missing information later when you select and book a shipping option.</p>`
  //                             html += `<p>Please click the link below to verify shipment details. The link includes an e-signature, which we realize you won’t complete until your freight has been received.<p>`
  //                             html += `<a href="https://haney-freightways-customer.web.app"><button>Customer App</button></a>`
  //                             html += `<p><b>E-Document and e-Signature Link</b></p>`
  //                             html += `<p>If you aren’t able to access the customer application but did receive this message, you can access your electronic document using the link below.<p>`
  //                             html += `<p>The <b>${((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature.  Since you’re making the pick-up, we’ll need you (thedriver), and the shipper to sign.</p>`
  //                             html += `<p>- To sign as the <b>Consignee</b> athe time of delivery, please <a href="${this.state.signingURL1}">click here</a></p>`
  //                             html += `<p>Thanks for the opportunity to serve your company!</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`
  //                             html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //                             // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //                             const emails = [this.state.orderData.destination.email, "customeralerts@cargorx.com", "justin@pondata.com"]
  //                             const attatchment = true;
  //                             const emailReturn = await sendEmail({
  //                               emails,
  //                               subject,
  //                               html,
  //                               attatchment
  //                             })

  //                           }).then(async () => {
  //                             console.log(this.state.orderData.destination.email)
  //                             //const email = this.props.user.email

  //                             let subject = `Haney Freightways ${((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} #${this.state.orderData.freightBillNumber}, Please Sign!`
  //                             let html = `<p>Thank you very much for shipping with Haney Freightways!  Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`
  //                             html += `<p><b>Using Haney Freightways Customer App</b></p>`
  //                             html += `<p>The "Customer App" button below will take you to the Haney Freightways Customer Application.  If you don’t have a login yet, simply request one via shipping@cargorx.com.  We’ll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`
  //                             html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%202.07.50%20PM.png?alt=media&token=e7a63ce9-9179-4ac8-850f-cf6c14423ada" height="100">`
  //                             html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="100">`
  //                             html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents and access the e-sign version if you’ll be signing as the shipper contact.  If you aren’t signing as the shipper contact, the driver will have an e-signature version of the shipping document on his or her phonefor the shipping contact to sign.</p>`
  //                             html += `<p>- You can also use the Customer App to track your shipments – certain shipment types allow you to see the driver’s location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`
  //                             html += `<p>- <b>New Transactions:</b> If you don’t have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>– you’ll be asked to complete certain missing fields later when you select and book your shipping option.</p>`
  //                             html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing – you won’t be asked for any missing information later when you select and book a shipping option.</p>`
  //                             html += `<p>Please click the link below to verify shipment details. The link includes an e-signature, which we realize you won’t complete until your freight has been received.<p>`
  //                             html += `<a href="https://haney-freightways-customer.web.app"><button>Customer App</button></a>`
  //                             html += `<p>Thanks for the opportunity to serve your company!</p>`
  //                             html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`
  //                             html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //                             // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //                             const emails = [this.state.orderData.thirdParty.email, "customeralerts@cargorx.com", "justin@pondata.com"]
  //                             const attatchment = true;
  //                             const emailReturn = await sendEmail({
  //                               emails,
  //                               subject,
  //                               html,
  //                               attatchment
  //                             })

  //                           }).then(() => {
  //                             window.location.reload()
  //                           })

  //                         })
  //                       }, (error) => {
  //                         console.log(error);
  //                       })

  //                     })
  //                   }, (error) => {
  //                     console.log(error);
  //                   })

  //                 })
  //               }, (error) => {
  //                 console.log(error);
  //               })
  //               // .then(async () => {
  //               //   console.log(this.state.orderData.origin.email)
  //               //   //const email = this.props.user.email

  //               //   let subject = `Haney Freightways ${(this.state.orderData.deliveryType == "Air" ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} #${this.state.orderData.freightBillNumber}, Please Sign!`
  //               //   let html = `<p>Thanks again for choosing Haney Freightways!</p>`
  //               //   html += `<p>Please click the link below, verify the shipment details, and sign the ${(this.state.orderData.deliveryType == "Air" ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))}.<p>`
  //               //   html += `<a href="${this.state.signingURL1}">Review & Sign Here</a>`
  //               //   html += `<p>Thanks for the opportunity to serve your company!</p>`
  //               //   html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
  //               //   html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //               //   // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //               //   const emails = [this.state.orderData.origin.email]
  //               //   const attatchment = true;
  //               //   const emailReturn = await sendEmail({
  //               //     emails,
  //               //     subject,
  //               //     html,
  //               //     attatchment
  //               //   })

  //               // }).then(async () => {
  //               //   console.log(this.state.pickUpDriverEmail)
  //               //   //const email = this.props.user.email

  //               //   let subject = `Haney Freightways ${(this.state.orderData.deliveryType == "Air" ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} #${this.state.orderData.freightBillNumber}, Please Get Signatures!`
  //               //   let html = `<p>Thank you for partnering with Haney Freightways!</p>`
  //               //   html += `<p>Please click the following link to sign the ${(this.state.orderData.deliveryType == "Air" ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} as the authorized driver: <a href="${this.state.signingURL2}">Sign Here</a></p>`
  //               //   html += `<p>Please click the following link to have the shipper complete their signature: <a href="${this.state.signingURL1}">Sign Here</a></p>`
  //               //   html += `<p>Sample air waybill: <a href="${this.state.signingSampleWaybillURL}">View Here</a></p>`
  //               //   html += `<p>If the shipper has already signed, you will be notified as such when you click the shipper signature link.<p>`
  //               //   html += `<p>Thanks again for your help and be safe out there!<p>`
  //               //   html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
  //               //   html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //               //   // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //               //   const emails = [this.state.pickUpDriverEmail]
  //               //   const attatchment = true;
  //               //   const emailReturn = await sendEmail({
  //               //     emails,
  //               //     subject,
  //               //     html,
  //               //     attatchment
  //               //   })

  //               // }).then(async () => {

  //               //   if (this.state.orderData.deliveryType == "Air") {
  //               //     console.log(this.state.dropOffDriverEmail)
  //               //     //const email = this.props.user.email

  //               //     let subject = `Haney Freightways ${(this.state.orderData.deliveryType == "Air" ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} #${this.state.orderData.freightBillNumber}, Please Get Signature!`
  //               //     let html = `<p>Thank you for partnering with Haney Freightways!  Below you will find links to the documents you’ll need to complete this delivery.</p>`
  //               //     html += `<p><b>Dispatch Documentation</b></p>`
  //               //     html += `<p>Please click the following link to view the dispatch alert: <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FDelivery%20Vendor%20Driver%20Docs%2FPick-Up%20Dispatch%20_%20Rate%20Confirmation%20(Airline%20to%20Destination)%20Final%203.20.2020%20(1).pdf?alt=media&token=3ee1290f-a191-4cb4-bcce-501e7af2d171">View Here</a></p>`
  //               //     html += `<p><b>Customer Documentation</b></p>`
  //               //     html += `<p>Please click the following link to have the consignee sign the <b>House Waybill</b> once they have agreed to take delivery: <a href="${this.state.signingURL3}">Sign Here</a></p>`
  //               //     html += `<p>If the consignee has already signed, you will be notified as such when you click the consignee signature link.<p>`
  //               //     html += `<p><b>Airline Documentation</b></p>`
  //               //     html += `<p>Please take a picture of the actual airline waybill within the Haney Freightways application! We really need this document and appreciate your help!<p>`
  //               //     html += `<p>Thanks again for your help and be safe out there!<p>`
  //               //     html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
  //               //     html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //               //     // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //               //     const emails = [this.state.dropOffDriverEmail]
  //               //     const attatchment = true;
  //               //     const emailReturn = await sendEmail({
  //               //       emails,
  //               //       subject,
  //               //       html,
  //               //       attatchment
  //               //     })
  //               //   } else {
  //               //     null
  //               //   }
  //               // }).then(async () => {
  //               //   console.log(this.state.orderData.destination.email)
  //               //   //const email = this.props.user.email

  //               //   let subject = `Haney Freightways ${(this.state.orderData.deliveryType == "Air" ? "House Waybill" : ((this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options") ? "Bill of Lading" : ""))} #${this.state.orderData.freightBillNumber}, Please Sign!`
  //               //   let html = `<p>Thanks again for choosing Haney Freightways!</p>`
  //               //   html += `<p>Please click the link below to verify shipment details. The link includes an e-signature, which we realize you won’t complete until your freight has been received.<p>`
  //               //   html += `<a href="${this.state.signingURL3}">Review & Sign Here</a>`
  //               //   html += `<p>If you are not receiver of this shipment, don’t worry!  Our driver will have the link for the actual receiver to sign.</p>`
  //               //   html += `<p>Thanks for the opportunity to serve your company!</p>`
  //               //   html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`
  //               //   html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`
  //               //   // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //               //   const emails = [this.state.orderData.destination.email]
  //               //   const attatchment = true;
  //               //   const emailReturn = await sendEmail({
  //               //     emails,
  //               //     subject,
  //               //     html,
  //               //     attatchment
  //               //   })

  //               // }).then(() => {
  //               //   // window.location.reload()
  //               // })

  //             })
  //           }, (error) => {
  //             console.log(error);
  //           })

  //         })
  // }




  saveAsQuote = () => {
    // update firestore document with PENDING and comment
    console.log("saving quote")
    db.collection("TEST-quotes").add({
      uid: this.state.uid ? this.state.uid : null,
      role: this.state.role ? this.state.role : null,
      status: "pending",
      originBusinessName: this.state.originBusinessName ? this.state.originBusinessName : null,
      originContactName: this.state.originContactName ? this.state.originContactName : null,
      originContactEmail: this.state.originContactEmail ? this.state.originContactEmail : null,
      originContactPhone: this.state.originContactPhone ? this.state.originContactPhone : null,
      originOpenTime: this.state.originOpenTime ? this.state.originOpenTime : null,
      originCloseTime: this.state.originCloseTime ? this.state.originCloseTime : null,
      originStartTimeWindow: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : null,
      originEndTimeWindow: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : null,
      originAddress: this.state.originAddress ? this.state.originAddress : null,
      originCity: this.state.originCity ? this.state.originCity : null,
      originState: this.state.originState ? this.state.originState : null,
      originZip: this.state.originZip ? this.state.originZip : null,
      originType: this.state.originType ? this.state.originType : null,
      pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
      pickUpServices: this.state.pickUpServices ? this.state.pickUpServices : null,
      destinationBusinessName: this.state.destinationBusinessName ? this.state.destinationBusinessName : null,
      destinationContactName: this.state.destinationContactName ? this.state.destinationContactName : null,
      destinationContactEmail: this.state.destinationContactEmail ? this.state.destinationContactEmail : null,
      destinationContactPhone: this.state.destinationContactPhone ? this.state.destinationContactPhone : null,
      destinationOpenTime: this.state.destinationOpenTime ? this.state.destinationOpenTime : null,
      destinationCloseTime: this.state.destinationCloseTime ? this.state.destinationCloseTime : null,
      destinationStartTimeWindow: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : null,
      destinationEndTimeWindow: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : null,
      destinationAddress: this.state.destinationAddress ? this.state.destinationAddress : null,
      destinationCity: this.state.destinationCity ? this.state.destinationCity : null,
      destinationState: this.state.destinationState ? this.state.destinationState : null,
      destinationZip: this.state.destinationZip ? this.state.destinationZip : null,
      destinationType: this.state.destinationType ? this.state.destinationType : null,
      dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
      dropOffServices: this.state.dropOffServices ? this.state.dropOffServices : null,
      services: this.state.services ? this.state.services : null,
      unNumber: this.state.unNumber ? this.state.unNumber : null,
      properShippingName: this.state.properShippingName ? this.state.properShippingName : null,
      packaging: this.state.packaging ? this.state.packaging : null,
      quantity: this.state.quantity ? this.state.quantity : null,
      weight: this.state.weight ? this.state.weight : null,
      height: this.state.height ? this.state.height : null,
      width: this.state.width ? this.state.width : null,
      depth: this.state.depth ? this.state.depth : null,
      class: this.state.class ? this.state.class : null,
      deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
      flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
      page: window.location.pathname,
      updatedAt: new Date()
    }).then((docRef) => {
      db.collection("TEST-users").doc(this.state.uid).collection("quotes").doc(docRef.id).set({
        uid: this.state.uid ? this.state.uid : null,
        role: this.state.role ? this.state.role : null,
        status: "pending",
        originBusinessName: this.state.originBusinessName ? this.state.originBusinessName : null,
        originContactName: this.state.originContactName ? this.state.originContactName : null,
        originContactEmail: this.state.originContactEmail ? this.state.originContactEmail : null,
        originContactPhone: this.state.originContactPhone ? this.state.originContactPhone : null,
        originOpenTime: this.state.originOpenTime ? this.state.originOpenTime : null,
        originCloseTime: this.state.originCloseTime ? this.state.originCloseTime : null,
        originStartTimeWindow: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : null,
        originEndTimeWindow: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : null,
        originAddress: this.state.originAddress ? this.state.originAddress : null,
        originCity: this.state.originCity ? this.state.originCity : null,
        originState: this.state.originState ? this.state.originState : null,
        originZip: this.state.originZip ? this.state.originZip : null,
        originType: this.state.originType ? this.state.originType : null,
        pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
        pickUpServices: this.state.pickUpServices ? this.state.pickUpServices : null,
        destinationBusinessName: this.state.destinationBusinessName ? this.state.destinationBusinessName : null,
        destinationContactName: this.state.destinationContactName ? this.state.destinationContactName : null,
        destinationContactEmail: this.state.destinationContactEmail ? this.state.destinationContactEmail : null,
        destinationContactPhone: this.state.destinationContactPhone ? this.state.destinationContactPhone : null,
        destinationOpenTime: this.state.destinationOpenTime ? this.state.destinationOpenTime : null,
        destinationCloseTime: this.state.destinationCloseTime ? this.state.destinationCloseTime : null,
        destinationStartTimeWindow: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : null,
        destinationEndTimeWindow: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : null,
        destinationAddress: this.state.destinationAddress ? this.state.destinationAddress : null,
        destinationCity: this.state.destinationCity ? this.state.destinationCity : null,
        destinationState: this.state.destinationState ? this.state.destinationState : null,
        destinationZip: this.state.destinationZip ? this.state.destinationZip : null,
        destinationType: this.state.destinationType ? this.state.destinationType : null,
        dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
        dropOffServices: this.state.dropOffServices ? this.state.dropOffServices : null,
        services: this.state.services ? this.state.services : null,
        unNumber: this.state.unNumber ? this.state.unNumber : null,
        properShippingName: this.state.properShippingName ? this.state.properShippingName : null,
        packaging: this.state.packaging ? this.state.packaging : null,
        quantity: this.state.quantity ? this.state.quantity : null,
        weight: this.state.weight ? this.state.weight : null,
        height: this.state.height ? this.state.height : null,
        width: this.state.width ? this.state.width : null,
        depth: this.state.depth ? this.state.depth : null,
        class: this.state.class ? this.state.class : null,
        deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
        flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
        page: window.location.pathname,
        updatedAt: new Date()
      }, { merge: true }).then(() => {
        this.props.history.push('/quotes')
      }).then(() => {
        window.location.reload()
      }).catch((err) => {
        console.log(`${err}`)
      })
    }).catch((err) => {
      console.log(`${err}`)
    })
  }


  resetRequest = () => {
    window.location.reload();
  }

  setUser = (user) => {
    this.setState({
      uid: user,
      userSet: true
    })
    console.log(this.state)
  }

  handleGeoChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
    //console.log(this.state)
  }

  getAirports = (order) => {
    const axios = require("axios");
    console.log(order)
    console.log(this.state.orderData)
    axios({
      "method": "GET",
      "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.orderData.originLat}/${this.state.orderData.originLng}/km/80/16`,
      "headers": {
        "content-type": "application/octet-stream",
        "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
        "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
      }, "params": {
        "withFlightInfoOnly": "false"
      }
    })
      .then((response) => {
        this.setState({
          originAirports: response.data,
          // getAirportsLoaded: true
        })

        axios({
          "method": "GET",
          "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.orderData.destinationLat}/${this.state.orderData.destinationLng}/km/80/16`,
          "headers": {
            "content-type": "application/octet-stream",
            "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
            "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
          }, "params": {
            "withFlightInfoOnly": "false"
          }
        })
          .then((response) => {
            this.setState({
              destinationAirports: response.data,
              getAirportsLoaded: true
            })

          })
          .catch((error) => {
            console.log(error)
          })
        // console.log(response)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  getFlights = () => {
    const axios = require("axios");

    this.setState({
      matchingFlights: [],
    })

    Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

    let origin = (this.state.originCity + " " + this.state.originState)
    // console.log(origin)
    // this.setState({
    //   mapDataSaved: false
    // })
    let originCoords = Geocode.fromAddress(origin).then(
      response => {
        // console.log(response.results[0].geometry.location);
        this.setState({
          originCoords: response.results[0].geometry.location,
        })
        let destination = (this.state.destinationCity + " " + this.state.destinationState)
        // console.log(destination)
        let destinationCoords = Geocode.fromAddress(destination).then(
          response => {
            // console.log(response.results[0].geometry.location);
            this.setState({
              destinationCoords: response.results[0].geometry.location,
            })
            console.log(this.state);

          }
        ).then(
          response => {
            // console.log(this.state)
            axios({
              "method": "GET",
              "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.originCoords.lat}/${this.state.originCoords.lng}/km/${this.state.radius}/16`,
              "headers": {
                "content-type": "application/octet-stream",
                "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
              }, "params": {
                "withFlightInfoOnly": "false"
              }
            })
              .then((response) => {
                this.setState({
                  originAirports: response.data,
                })
                axios({
                  "method": "GET",
                  "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.destinationCoords.lat}/${this.state.destinationCoords.lng}/km/${this.state.radius}/16`,
                  "headers": {
                    "content-type": "application/octet-stream",
                    "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                    "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
                  }, "params": {
                    "withFlightInfoOnly": "false"
                  }
                })
                  .then((response) => {
                    this.setState({
                      destinationAirports: response.data,
                    })
                    // console.log(this.state.originAirports.items[0].icao)

                    this.state.originAirports.items.forEach((originAirport) => {
                      // console.log(originAirport.icao)
                      let originAirportID = originAirport.icao
                      axios({
                        "method": "GET",
                        "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao}/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T00:00/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T11:59`,
                        "headers": {
                          "content-type": "application/octet-stream",
                          "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                          "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
                        }, "params": {
                          "withLeg": "false",
                          "direction": "Departure"
                        }
                      })
                        .then((response) => {
                          this.setState({
                            departingFlights: response.data,
                          })
                          console.log(response.data.departures)
                          // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
                          // console.log(departingFlightsMatch)
                          let filteredDepartingFlights = this.state.matchingFlights
                          // Parse data into array like in firebase.js
                          this.state.destinationAirports.items.forEach((destinationAirport) => {
                            let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === destinationAirport.icao));
                            // console.log(destinationAirport)
                            // console.log(departingFlights)
                            if (departingFlights.length > 0) {
                              departingFlights.forEach((flight) => {
                                let docData = flight
                                let docObj = {
                                  ...docData,
                                  originAirport: originAirport.icao
                                }
                                filteredDepartingFlights.push(docObj);
                              })
                            }
                          })
                          // console.log(originAirport)
                          this.setState({
                            matchingFlights: filteredDepartingFlights,
                          })
                          this.state.originAirports.items.forEach((originAirport) => {
                            // console.log(originAirport.icao)
                            let originAirportID = originAirport.icao
                            axios({
                              "method": "GET",
                              "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao}/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T12:00/${moment(this.state.pickUpDate).format('YYYY-MM-DD')}T23:59`,
                              "headers": {
                                "content-type": "application/octet-stream",
                                "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
                                "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
                              }, "params": {
                                "withLeg": "false",
                                "direction": "Departure"
                              }
                            })
                              .then((response) => {
                                this.setState({
                                  departingFlights: response.data,
                                })
                                // console.log(response.data.departures)
                                // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
                                // console.log(departingFlightsMatch)
                                let filteredDepartingFlights = this.state.matchingFlights
                                // Parse data into array like in firebase.js
                                this.state.destinationAirports.items.forEach((destinationAirport) => {
                                  let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === destinationAirport.icao));
                                  // console.log(destinationAirport)
                                  // console.log(departingFlights)
                                  if (departingFlights.length > 0) {
                                    departingFlights.forEach((flight) => {
                                      let docData = flight
                                      let docObj = {
                                        ...docData,
                                        originAirport: originAirport.icao
                                      }
                                      filteredDepartingFlights.push(docObj);
                                    })
                                  }
                                })
                                // console.log(originAirport)
                                this.setState({
                                  matchingFlights: filteredDepartingFlights,
                                })
                                // console.log(this.state)
                              })
                              .catch((error) => {
                                console.log(error)
                              })
                          })
                        })
                        .catch((error) => {
                          console.log(error)
                        })
                    })
                  })
                  .catch((error) => {
                    console.log(error)
                  })
                // console.log(response)
              })
              .catch((error) => {
                console.log(error)
              })

          }
        )
      }
    )

  }

  saveInfo = (arr) => {
    let orderData = this.state.orderData;
    orderData[arr]['firstName'] = orderData[arr]['firstName'] ? onlyLettersAndWhitespace(orderData[arr]['firstName']).trim() : null;
    orderData[arr]['lastName'] = orderData[arr]['lastName'] ? onlyLettersAndWhitespace(orderData[arr]['lastName']).trim() : null;
    orderData[arr]['phone'] = orderData[arr]['phone'] ? onlyNumbers(orderData[arr]['phone']) : null;
    orderData[arr]['email'] = orderData[arr]['email'] ? orderData[arr]['email'].trim() : null;

    this.setState({
      errorMessage: "",
      orderData: orderData
    });

    let errorDetails = ''

    const reqFields = ["firstName", "lastName", "email", "phone", "businessName", "address", "city", "state", "zip"];
    errorDetails = errorDetails.concat(itemErrorDetails(orderData[arr], reqFields))

    let errorMessage = "";

    for (var i = 0; i < errorDetails.length; i++) {
      if (i === errorDetails.length - 1 && errorDetails.length > 1) {
        errorMessage = errorDetails.length > 1 ? `${errorMessage} and ${errorDetails[i]} are not filled` : `${errorDetails[i]} is not filled`;
      } else {
        errorMessage = errorMessage + errorDetails[i] + ", ";
      }
    }

    if (!errorMessage) {
      Geocode.setApiKey("AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM");

      this.setState({ orderData: orderData })
      let cityState = (this.state.orderData[arr]['city'] + " " + this.state.orderData[arr]['state']);
      this.setState({
        mapDataSaved: false
      })
      let originCoords = Geocode.fromAddress(cityState).then(
        response => {
          // console.log(response.results[0].geometry.location);

          let orderData = this.state.orderData;
          orderData['originCoords'] = response.results[0].geometry.location;

          this.setState({
            orderData: orderData,
            mapDataSaved: true
          })
          db.collection("haney-orders").doc(this.state.orderData.id).set({
            [arr]: this.state.orderData[arr],
            [`${arr}Lat`]: this.state.orderData.originCoords ? this.state.orderData.originCoords.lat : null,
            [`${arr}Lng`]: this.state.orderData.originCoords ? this.state.orderData.originCoords.lng : null,
            page: window.location.pathname,
            updatedAt: new Date()
          }, { merge: true }).then(docRef => {
            db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(this.state.orderData.id).set({
              [arr]: this.state.orderData[arr],
              [`${arr}Lat`]: this.state.orderData.originCoords ? this.state.orderData.originCoords.lat : null,
              [`${arr}Lng`]: this.state.orderData.originCoords ? this.state.orderData.originCoords.lng : null,
              page: window.location.pathname,
              updatedAt: new Date()
            }, { merge: true })
              .then(() => {
                console.log("User order has been updated")
                const modalString = arr === 'origin' ? 'updateOrigin' : (arr === 'destination' ? 'updateDestination' : 'updateThirdParty')
                this.handleClose(modalString);
              })
              .catch(err => console.log("Error updating user order", err))
          }).catch(err => console.log("Could not update haney-orders", err));
        }
      )
    } else {
      this.setState({
        errorMessage: errorMessage
      })
    }
  }

  renewItems = async (id, items) => {
    return new Promise((resolve, reject) => {
      db.collection("haney-orders").doc(id).set({
        items: items,
      }, { merge: true }).then(() => {
        resolve(true);
      });
    })

  }

  saveFreight = () => {

    console.log("save freight func hit");
    const orderID = this.state.orderData.id;
    const items = this.state.orderData.items;

    this.setState({
      errorMessage: ""
    })

    let reqFields = ["packaging", "quantity", "weight", "length", "height", "width", "description"];
    let errorDetails = [];

    let errorMessage = ""

    for (var i = 0; i < items.length; i++) {
      let itemDetails = {};
      if (this.state.orderData.items[i].isHazmat) {
        reqFields.push("unNumber", "properShippingName")
        errorDetails = errorDetails.concat(itemErrorDetails(this.state.orderData.items[i], reqFields));
        reqFields = reqFields.slice(0, reqFields.length - 2);
      } else {
        errorDetails = errorDetails.concat(itemErrorDetails(this.state.orderData.items[i], reqFields));
      }
    }

    for (var i = 0; i < errorDetails.length; i++) {
      if (i === errorDetails.length - 1 && errorDetails.length > 1) {
        errorMessage = errorDetails.length > 1 ? `${errorMessage} and ${errorDetails[i]} are not filled` : `${errorDetails[i]} is not filled`;
      } else {
        errorMessage = errorMessage + errorDetails[i] + ", ";
      }
    }

    if (!errorDetails.length) {


      const itemsNoFiles = [];
      const allFiles = [];

      for (let i = 0; i < this.state.orderData.items.length; i++) {
        const { files, ...noFiles } = this.state.orderData.items[i];
        itemsNoFiles.push(noFiles);
        allFiles.push(files);
      }


      db.collection("haney-orders").doc(orderID).set({
        items: itemsNoFiles,
        page: window.location.pathname,
        updatedAt: new Date()
      }, { merge: true }).then(docRef => {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];

          const oldFiles = [];
          const newFiles = [];

          item.files.map(file => {
            if ('file' in file) {
              const id = uuidv1();
              newFiles.push({ ...file, id: id });
            } else {
              oldFiles.push(file);
            }
          })

          console.log(newFiles);

          oldFiles.map((file, index) => {
            if ('files' in itemsNoFiles[i]) {
              itemsNoFiles[i].files.push(file);
            } else {
              itemsNoFiles[i].files = [file]
            }
          })

          var uploadFiles = newFiles.map(async (fileObj, index) => {
            const { file, id } = fileObj;

            const downloadURL = await this.uploadImage(`orders/${orderID}/${item.id}/${id}`, file);

            if ('files' in itemsNoFiles[i]) {
              itemsNoFiles[i].files.push({ picURL: downloadURL, id: id });
            } else {
              itemsNoFiles[i].files = [{ picURL: downloadURL, id: id }];
            }
          })

        }

        Promise.all(uploadFiles).then(() => {
          this.renewItems(orderID, itemsNoFiles);

          db.collection("TEST-users").doc(this.state.orderData.uid).collection("orders").doc(orderID).set({
            items: itemsNoFiles,
            page: window.location.pathname,
            updatedAt: new Date()
          }, { merge: true })
            .then(() => {
              console.log("User order has been updated");
              this.handleClose('updateFreight');
            })
            .catch(err => console.log("Error updating user order", err))
        })
      }).catch(err => console.log("Could not update haney-orders", err));

    } else {

      this.setState({
        errorMessage: errorMessage
      })

    }
  }

  step2Back = () => {
    this.setState({
      step1: true,
      step2: false

    })
  }

  step3Back = () => {
    this.setState({
      step2: true,
      step3: false

    })
  }

  getQuote = () => {
    this.setState({
      step4: false,
      step5: true

    })

  }
  saveAsQuote = () => {
    this.setState({
      quote: true,

    })

  }

  step4Back = () => {
    this.setState({
      step3: true,
      step4: false

    })
  }

  step5Back = () => {
    this.setState({
      step4: true,
      step5: false

    })
  }

  addItem = () => {
    var orderData = this.state.orderData;
    orderData.items.push({ id: this.state.itemCount })
    this.setState({
      orderData: orderData,
      itemCount: this.state.itemCount + 1
    })

  }

  removeItem = () => {
    var orderData = this.state.orderData;
    orderData.items.pop();
    this.setState({
      orderData: orderData,
      itemCount: this.state.itemCount - 1
    })
  }

  addItem2 = () => {
    this.setState({
      item3: false
    })
  }

  viewFreight = () => {
    this.setState({
      viewFreight: true
    })
  }

  assignFlightNumber = (flightNumber, originAirport, destinationAirport) => {
    this.setState({
      flightNumber: flightNumber,
      originAirport: originAirport,
      destinationAirport: destinationAirport
    })
  }

  assignUser = (doc, arr, query) => {
    // console.log(doc);
    var orderData = this.state.orderData;
    orderData[arr]['phone'] = doc.cellPhone ? doc.cellPhone : (doc.directPhone ? doc.directPhone : '');
    orderData[arr]['firstName'] = doc.firstName;
    orderData[arr]['lastName'] = doc.lastName;
    orderData[arr]['email'] = doc.email;

    this.setState({
      orderData: orderData,
      [query]: ''
    })
  };

  assignBusiness = (doc, arr, query) => {
    // console.log(doc);
    var orderData = this.state.orderData;

    orderData[arr]['businessName'] = doc.name;
    orderData[arr]['address'] = doc.physicalAddress;
    orderData[arr]['city'] = doc.physicalCity;
    orderData[arr]['state'] = doc.physicalState;
    orderData[arr]['zip'] = doc.physicalZip;

    this.setState({
      orderData: orderData,
      [query]: ''
    })
  }

  assignOriginAirCarrier = (doc, arr, query) => {
    // console.log(doc, arr, query);
    let originAirCarrier = this.state.originAirCarrier;
    originAirCarrier['businessName'] = doc.name;
    originAirCarrier['airCode'] = doc.airCodes[0];
    originAirCarrier['address'] = doc.physicalAddress;
    originAirCarrier['city'] = doc.physicalCity;
    originAirCarrier['state'] = doc.physicalState;
    originAirCarrier['zip'] = doc.physicalZip;
    originAirCarrier['cargorxAccountNumber'] = doc.cargorxAccountNumber ? doc.cargorxAccountNumber : false;
    this.setState({
      originAirCarrier: originAirCarrier,
      [query]: ''
    })
  }
  assignDestinationAirCarrier = (doc, arr, query) => {
    // console.log(doc, arr, query);
    let destinationAirCarrier = this.state.destinationAirCarrier;
    destinationAirCarrier['businessName'] = doc.name;
    destinationAirCarrier['airCode'] = doc.airCodes[0];
    destinationAirCarrier['address'] = doc.physicalAddress;
    destinationAirCarrier['city'] = doc.physicalCity;
    destinationAirCarrier['state'] = doc.physicalState;
    destinationAirCarrier['zip'] = doc.physicalZip;
    destinationAirCarrier['cargorxAccountNumber'] = doc.cargorxAccountNumber ? doc.cargorxAccountNumber : false;
    this.setState({
      destinationAirCarrier: destinationAirCarrier,
      [query]: ''
    })
  }

  deliveryType = (type) => {
    this.setState({
      deliveryType: type
    })
  }

  hideFlights = () => {
    this.setState({
      hideFlights: !this.state.hideFlights
    })
  }

  addLeg = () => {
    this.setState({
      leg1: true
    })
  }

  addLeg2 = () => {
    this.setState({
      leg2: true
    })
  }

  removeLeg2 = () => {
    this.setState({
      leg1: false
    })
  }


  addLeg3 = () => {
    this.setState({
      leg3: true
    })
  }



  loadVendorsSTAData = (id) => {
    let data = db.collection("haney-vendors").where('sta', '==', true)
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {

          var docData = doc.data()



          console.log(docData)
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          vendorsSTAData: data,
          vendorsDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadVendorsData = (id) => {
    let data = db.collection("haney-vendors")
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          vendorsData: data,
          vendorsDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }


  loadDriversPickUpData = (id) => {
    let data = db.collection("haney-vendors").doc(id).collection("users").where('role', '==', 'Driver')
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        //console.log(data)
        this.setState({
          driversPickUpData: data,
          driversPickUpDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadDriversDropOffData = (id) => {
    let data = db.collection("haney-vendors").doc(id).collection("users").where('role', '==', 'Driver')
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          driversDropOffData: data,
          driversDropOffDataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadDriversPickUpSTAData = (id) => {
    let data = db.collection("haney-vendors").doc(id).collection("users").where('role', '==', 'Driver')
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        //console.log(data)
        this.setState({
          driversPickUpSTAData: data,
          driversPickUpSTADataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadDriversDropOffSTAData = (id) => {
    let data = db.collection("haney-vendors").doc(id).collection("users").where('userType', '==', 'Driver').where('sta', '==', true)
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          driversDropOffSTAData: data,
          driversDropOffSTADataLoaded: true,
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }




  loadOrdersData = (id) => {
    // console.log("loading order data")
    let data = db.collection("haney-orders").doc(id)
      .get().then((snapshot) => {
        var docData = snapshot.data()
        if (docData) {
          // docData.origin.date = moment.unix(docData.origin.date.seconds, moment.defaultFormat).toDate();
          // docData.destination.date = moment.unix(docData.destination.date.seconds, moment.defaultFormat).toDate();
          var docObj = {
            id: snapshot.id,
            ...docData,
          }
          console.log(docObj)
          return (docObj)
        } else {
          return (null)
        }
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(docObj => {
        // docObj.origin.date = docObj.origin.date.seconds.toDate();

        this.setState({
          origin: docObj.origin,
          destination: docObj.destination,
          orderData: docObj,
          deliveryType: docObj.deliveryType,
          orderDataLoaded: true
        })
      })

    let dataNormal = db.collection("haney-orders").doc(id)
      .get().then((snapshot) => {
        var docData = snapshot.data()
        if (docData) {
          var docObj = {
            id: snapshot.id,
            ...docData,
          }
          return (docObj)
        } else {
          return (null)
        }
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(docObj => {
        this.setState({
          orderDataNormal: docObj,
          orderDataLoaded: true
        })
      })

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  loadPickUpDriverContact = (id) => {
    // console.log("loading order data")
    let data = db.collection("TEST-users").doc(id)
      .get().then((snapshot) => {
        var docData = snapshot.data()
        if (docData) {
          var docObj = {
            ...docData,
            id: snapshot.id,
          }
          return (docObj)
        } else {
          return (null)
        }
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(docObj => {
        this.setState({
          pickUpDriverContact: docObj,
          pickUpDriverContactLoaded: true
        })
      })
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  }

  favOrder = () => {
    db.collection("TEST-users").doc(this.props.authUser.uid).collection("favoritedOrders").doc(this.state.orderData.id).set({
      id: this.state.orderData.id,
      deliveryType: this.state.orderData.id,
      billingParty: this.state.orderData.billingParty ? this.state.orderData.billingParty : "",
      origin: this.state.orderData.originZip,
      originBusinessName: this.state.orderData.originBusinessName ? this.state.orderData.originBusinessName : "",
      originCity: this.state.orderData.originCity ? this.state.orderData.originCity + ", " + this.state.orderData.originState : "",
      destinationBusinessName: this.state.orderData.destinationBusinessName ? this.state.orderData.destinationBusinessName : "",
      destinationCity: this.state.orderData.destinationCity ? this.state.orderData.destinationCity + ", " + this.state.orderData.destinationState : "",
      pickUpDate: this.state.orderData.pickUpDate,
      destination: this.state.orderData.destinationZip,
      dropOffDate: this.state.orderData.dropOffDate,
      class: this.state.orderData.class,
      status: this.state.orderData.status,
      updatedAt: new Date()
    }).then(docObj => {
      db.collection("haney-orders").doc(this.props.orderID).set({
        dispatcherID: this.props.authUser.uid,
        dispatcherAssigned: new Date()
      }, { merge: true }).then(() => {
        this.setState({
          faved: true,
        })
      })
    })
  }

  changeShipmentStatus = (e) => {
    let orderData = this.state.orderData;
    if (orderData) {
      orderData[e.target.name] = e.target.value;
      this.setState({ orderData: orderData })
      db.collection("haney-orders").doc(this.state.orderData.id).update({
        [e.target.name]: e.target.value
      }).then(res => console.log("Update succesful"))
        .catch(err => console.log("Error in updating the db"));
    }
  }



  qualifyVendors = () => {
    var qualifiedPickUpVendors = []
    this.state.originAirports.items.map((airport) => {
      console.log(airport.icao)

      var qualifiedPickUpVendorsList = this.state.vendorsSTAData.filter(function (vendor) {
        // console.log(vendor.airCodes.indexOf(airport.icao))
        return vendor.airCodes.indexOf(airport.icao) !== -1
      });
      console.log(qualifiedPickUpVendorsList)
      qualifiedPickUpVendors = qualifiedPickUpVendors.concat(qualifiedPickUpVendorsList)
    })
    console.log(qualifiedPickUpVendors)
    // var qualifiedPickUpVendorsFinal = this.state.qualifiedPickUpVendors.filter(function (vendor) {
    //   // console.log(vendor.airCodes.indexOf(airport.icao))
    //   return !this[vendor.id] && (this[vendor.id] = true);
    // });
    this.setState({
      qualifiedPickUpVendors: qualifiedPickUpVendors,
      vendorsQualified: true
    })

  }

  qualifyDropOffVendors = () => {
    var qualifiedDropOffVendors = []
    this.state.destinationAirports.items.map((airport) => {
      console.log(airport.icao)

      var qualifiedDropOffVendorsList = this.state.vendorsData.filter(function (vendor) {
        console.log(vendor)
        // console.log(vendor.airCodes.indexOf(airport.icao))
        if (vendor.airCodes) {
          return ((vendor.airCodes.indexOf(airport.icao) !== -1) && (vendor.vendorType == "Ground Carrier" || vendor.vendorType == "LTL Carrier"))
        }
      })
      qualifiedDropOffVendors = qualifiedDropOffVendors.concat(qualifiedDropOffVendorsList)
    })
    console.log(qualifiedDropOffVendors)
    this.setState({
      qualifiedDropOffVendors: qualifiedDropOffVendors,
      dropOffVendorsQualified: true
    })
  }

  selectDriver = (driver) => {
    console.log(driver)
    this.setState({
      pickUpDriverID: driver.id,
      pickUpDriverName: driver.name,
      pickUpDriverEmail: driver.email,
      pickUpDriverCell: driver.cellPhone,
      pickUpDriver: driver,
      driverSelected: true
    })
  }

  selectDropOffDriver = (driver) => {
    console.log(driver)
    this.setState({
      dropOffDriverID: driver.id,
      dropOffDriverName: driver.name,
      dropOffDriverEmail: driver.email,
      dropOffDriver: driver,
      dropOffDriverSelected: true
    })
  }


  selectFlight = (flight) => {
    console.log("selecting flight")
    console.log(flight)
    this.setState({
      flight: flight
    })
    // this.loadAirportAddress(flight.airline, flight.originAirport, flight.movement.airport.icao)
    // console.log(airline, origin, destination)
    let airline = flight.airline.name
    let origin = flight.originAirport
    let destination = flight.movement.airport.icao
    console.log(airline, origin, destination)
    console.log(airline.includes("Airlines"))
    const airlineAppend = (airline.includes("Airlines") ? airline : airline + " Airlines")
    console.log(airlineAppend)
    let data = db.collection("haney-vendors").where('name', '==', airlineAppend).where('airCodes', 'array-contains', origin)
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        console.log(data)
        this.setState({
          originAirlineDetails: data,
          airportAddressUpdated: true,
        })
      })

    let destinationData = db.collection("haney-vendors").where('name', '==', airlineAppend).where('airCodes', 'array-contains', destination)
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          destinationAirlineDetails: data,
          airportAddressUpdated: true,
        })
      })

  }

  loadAirportAddress = (airline, origin, destination) => {
    console.log(airline, origin, destination)
    const airlineAppend = airline + " Airlines"
    let data = db.collection("haney-vendors").where('name', '==', airlineAppend).where('airCodes', 'array-contains', origin)
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          originAirlineDetails: data,
          airportAddressUpdated: true,
        })
      })

    let destinationData = db.collection("haney-vendors").where('name', '==', airlineAppend).where('airCodes', 'array-contains', destination)
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          destinationAirlineDetails: data,
          airportAddressUpdated: true,
        })
      })
  }

  loadMarketAreas = () => {
    // console.log()
    let data = db.collection("marketareas")
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          marketAreasData: data,
          marketAreasDataLoaded: true,
        })
      })
  }
  convertZipToMarketArea = (zip) => {
    // console.log(state.zip.length)
    // console.log(state.zip.length == 3 ? zip.substring(0, 3) : null)
    if (zip.length >= 3) {
      var newArray = this.state.marketAreasData.filter(function (marketArea) {
        return marketArea.zips.includes(zip.substring(0, 3))
      });
      this.setState({
        filteredMarketArea: newArray[0].city,
        filteredMarketAreaCity: newArray[0].city,
        filteredMarketAreaFullName: newArray[0].fullName,
        filteredMarketAreasVendorLoaded: true
      })
    }
  }

  qualifyMarketAreaVendors = () => {
    console.log('qualifying ground vendors')
    console.log(this.state.filteredMarketArea)
    var marketArea = this.state.filteredMarketArea
    var marketAreaCity = this.state.filteredMarketAreaCity
    var marketAreaFullName = this.state.filteredMarketAreaFullName
    var qualifiedPickUpVendors = []

    if (this.state.orderData.deliveryType == "Additional Options") {
      var qualifiedPickUpVendorsList = this.state.vendorsData.filter(function (vendor) {
        console.log(vendor)

        if (vendor.marketAreas) {
          return (((vendor.marketAreas.indexOf(marketAreaCity) !== -1) || (vendor.marketAreas.indexOf(marketAreaFullName) !== -1)) && (vendor.vendorType == "Ground Carrier" || vendor.vendorType == "LTL Carrier"))
        }
      });
    } else {
      var qualifiedPickUpVendorsList = this.state.vendorsData.filter(function (vendor) {
        console.log(vendor)

        if (vendor.marketAreas) {
          return (((vendor.marketAreas.indexOf(marketAreaCity) !== -1) || (vendor.marketAreas.indexOf(marketAreaFullName) !== -1)) && (vendor.vendorType == "Ground Carrier" || vendor.vendorType == "LTL Carrier") && (vendor.hasDrivers))
        }
      });
    }
    // var qualifiedPickUpVendorsList = this.state.vendorsData.filter(function (vendor) {
    //   console.log(vendor)

    //   if (vendor.marketAreas) {
    //     return (((vendor.marketAreas.indexOf(marketAreaCity) !== -1) || (vendor.marketAreas.indexOf(marketAreaFullName) !== -1)) && (vendor.vendorType == "Ground Carrier" || vendor.vendorType == "LTL Carrier") && (vendor.hasDrivers))
    //   }
    // });
    console.log(qualifiedPickUpVendorsList)
    qualifiedPickUpVendors = qualifiedPickUpVendors.concat(qualifiedPickUpVendorsList)
    console.log(qualifiedPickUpVendors)
    this.setState({
      qualifiedPickUpVendors: qualifiedPickUpVendors,
      qualifiedGroundPickUpVendors: qualifiedPickUpVendors,
      marketAreaFilteredVendorsLoaded: true
    })
  }



  loadDispatch = () => {

    if (this.state.orderData.dispatcherID) {
      let dispatcherData = db.collection("TEST-users").doc(this.state.orderData.dispatcherID)
        .get().then((snapshot) => {
          var docData = snapshot.data()
          if (docData) {
            var docObj = {
              id: snapshot.id,
              ...docData
            }
            return (docObj)
          } else {
            return (null)
          }
        }, (error) => {
          console.log('error fetching data: ', error)
        }).then(docObj => {
          this.setState({
            dispatcherData: docObj,
            dispatcherDataLoaded: true
          })
        })
    }

  }

  assignPic2 = (downloadURL, field) => {
    this.setState({
      [field]: downloadURL
    });
    db.collection("haney-orders").doc(this.props.orderID).set({
      [field]: downloadURL
    }, { merge: true }).then(() => {
      window.location.reload()
    })
  }



  render() {
    const { classes, modalClose, authUser, orderID, user } = this.props;
    function StyledRadio(props) {

      return (
        <Radio
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
          icon={<span className={classes.icon} />}
          {...props}
        />
      );
    }
    // Inspired by blueprintjs
    function StyledRadio(props) {

      return (
        <Radio
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
          icon={<span className={classes.icon} />}
          {...props}
        />
      );
    }
    radiusOptions
    const shippingModes = ['', 'LTL', 'TL']
    const role = ['', 'Shipper', 'Consignee', 'Third Party']
    const locationTypes = ['', 'Business', 'Construction Site', 'Convention Center or Tradeshow', 'Freight Carrier Terminal', 'Home Based Business', 'Mlitary Base', 'Mini-Storage / Self Storage Facility', 'Religious Institution', 'Residential / Home']
    const packagingTypes = ['', 'Pallets: Standard (40" x 48")', 'Pallets (48" x 48")', 'Pallets (60" x 48")', 'Pallets (enter dimensions)', 'Boxed', 'Crated', 'Drums or Barrels']
    const freightClass = ['', 'I dont know', '50', '55', '60', '65', '70', '77.5', '85', '92.5', '100', '110', '125', '150', '175', '200', '250', '300', '400', '500']
    const radiusOptions = ['', '50', '100', '150', '200', '250', '300']
    const militaryTime = ['', '0000', '0100', '0200', '0300', '0400', '0500', '0600', '0700', '0800', '0900', '1000', '1100', '1200', '1300', '1400', '1500', '1600', '1700', '1800', '1900', '2000', '2100', '2200', '2300']
    const shipmentStatus = ['Pending', 'Quoted Needs Approval', 'Booked', 'Dispatched', 'In Route to Shipper', 'Arrived at Shipper', 'Driver Departed Shipper', 'Arrived at Airline', 'Tendered to Airline Awaiting Departure', "Aircraft Departed", "Aircraft Arrived", 'Aircraft Download', 'In Route to Consignee', 'Arrived at Consignee', 'Delivered'];
    const accountingStatus = ['Unquoted', 'Quoted', 'Quote Authorized', 'Pricing Final', 'Invoiced', 'Past Due', 'Paid'];

    if (authUser && !this.state.userSet) { this.setUser(authUser.uid) }
    //console.log(authUser)
    // reset modal when closed
    // if (this.state.messageSent) { this.resetRequest() }

    let pathname = window.location.pathname;
    console.log(this.state);


    if (user.dataLoaded
      && !this.state.orderDataLoaded && !this.state.vendorsDataLoaded && (orderID && orderID)) {
      this.loadOrdersData(this.props.orderID)
      this.loadVendorsData()
      this.loadVendorsSTAData()
    }

    if (this.state.vendorPickUp && !this.state.driversPickUpDataLoaded) {
      this.loadDriversPickUpData(this.state.vendorPickUp.id)
      this.loadDriversPickUpSTAData(this.state.vendorPickUp.id)
    }

    if (this.state.vendorDropOff && !this.state.driversDropOffDataLoaded) {
      this.loadDriversDropOffData(this.state.vendorDropOff.id)
      this.loadDriversDropOffSTAData(this.state.vendorDropOff.id)
    }

    if (this.state.driverPickUp && !this.state.pickUpDriverContactLoaded) {
      this.loadPickUpDriverContact(this.state.driverPickUp.id)
    }

    if (!this.state.getAirportsLoaded && this.state.orderDataLoaded) {
      console.log(this.state.orderData)
      console.log(this.state.orderDataLoaded)
      this.getAirports(this.state.orderData)
    }

    if (this.state.getAirportsLoaded) {
      console.log(this.state.vendorsData)
      console.log(this.state.destinationAirports.items)
    }

    if (this.state.vendorsSTAData && this.state.originAirports && this.state.destinationAirports && this.state.getAirportsLoaded && !this.state.vendorsQualified) {
      this.qualifyVendors()
      this.qualifyDropOffVendors()
    }

    if (this.state.orderData && !this.state.airportAddressUpdated) {
      if (this.state.orderData.flight) {
        if (this.state.orderData.flight.originAirport) {
          this.loadAirportAddress(this.state.orderData.flight.airline.name, this.state.orderData.flight.originAirport, this.state.orderData.flight.movement.airport.icao)
        }
      }

    }

    if (user.dataLoaded && !this.state.marketAreasDataLoaded) {
      this.loadMarketAreas()
    }
    if (this.state.orderData && !this.state.filteredMarketAreasVendorLoaded) {
      this.convertZipToMarketArea(this.state.orderData.origin.zip)
    }
    if (this.state.filteredMarketArea && this.state.vendorsData && !this.state.marketAreaFilteredVendorsLoaded) {
      console.log('load ground vendors')
      this.qualifyMarketAreaVendors()
    }

    if (this.state.orderData && !this.state.dispatcherDataLoaded) {
      this.loadDispatch()
    }

    if (this.state.orderData) {
      console.log(this.state.orderData.origin);
      if (this.state.orderData.origin.deliverBy) {
        if ("seconds" in this.state.orderData.origin.deliverBy) {
          var deliverBy = this.state.orderData.origin.deliverBy.toDate();
        } else {
          var deliverBy = this.state.orderData.origin.deliverBy;
        }
      }
      console.log(this.state.orderData.destination);
      if (this.state.orderData.destination.deliverBy) {

        if ('seconds' in this.state.destination.deliverBy) {
          var pickUpBy = this.state.orderData.destination.deliverBy.toDate();
        } else {
          var pickUpBy = this.state.orderData.destination.deliverBy;
        }
      }
    }

    console.log(this.props)
    console.log(this.state)

    return (
      <div>
        {this.state.messageSent ? (
          <GridContainer justify="center">
            <GridItem xs={11}>
              <h4 className={classes.textPrimary}>Order Submitted!</h4>

            </GridItem>
          </GridContainer>
        ) : (
          <GridContainer style={{ marginTop: "-30px" }} justify="center">
            {/* {
                this.state.mapDataSaved ?
                  <GridItem xs={12} md={8}>
                    <ShipFullScreenMap originCoords={this.state.originCoords} destinationCoords={this.state.destinationCoords} />
                  </GridItem>
                  : null
              } */}
            <GridItem xs={12}>
              <div className={classes.formContainer}>
                <form onSubmit={this.handleSubmit}
                >
                  <GridContainer justify="center">
                    <GridItem xs={11}>
                      {this.state.messageError ? <h5 className={classes.bodyText}>There Has Been An Error: {this.state.messageError}</h5> : null}
                      {this.state.step1 ?
                        <div>
                          <h3 className={classes.bodyText}>Step 1 of 4</h3>
                          <p>Tell us who you are and where you're coming from.</p>
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}>
                            <InputLabel
                              htmlFor="role"
                              className={classes.selectLabel}>
                              YOUR ROLE:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.role}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: 'role',
                                name: 'role'
                              }}
                            >
                              {
                                role.map((item) => (
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem
                                    }}
                                    value={item}
                                    key={item}
                                  >{item}</MenuItem>
                                ))
                              }
                            </Select>
                          </FormControl>
                          {/*<FormControl
                          fullWidth
                          className={classes.selectFormControl}>
                          <InputLabel
                            htmlFor="shippingmode"
                            className={classes.selectLabel}>
                            SHIPPING MODE:
                  </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.shippingMode}
                            onChange={this.handleSelectChange}
                            inputProps={{
                              id: 'shippingMode',
                              name: 'shippingMode'
                            }}
                          >
                            {
                              shippingModes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem
                                  }}
                                  value={item}
                                  key={item}
                                >{item}</MenuItem>
                              ))
                            }
                          </Select>
                          </FormControl>*/}

                          <br />
                          <br />
                          <h4 className={classes.bodyText}><b>Origin Details </b></h4>

                          <CustomInput
                            labelText="Business Name"
                            id="originBusinessName"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              required: true,
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.originBusinessName ? this.state.originBusinessName : ''
                            }}
                          />

                          <CustomInput
                            labelText="Address"
                            id="originAddress"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              required: true,
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.originAddress ? this.state.originAddress : ''
                            }}
                          />
                          <GridContainer justify="center">
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="City"
                                id="originCity"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originCity ? this.state.originCity : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} style={{ padding: "0px, 0px, 0px, 0px !important" }}>
                              <CustomInput
                                labelText="State"
                                id="originState"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originState ? this.state.originState : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3}>
                              <CustomInput
                                labelText="ZIP"
                                id="originZip"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originZip ? this.state.originZip : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12}>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}>
                                <InputLabel
                                  htmlFor="originType"
                                  className={classes.selectLabel}>
                                  LOCATION TYPE:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu
                                  }}
                                  classes={{
                                    select: classes.select
                                  }}
                                  value={this.state.originType}
                                  onChange={this.handleSelectChange}
                                  defaultValue={this.state.originZip ? this.state.originZip : ''}
                                  inputProps={{
                                    id: 'originType',
                                    name: 'originType'
                                  }}
                                >
                                  {
                                    locationTypes.map((item) => (
                                      <MenuItem
                                        classes={{
                                          root: classes.selectMenuItem
                                        }}
                                        value={item}
                                        key={item}
                                      >{item}</MenuItem>
                                    ))
                                  }
                                </Select>
                              </FormControl>
                            </GridItem>
                          </GridContainer>
                          <GridContainer style={{ marginTop: "10px" }}>
                            <GridItem xs={6}>
                              {/* <Datetime
                                  selected={this.state.orderData && this.state.orderData.origin.date}
                                  onChange={this.handlePickUpDateChange}
                                  defaultValue={this.state.orderData ? this.state.orderData.origin.date : ''}
                                  timeFormat={true}
                                  isValidDate={this.valid}
                                  renderInput={(dateInputProps, open, close) => (
                                    <CustomInput
                                      inputProps={{ ...dateInputProps, id: 'pickUpDate', name: 'pickUpDate', required: true, }}
                                      onBlur={close}
                                      onFocus={open}
                                      labelText="Pickup Date"
                                      formControlProps={{
                                        fullWidth: true
                                      }}
                                    />
                                  )}
                                />
 */}
                            </GridItem>
                            <GridItem xs={6}>
                              <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() => this.handleTogglePickupServices('Lift Gate')}
                                      checked={this.state.pickUpServices.indexOf('Lift Gate') !== -1 ? true : false}
                                      checkedIcon={<Check className={classes.checkedIcon} />}
                                      icon={<Check className={classes.uncheckedIcon} />}
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label='Lift Gate at Pickup Point'
                                />
                              </div><br />
                              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() => this.handleTogglePickupServices('Limited Access')}
                                      checked={this.state.pickUpServices.indexOf('Limited Access') !== -1 ? true : false}
                                      checkedIcon={<Check className={classes.checkedIcon} />}
                                      icon={<Check className={classes.uncheckedIcon} />}
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label='Limited Access Pick Up'
                                />
                              </div>

                            </GridItem>
                          </GridContainer>

                          <Button
                            style={{ float: "right", marginTop: "20px" }}
                            color="primary"
                            onClick={() => this.saveOrigin()}
                          >NEXT</Button>
                        </div>
                        : null}

                      {/* 
                        <CustomInput
                          labelText="Notes"
                          id="description"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            id: "pickUpNotes",
                            name: "pickUpNotes",
                            type: "text",
                            multiline: true,
                            rows: 5,
                            onChange: (event) => this.handleChange(event)
                          }}
                        /> */}

                      {this.state.step2 ?
                        <div>
                          <h3 className={classes.bodyText}>Step 2 of 4</h3>
                          <p>Tell us where you're going.</p>

                          <h4 className={classes.bodyText}><b>Receiver Details</b></h4>

                          <CustomInput
                            labelText="Business Name"
                            id="destinationBusinessName"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              required: true,
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.destinationBusinessName ? this.state.destinationBusinessName : ''
                            }}
                          />

                          <CustomInput
                            labelText="Address"
                            id="destinationAddress"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              required: true,
                              type: "text",
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.destinationAddress ? this.state.destinationAddress : ''
                            }}
                          />
                          <GridContainer justify="center">
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="City"
                                id="destinationCity"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationCity ? this.state.destinationCity : ''

                                }}
                              />
                            </GridItem>
                            <GridItem xs={3} style={{ padding: "0px, 0px, 0px, 0px !important" }}>
                              <CustomInput
                                labelText="State"
                                id="destinationState"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationState ? this.state.destinationState : ''

                                }}
                              />
                            </GridItem>
                            <GridItem xs={3}>
                              <CustomInput
                                labelText="ZIP"
                                id="destinationZip"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationZip ? this.state.destinationZip : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}>
                            <InputLabel
                              htmlFor="destinationType"
                              className={classes.selectLabel}>
                              LOCATION TYPE:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.destinationType}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: 'destinationType',
                                name: 'destinationType'
                              }}
                            >
                              {
                                locationTypes.map((item) => (
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem
                                    }}
                                    value={item}
                                    key={item}
                                  >{item}</MenuItem>
                                ))
                              }
                            </Select>
                          </FormControl>
                          <GridContainer style={{ marginTop: "10px" }}>
                            <GridItem xs={6}>
                              <Datetime
                                selected={this.state.dropOffDate}
                                onChange={this.handleDropOffDateChange}
                                defaultValue={this.state.dropOffDate ? this.state.dropOffDate : ''}
                                timeFormat={true}
                                isValidDate={this.valid}
                                renderInput={(dateInputProps, open, close) => (
                                  <CustomInput
                                    inputProps={{ ...dateInputProps, id: 'dropOffDate', name: 'dropOffDate', required: true, }}
                                    onBlur={close}
                                    onFocus={open}
                                    labelText="Drop Off Date"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                  />
                                )}
                              />

                            </GridItem>
                            <GridItem xs={6}>
                              <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() => this.handleToggleDropOffServices('Lift Gate')}
                                      checked={this.state.dropOffServices.indexOf('Lift Gate') !== -1 ? true : false}
                                      checkedIcon={<Check className={classes.checkedIcon} />}
                                      icon={<Check className={classes.uncheckedIcon} />}
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label='Lift Gate at Pickup Point'
                                />
                              </div><br />
                              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() => this.handleToggleDropOffServices('Limited Access')}
                                      checked={this.state.dropOffServices.indexOf('Limited Access') !== -1 ? true : false}
                                      checkedIcon={<Check className={classes.checkedIcon} />}
                                      icon={<Check className={classes.uncheckedIcon} />}
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label='Limited Access Pick Up'
                                />
                              </div>

                            </GridItem>

                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ marginTop: "20px" }}
                                onClick={() => this.step2Back()}
                              >BACK</Button>
                            </GridItem>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ float: "right", marginTop: "20px" }}
                                onClick={() => this.saveDestination()}
                              >NEXT</Button>
                            </GridItem>
                          </GridContainer>
                        </div>
                        : null}

                      {/* <CustomInput
                              labelText="Notes"
                              id="dropOffNotes"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                type: "text",
                                multiline: true,
                                rows: 5,
                                onChange: (event) => this.handleChange(event)
                              }}
                            /> */}
                      {this.state.step3 ?
                        <div>
                          <h3 className={classes.bodyText}>Step 3 of 4</h3>
                          <p>Tell us who we'll be dealing with and when.</p>
                          <p><b>Who can we contact at the origin address?</b></p>
                          <GridContainer>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Name"
                                id="originContactName"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactName ? this.state.originContactName : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Email"
                                id="originContactEmail"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactEmail ? this.state.originContactEmail : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Phone"
                                id="originContactPhone"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactPhone ? this.state.originContactPhone : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <p><b>What are their business hours?</b></p>
                          <GridContainer>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Open"
                                id="originOpenTime"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originOpenTime ? this.state.originOpenTime : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={2}>
                              <p>to</p>
                            </GridItem>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Close"
                                id="originCloseTime"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originCloseTime ? this.state.originCloseTime : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p><b>When should we pick up the freight?</b></p>
                          <GridContainer>
                            <GridItem xs={2}>
                              <p>Between</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="Start"
                                id="originStartTimeWindow"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originStartTimeWindow ? this.state.originStartTimeWindow : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={1}>
                              <p>and</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="End"
                                id="originEndTimeWindow"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originEndTimeWindow ? this.state.originEndTimeWindow : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <br /> <br />
                          <p><b>Who can we contact at the destination address?</b></p>
                          <GridContainer>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Name"
                                id="destinationContactName"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationContactName ? this.state.destinationContactName : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Email"
                                id="destinationContactEmail"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationContactEmail ? this.state.destinationContactEmail : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Phone"
                                id="destinationContactPhone"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationContactPhone ? this.state.destinationContactPhone : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <p><b>What are their business hours?</b></p>
                          <GridContainer>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Open"
                                id="destinationOpenTime"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationOpenTime ? this.state.destinationOpenTime : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={2}>
                              <p>to</p>
                            </GridItem>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Close"
                                id="destinationCloseTime"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationCloseTime ? this.state.destinationCloseTime : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p><b>When should we drop off the freight?</b></p>
                          <GridContainer>
                            <GridItem xs={2}>
                              <p>Between</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="Start"
                                id="destinationStartTimeWindow"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationStartTimeWindow ? this.state.destinationStartTimeWindow : ''
                                }}
                              />
                            </GridItem>
                            <GridItem xs={1}>
                              <p>and</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="End"
                                id="destinationEndTimeWindow"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationEndTimeWindow ? this.state.destinationEndTimeWindow : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ marginTop: "20px" }}
                                onClick={() => this.step3Back()}
                              >BACK</Button>
                            </GridItem>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ float: "right", marginTop: "20px" }}
                                onClick={() => this.saveFreight()}
                              >NEXT</Button>
                            </GridItem>
                          </GridContainer>
                        </div>
                        : null}
                      {this.state.step4 ?
                        <div>
                          <h3 className={classes.bodyText}>Step 4 of 4</h3>
                          <p>Tell us what you are shipping.</p>





                          <h3 className={classes.bodyText}>ITEM #1</h3>
                          <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                          <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  tabIndex={-1}
                                  onClick={() => this.handleToggleServices('Hazmat')}
                                  checked={this.state.services.indexOf('Hazmat') !== -1 ? true : false}
                                  checkedIcon={<Check className={classes.checkedIcon} />}
                                  icon={<Check className={classes.uncheckedIcon} />}
                                  color="primary"
                                  classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot
                                  }}
                                />
                              }
                              classes={{ label: classes.bodyText }}
                              label='Hazmat'
                            />
                          </div>
                          <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  tabIndex={-1}
                                  onClick={() => this.handleToggleServices('Over Length')}
                                  checked={this.state.services.indexOf('Over Length') !== -1 ? true : false}
                                  checkedIcon={<Check className={classes.checkedIcon} />}
                                  icon={<Check className={classes.uncheckedIcon} />}
                                  color="primary"
                                  classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot
                                  }}
                                />
                              }
                              classes={{ label: classes.bodyText }}
                              label='Over Length'
                            />
                          </div>
                          <GridContainer>
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="UN Number"
                                id="unNumber"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.unNumber ? this.state.unNumber : ''

                                }}
                              />

                            </GridItem>
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="Proper Shipping Name"
                                id="properShippingName"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "text",
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.properShippingName ? this.state.properShippingName : ''
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}>
                            <InputLabel
                              htmlFor="packaging"
                              className={classes.selectLabel}>
                              PACKAGING:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.packaging}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: 'packaging',
                                name: 'packaging'
                              }}
                            >
                              {
                                packagingTypes.map((item) => (
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem
                                    }}
                                    value={item}
                                    key={item}
                                  >{item}</MenuItem>
                                ))
                              }
                            </Select>
                          </FormControl>


                          <CustomInput
                            labelText="Qty"
                            id="quantity"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              required: true,
                              type: "number",
                              min: "0",
                              step: "1",
                              onChange: (event) => this.handleChange(event)
                            }}
                          />
                          <CustomInput
                            labelText="Total Weight"
                            id="weight"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              required: true,
                              type: "number",
                              min: "0",
                              step: "1",
                              onChange: (event) => this.handleChange(event)
                            }}
                          />
                          {
                            this.state.packaging == "Pallets (enter dimensions)" ?
                              <GridContainer>
                                <GridItem xs={3}>
                                  <CustomInput
                                    labelText="Height"
                                    id="height"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: "number",
                                      min: "0",
                                      step: "1",
                                      onChange: (event) => this.handleChange(event),
                                      defaultValue: this.state.height ? this.state.height : ''
                                    }}
                                  />
                                </GridItem>
                                <GridItem xs={4}>
                                  <CustomInput
                                    labelText="Width"
                                    id="width"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: "number",
                                      min: "0",
                                      step: "1",
                                      onChange: (event) => this.handleChange(event),
                                      defaultValue: this.state.width ? this.state.width : ''
                                    }}
                                  />
                                </GridItem>
                                <GridItem xs={3}>
                                  <CustomInput
                                    labelText="Depth"
                                    id="depth"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: "number",
                                      min: "0",
                                      step: "1",
                                      onChange: (event) => this.handleChange(event),
                                      defaultValue: this.state.depth ? this.state.depth : ''
                                    }}
                                  />
                                </GridItem>
                              </GridContainer>
                              : null
                          }

                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}>
                            <InputLabel
                              htmlFor="class"
                              className={classes.selectLabel}>
                              FREIGHT CLASS:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.class}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: 'class',
                                name: 'class'
                              }}
                            >
                              {
                                freightClass.map((item) => (
                                  <MenuItem
                                    classes={{
                                      root: classes.selectMenuItem
                                    }}
                                    value={item}
                                    key={item}
                                  >{item}</MenuItem>
                                ))
                              }
                            </Select>
                          </FormControl>
                          {!this.state.item2 ?
                            <Button
                              color="primary"
                              onClick={() => this.addItem()}
                            >
                              ADD ITEM
                            </Button>
                            : null}
                          {this.state.item2 ?
                            <div>
                              <h3 className={classes.bodyText}>ITEM #2</h3>
                              <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() => this.handleToggleServices('Hazmat')}
                                      checked={this.state.services.indexOf('Hazmat') !== -1 ? true : false}
                                      checkedIcon={<Check className={classes.checkedIcon} />}
                                      icon={<Check className={classes.uncheckedIcon} />}
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label='Hazmat'
                                />
                              </div>
                              <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() => this.handleToggleServices('Over Length')}
                                      checked={this.state.services.indexOf('Over Length') !== -1 ? true : false}
                                      checkedIcon={<Check className={classes.checkedIcon} />}
                                      icon={<Check className={classes.uncheckedIcon} />}
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label='Over Length'
                                />
                              </div>
                              <GridContainer>
                                <GridItem xs={6}>
                                  <CustomInput
                                    labelText="UN Number"
                                    id="unNumber"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: "number",
                                      min: "0",
                                      step: "1",
                                      onChange: (event) => this.handleChange(event)
                                    }}
                                  />

                                </GridItem>
                                <GridItem xs={6}>
                                  <CustomInput
                                    labelText="Proper Shipping Name"
                                    id="propperShippingName"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: "text",
                                      onChange: (event) => this.handleChange(event)
                                    }}
                                  />
                                </GridItem>
                              </GridContainer>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}>
                                <InputLabel
                                  htmlFor="packaging"
                                  className={classes.selectLabel}>
                                  PACKAGING:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu
                                  }}
                                  classes={{
                                    select: classes.select
                                  }}
                                  value={this.state.packaging}
                                  onChange={this.handleSelectChange}
                                  inputProps={{
                                    id: 'packaging',
                                    name: 'packaging'
                                  }}
                                >
                                  {
                                    packagingTypes.map((item) => (
                                      <MenuItem
                                        classes={{
                                          root: classes.selectMenuItem
                                        }}
                                        value={item}
                                        key={item}
                                      >{item}</MenuItem>
                                    ))
                                  }
                                </Select>
                              </FormControl>


                              <CustomInput
                                labelText="Qty"
                                id="quantity"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "number",
                                  min: "0",
                                  step: "1",
                                  onChange: (event) => this.handleChange(event)
                                }}
                              />
                              <CustomInput
                                labelText="Total Weight"
                                id="weight"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  required: true,
                                  type: "number",
                                  min: "0",
                                  step: "1",
                                  onChange: (event) => this.handleChange(event)
                                }}
                              />
                              {
                                this.state.packaging == "Pallets (enter dimensions)" ?
                                  <GridContainer>
                                    <GridItem xs={3}>
                                      <CustomInput
                                        labelText="Height"
                                        id="height"
                                        formControlProps={{
                                          fullWidth: true
                                        }}
                                        inputProps={{
                                          required: true,
                                          type: "number",
                                          min: "0",
                                          step: "1",
                                          onChange: (event) => this.handleChange(event)
                                        }}
                                      />
                                    </GridItem>
                                    <GridItem xs={4}>
                                      <CustomInput
                                        labelText="Width"
                                        id="width"
                                        formControlProps={{
                                          fullWidth: true
                                        }}
                                        inputProps={{
                                          required: true,
                                          type: "number",
                                          min: "0",
                                          step: "1",
                                          onChange: (event) => this.handleChange(event)
                                        }}
                                      />
                                    </GridItem>
                                    <GridItem xs={3}>
                                      <CustomInput
                                        labelText="Depth"
                                        id="depth"
                                        formControlProps={{
                                          fullWidth: true
                                        }}
                                        inputProps={{
                                          required: true,
                                          type: "number",
                                          min: "0",
                                          step: "1",
                                          onChange: (event) => this.handleChange(event)
                                        }}
                                      />
                                    </GridItem>
                                  </GridContainer>
                                  : null
                              }

                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}>
                                <InputLabel
                                  htmlFor="class"
                                  className={classes.selectLabel}>
                                  FREIGHT CLASS:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu
                                  }}
                                  classes={{
                                    select: classes.select
                                  }}
                                  value={this.state.class}
                                  onChange={this.handleSelectChange}
                                  inputProps={{
                                    id: 'class',
                                    name: 'class'
                                  }}
                                >
                                  {
                                    freightClass.map((item) => (
                                      <MenuItem
                                        classes={{
                                          root: classes.selectMenuItem
                                        }}
                                        value={item}
                                        key={item}
                                      >{item}</MenuItem>
                                    ))
                                  }
                                </Select>
                              </FormControl>
                            </div>
                            : null}


                          {this.state.flights && this.state.flights.map(flight => {
                            if (flight.Stops.length == 0) {
                              return (
                                <div>
                                  <Card style={{ backgroundColor: "white", boxShadow: "0px 0px 5px 0px #888888" }}>
                                    {/* <CardHeader>
                          <h5 style={{ color: "black" }}> <i>Case #{flight.id}</i> <br /></h5>
                        </CardHeader> */}
                                    <CardBody>
                                      <p><span style={{ color: "black" }}>Carrier:</span> <span style={{ fontWeight: "900", color: "black" }}>{flight.Carriers}</span> </p>
                                      {/*<p><span style={{ color: "black" }}>Stops:</span> <span style={{ fontWeight: "900", color: "black" }}>{flight.Stops.length}</span> </p>
                          <p>Flights: {flight.FlightNumbers.map(flight => {
                            return (
                              <p>
                                {flight.FlightNumber} <br />{flight.CarrierId}
                              </p>
                            )
                          })}</p>*/}
                                      <GridContainer>
                                        <GridItem xs={6}>
                                          {String(flight.Departure)}
                                        </GridItem>
                                        <GridItem xs={6}>
                                          {String(flight.Arrival)}
                                        </GridItem>
                                      </GridContainer>
                                    </CardBody>

                                  </Card>
                                </div>
                              )
                            } else {
                              null
                            }
                          })}
                          {this.state.assigningAction ? (
                            <div>
                              <p className={classes.bodyText}>{this.state.assigningAction}</p>
                            </div>
                          ) : (
                            <div>
                              <GridContainer>
                                <GridItem xs={6}>
                                  <Button
                                    color="primary"
                                    style={{ marginTop: "20px" }}
                                    onClick={() => this.step4Back()}
                                  >BACK</Button>
                                </GridItem>
                                <GridItem xs={6}>
                                  <Button
                                    color="primary"
                                    style={{ float: "right", marginTop: "20px" }}
                                    onClick={() => this.getFlights(this.state.originCoords, this.state.destinationCoords)}
                                  >NEXT</Button>
                                </GridItem>
                              </GridContainer>

                            </div>

                          )}


                        </div>

                        : null}
                      {this.state.step5 ?
                        <div>
                          <br />
                          <GridContainer>
                            <GridItem xs={12}>
                              {this.state.orderData &&
                                <ShipFullScreenMap originCoords={{ lat: this.state.orderData.originLat, lng: this.state.orderData.originLng }} destinationCoords={{ lat: this.state.orderData.destinationLat, lng: this.state.orderData.destinationLng }} driverCoords={this.state.orderData.dropOffDriverLocation} />
                              }
                            </GridItem>
                          </GridContainer>
                          <GridContainer>

                            <GridItem xs={12} md={3}>
                              <h4><b>Summary Order # {this.state.orderData ? this.state.orderData.freightBillNumber : null}</b></h4>
                            </GridItem>

                            <GridItem xs={12} md={3}>
                              <GridContainer>

                                <GridItem xs={5}>
                                  <Button
                                    style={{ color: "white", marginTop: "5px", backgroundColor: "#ff0000" }}
                                    onClick={() => this.cancelOrder()}
                                  >
                                    CANCEL ORDER
                                  </Button>
                                </GridItem>
                                <GridItem xs={1}></GridItem>
                                <GridItem xs={5}>
                                  <Button
                                    color={this.state.faved ? "primary" : "info"}
                                    onClick={() => this.favOrder()}
                                  >
                                    Pin Order
                                  </Button>
                                </GridItem>
                                <GridItem xs={1}></GridItem>
                              </GridContainer>

                            </GridItem>
                            <GridItem xs={12} md={3}>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}>

                                <InputLabel
                                  htmlFor="status"
                                  className={classes.selectLabel}>
                                  Shipment Operational Status:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu
                                  }}
                                  classes={{
                                    select: classes.select
                                  }}
                                  value={this.state.orderData && this.state.orderData.status}
                                  onChange={(e) => {
                                    this.changeShipmentStatus(e);
                                  }}
                                  defaultValue={this.state.orderData && this.state.orderData.status}
                                  inputProps={{
                                    id: 'status',
                                    name: 'status'
                                  }}
                                >
                                  {
                                    shipmentStatus.map((item) => (
                                      <MenuItem
                                        classes={{
                                          root: classes.selectMenuItem
                                        }}
                                        value={item}
                                        key={item}
                                      >{item}</MenuItem>
                                    ))
                                  }
                                </Select>
                              </FormControl>
                              {this.state.orderData && this.state.orderData.status}
                            </GridItem>
                            <GridItem xs={12} md={3}>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}>

                                <InputLabel
                                  htmlFor="financialStatus"
                                  className={classes.selectLabel}>
                                  Shipment Accounting Status:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu
                                  }}
                                  classes={{
                                    select: classes.select
                                  }}
                                  value={this.state.orderData && this.state.orderData.financialStatus}
                                  onChange={(e) => {
                                    this.changeShipmentStatus(e);
                                  }}
                                  defaultValue={this.state.orderData && this.state.orderData.financialStatus}
                                  inputProps={{
                                    id: 'financialStatus',
                                    name: 'financialStatus'
                                  }}
                                >
                                  {
                                    accountingStatus.map((item) => (
                                      <MenuItem
                                        classes={{
                                          root: classes.selectMenuItem
                                        }}
                                        value={item}
                                        key={item}
                                      >{item}</MenuItem>
                                    ))
                                  }
                                </Select>
                              </FormControl>
                              {this.state.orderData && this.state.orderData.financialStatus}

                            </GridItem>


                            {/*Party Freight Summary*/}
                            <GridItem xs={12} md={4}>
                              <br />
                              <p><b>Summary</b></p>
                              {this.state.orderData &&
                                <PartyFreightSummary
                                  dispatch={true}
                                  orderData={this.state.orderData}
                                  origin={this.state.orderData.origin}
                                  destination={this.state.orderData.destination}
                                  thirdParty={this.state.orderData.thirdParty}
                                  items={this.state.orderData.items}
                                  shipperName={this.state.orderData.shipperName}
                                  billingParty={this.state.orderData.billingParty}
                                  itemCount={this.state.itemCount}
                                  isEditable={true}
                                  handleClickOpen={this.handleClickOpen}
                                  handleClose={this.handleClose}
                                  classes={this.props.classes}
                                  businessQuery={this.state.businessQuery}
                                  userQuery={this.state.userQuery}
                                  errorMessage={this.state.errorMessage}
                                  assignBusiness={this.assignBusiness}
                                  assignUser={this.assignUser}
                                  handleChange={this.handleChange}
                                  handleArrChange={this.handleArrChange}
                                  handleSelectChange={this.handleSelectChangeStateObj}
                                  handleDateChange={this.handleDateChange}
                                  handleToggleServices={this.handleToggleServices}
                                  saveInfo={this.saveInfo}
                                  addItem={this.addItem}
                                  removeItem={this.removeItem}
                                  handleItemChange={this.handleItemChange}
                                  handleItemSelectChange={this.handleItemSelectChange}
                                  handleToggleItemServices={this.handleToggleItemServices}
                                  handleSelectChangeObj={this.handleSelectChangeObj}
                                  onAssignPic={this.assignPic}
                                  removePicture={this.removePicture}
                                  saveFreight={this.saveFreight}
                                  updateOrigin={this.state.updateOrigin}
                                  updateDestination={this.state.updateDestination}
                                  updateThirdParty={this.state.updateThirdParty}
                                  updateFreight={this.state.updateFreight}
                                />
                              }
                              <br />
                              <br />



                            </GridItem>

                            {/*Routing Module*/}

                            <GridItem xs={12} md={8}>


                              <b>Choose Delivery Type:</b>
                              {
                                this.state.orderData &&
                                <div>
                                  {(this.state.orderData.status !== "pending" || this.state.orderData.status !== "Pending" || this.state.orderData.status !== "booked" || this.state.orderData.status !== "Booked" || this.state.orderData.status !== "quoted" || this.state.orderData.status !== "Quoted")
                                    &&
                                    <div>
                                      Air Quote: ${this.state.orderData.airQuote}<br />
                                      Ground Quote: ${this.state.orderData.groundQuote}<br />
                                      LTL Quote: ${this.state.orderData.ltlQuote}<br />
                                      Mode: {(this.state.orderData.deliveryType == "Air") ? "Next Flight Out" : (this.state.orderData.deliveryType == "Scheduled Air") ? "Next Day Air" : (this.state.orderData.deliveryType == "Ground") ? "Dedicated Ground" : (this.state.orderData.deliveryType == "Additional Options") ? "Additional Options" : "?"}<br /><br />

                                      Pick Up Vendor: {this.state.orderData.vendorPickUpName}<br />
                                      Pick Up Driver: {this.state.orderData.driverPickUpName}<br />
                                      Pick Up Rate: ${this.state.orderData.pickUpRate}<br />
                                      Rate Confirmation: <span style={{ color: (this.state.orderData.pickUpRateStatus == "unconfirmed" ? "red" : "green") }}>{this.state.orderData.pickUpRateStatus}</span><br />
                                      <br />
                                      Airline Drop Time: {(this.state.orderData.dispatchedAt && this.state.orderData.destination.deliverBy) ? moment(deliverBy).format("MM/DD/YYYY HH:mm") : " "}
                                      {(this.state.orderData.flight && this.state.originAirlineDetails && this.state.destinationAirlineDetails) &&
                                        <div>
                                          Airline: {this.state.orderData.flight && this.state.orderData.flight.airline.name}<br />
                                          Flight Number: {this.state.orderData.flight && this.state.orderData.flight.number}<br />
                                          Origin Airport: {this.state.orderData.flight && this.state.orderData.flight.originAirport}<br />
                                          Origin Airline Address: {(this.state.originAirlineDetails.length !== 0) ? (this.state.originAirlineDetails[0].physicalAddress + " " + this.state.originAirlineDetails[0].physicalCity + ", " + this.state.originAirlineDetails[0].physicalState + " " + this.state.originAirlineDetails[0].physicalZip) : null}<br />
                                          Destination Airport: {this.state.orderData.flight.movement.airport.icao}<br />
                                          Destination Airline Address: {(this.state.destinationAirlineDetails.length !== 0) ? (this.state.destinationAirlineDetails[0].physicalAddress + " " + this.state.destinationAirlineDetails[0].physicalCity + ", " + this.state.destinationAirlineDetails[0].physicalState + " " + this.state.destinationAirlineDetails[0].physicalZip) : null}<br />
                                          Booking Number: {this.state.orderData.bookingNumber}<br />
                                          Air Waybill Number: {this.state.orderData.airWaybillNumber}<br />
                                          Service Type: {this.state.orderData.serviceLevel}<br />
                                          Scheduled Time: {this.state.orderData.flight.movement.scheduledTimeLocal}<br />
                                          Actual Time: {this.state.orderData.flight.movement.actualTimeLocal}<br />
                                        </div>
                                      }


                                      {(this.state.orderData && this.state.orderData.deliveryType == "Scheduled Air" && this.state.orderData.originAirCarrier && this.state.orderData.destinationAirCarrier) &&
                                        <div>
                                          Airline: {this.state.orderData.originAirCarrier && this.state.orderData.originAirCarrier.businessName}<br />
                                          Origin Airport: {this.state.orderData.originAirCarrier && this.state.orderData.originAirCarrier.airCode}<br />
                                          Origin Airline Adress: {this.state.orderData.originAirCarrier && (this.state.orderData.originAirCarrier.address + " " + this.state.orderData.originAirCarrier.city + ", " + this.state.orderData.originAirCarrier.state + " " + this.state.orderData.originAirCarrier.zip)}<br />
                                          Destination Airport: {this.state.orderData.destinationAirCarrier && this.state.orderData.destinationAirCarrier.airCode}<br />
                                          Destination Airline Adress: {this.state.orderData.destinationAirCarrier && (this.state.orderData.destinationAirCarrier.address + " " + this.state.orderData.destinationAirCarrier.city + ", " + this.state.orderData.destinationAirCarrier.state + " " + this.state.orderData.destinationAirCarrier.zip)}<br />
                                          Booking Number: {this.state.orderData.bookingNumber}<br />
                                          Air Waybill Number: {this.state.orderData.airWaybillNumber}<br />
                                          Service Type: {this.state.orderData.serviceLevel}<br />
                                          {/* Scheduled Time: {this.state.orderData.flight.movement.scheduledTimeLocal}<br/>
                                                                                    Actual Time: {this.state.orderData.flight.movement.actualTimeLocal}<br/> */}
                                        </div>
                                      }

                                      <br /><br />

                                      {(this.state.orderData && (this.state.orderData.deliveryType == "Ground" || this.state.orderData.deliveryType == "Additional Options"))
                                        ? null :

                                        <div>
                                          <br />

                                          Drop Off Vendor: {this.state.orderData.vendorDropOffName}<br />
                                          Drop Off Driver: {this.state.orderData.driverDropOffName}<br />
                                          Drop Off Rate: ${this.state.orderData.dropOffRate}<br />
                                          Status: <span style={{ color: (this.state.orderData.dropOffRateStatus == "unconfirmed" ? "red" : "green") }}>{this.state.orderData.dropOffRateStatus}</span><br />

                                        </div>
                                      }

                                    </div>
                                  }
                                </div>
                              }
                              {(this.state.orderData && (this.state.orderData.status == "booked" || this.state.orderData.status == "Dispatched")) &&
                                <GridContainer>
                                  <GridItem xs={6}
                                    style={{ backgroundColor: (this.state.orderData.deliveryType == "Air") ? "#efe6e6" : null }}
                                    onClick={() => this.deliveryType("Air")}
                                  >
                                    <h4><b>NEXT FLIGHT OUT: <span style={{ color: "red" }}>${this.state.orderData.airQuote}</span></b></h4>
                                    <p>ETA: {(this.state.orderData.air && moment(this.state.orderData.air.quoteETA.toDate()).format("MM-DD-YYYY HH:ss"))}</p>
                                    <div>


                                    </div>
                                  </GridItem>
                                  <GridItem xs={6}
                                    style={{ backgroundColor: (this.state.orderData.deliveryType == "Scheduled Air") ? "#efe6e6" : null }}
                                    onClick={() => this.deliveryType("Scheduled Air")}
                                  >
                                    <h4><b>NEXT DAY AIR: <span style={{ color: "red" }}>${this.state.orderData.cargoAirQuote}</span></b></h4>
                                    <p>ETA:  {(this.state.orderData.cargoAir && moment(this.state.orderData.cargoAir.quoteETA.toDate()).format("MM-DD-YYYY HH:ss"))}</p>

                                    <div>


                                    </div>
                                  </GridItem>
                                  <GridItem xs={4}
                                    style={{ backgroundColor: (this.state.orderData.deliveryType == "Ground") ? "#efe6e6" : null }}
                                    onClick={() => this.deliveryType("Ground")}
                                  >
                                    <h4><b>DEDICATED GROUND: <span style={{ color: "red" }}>${this.state.orderData.groundQuote}</span></b></h4>
                                    <p>ETA:  {(this.state.orderData.ground && moment(this.state.orderData.ground.quoteETA.toDate()).format("MM-DD-YYYY HH:ss"))}</p>

                                  </GridItem>
                                  <GridItem xs={4}
                                    onClick={() => this.deliveryType("LTL")}
                                    style={{ backgroundColor: (this.state.orderData.deliveryType == "LTL") ? "#efe6e6" : null }}
                                  >
                                    <h4><b>LTL:<span style={{ color: "red" }}>${this.state.orderData.autoLtlQuote}</span></b> </h4>
                                    <p>ETA:   {(this.state.orderData.autoLtl && moment(this.state.orderData.autoLtl.quoteETA.toDate()).format("MM-DD-YYYY HH:ss"))}</p>

                                  </GridItem>
                                  <GridItem xs={4}
                                    onClick={() => this.deliveryType("Additional Options")}
                                    style={{ backgroundColor: (this.state.orderData.deliveryType == "Additional Options") ? "#efe6e6" : null }}
                                  >
                                    <h4><b>DIRECT LTL:<span style={{ color: "red" }}>${this.state.orderData.ltlQuote}</span></b> </h4>
                                    <p>ETA:   {(this.state.orderData.ltl && moment(this.state.orderData.ltl.quoteETA.toDate()).format("MM-DD-YYYY HH:ss"))}</p>

                                  </GridItem>
                                </GridContainer>
                              }

                              <br />
                              {this.state.orderData &&
                                <div>
                                  {((this.state.deliveryType == "Air" || this.state.deliveryType == "Scheduled Air") && (this.state.orderData.status == "booked" || this.state.orderData.status == "Dispatched")) &&

                                    <div>
                                      <GridContainer>
                                        <GridItem xs={12} sm={4}>
                                          Pick Up Driver:

                                          <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}>
                                            <InputLabel
                                              htmlFor="vendorPickUp"
                                              style={{
                                                color: "#000"
                                              }}
                                            //className={classes.selectLabel}
                                            >
                                              Vendor:
                                            </InputLabel>
                                            <Select
                                              // MenuProps={{
                                              //     className: classes.selectMenu
                                              // }}
                                              // classes={{
                                              //     select: classes.select
                                              // }}
                                              style={{
                                                color: "#000"
                                              }}
                                              value={this.state.vendorPickUp ? this.state.vendorPickUp : null}
                                              onChange={this.handleSelectPickUpVendorChange}
                                              inputProps={{
                                                id: 'vendorPickUp',
                                                name: 'vendorPickUp'
                                              }}
                                            >
                                              {this.state.qualifiedPickUpVendors &&
                                                this.state.qualifiedPickUpVendors.map((item) => (
                                                  <MenuItem
                                                    // classes={{
                                                    //     root: classes.selectMenuItem
                                                    // }}
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                    value={item}
                                                    key={item}
                                                  >{item.name}</MenuItem>
                                                ))
                                              }
                                            </Select>
                                          </FormControl>
                                          {this.state.vendorPickUp ?
                                            //   <FormControl
                                            //     fullWidth
                                            //     className={classes.selectFormControl}>
                                            //     <InputLabel
                                            //       htmlFor="driverPickUp"
                                            //       style={{
                                            //         color: "#000"
                                            //       }}
                                            //     //className={classes.selectLabel}
                                            //     >
                                            //       Driver:
                                            //  </InputLabel>
                                            //     <Select
                                            //       // MenuProps={{
                                            //       //     className: classes.selectMenu
                                            //       // }}
                                            //       // classes={{
                                            //       //     select: classes.select
                                            //       // }}
                                            //       style={{
                                            //         color: "#000"
                                            //       }}
                                            //       value={this.state.driver ? this.state.driver : null}
                                            //       onChange={this.handleSelectChange}
                                            //       inputProps={{
                                            //         id: 'driverPickUp',
                                            //         name: 'driverPickUp'
                                            //       }}
                                            //     >
                                            //       {this.state.driversPickUpSTAData &&
                                            //         this.state.driversPickUpSTAData.map((item) => (
                                            //           item.sta &&
                                            //           <MenuItem
                                            //           // classes={{
                                            //           //     root: classes.selectMenuItem
                                            //           // }}
                                            //           style={{
                                            //             color: "#000"
                                            //           }}
                                            //           value={item}
                                            //           key={item}
                                            //         >{item.name}</MenuItem>

                                            //         ))
                                            //       }
                                            //     </Select>

                                            //   </FormControl>
                                            <div>
                                              {!this.state.driverSelected &&
                                                <div>
                                                  {this.state.driversPickUpSTAData &&
                                                    this.state.driversPickUpSTAData.map((item) => (
                                                      <div
                                                        onClick={() => this.selectDriver(item)}
                                                        style={{ cursor: "pointer" }}
                                                      >
                                                        {item.name}
                                                      </div>
                                                    ))
                                                  }
                                                </div>
                                              }

                                            </div>
                                            : null}
                                          <b>{(this.state.pickUpDriverName && this.state.driverSelected) &&
                                            this.state.pickUpDriverName
                                          }</b>
                                          <CustomInput
                                            labelText="Pick Up Rate"
                                            id="pickUpRate"
                                            formControlProps={{
                                              fullWidth: true
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) => this.handleChange(event)
                                            }}
                                          />

                                          Deliver By:
                                          {this.state.origin &&
                                            <div>
                                              {this.state.orderData.status == "Dispatched" ?
                                                <DateTimePicker
                                                  onChange={(e) => this.handleDateTimeChange(e, "origin")}
                                                  value={this.state.orderData.origin.deliverBy ? deliverBy : null}
                                                />
                                                :
                                                <DateTimePicker
                                                  onChange={(e) => this.handleDateTimeChange(e, "origin")}
                                                  value={this.state.orderData.origin.deliverBy ? deliverBy : null}
                                                />
                                              }
                                            </div>

                                          }



                                          {/* <FormControl
                                                                                      fullWidth
                                                                                      className={classes.selectFormControl}>
                                                                                      <InputLabel
                                                                                        htmlFor="deliverBy"
                                                                                        className={classes.selectLabel}>
                                                                                        DELIVER BY
                                                                                </InputLabel>
                                                                                      <Select
                                                                                        MenuProps={{
                                                                                          className: classes.selectMenu
                                                                                        }}
                                                                                        classes={{
                                                                                          select: classes.select
                                                                                        }}
                                                                                        value={this.state.orderData.origin['deliverBy']}
                                                                                        onChange={(e) => this.handleSelectChangeObj(e, 'origin')}
                                                                                        defaultValue={this.state.orderData.origin['deliverBy'] ? this.state.orderData.origin['deliverBy'] : ''}
                                                                                        inputProps={{
                                                                                          id: 'deliverBy',
                                                                                          name: 'deliverBy'
                                                                                        }}
                                                                                      >
                                                                                        {
                                                                                          militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                              classes={{
                                                                                                root: classes.selectMenuItem
                                                                                              }}
                                                                                              value={item}
                                                                                              key={item}
                                                                                            >{item}</MenuItem>
                                                                                          ))
                                                                                        }
                                                                                      </Select>
                                                                                    </FormControl> */}

                                        </GridItem>
                                        <GridItem xs={12} md={4}>
                                          {this.state.deliveryType == "Air" &&
                                            <CustomInput
                                              labelText="Flight Number #1"
                                              id="flightNumber"
                                              formControlProps={{
                                                fullWidth: true
                                              }}
                                              labelProps={{
                                                shrink: true
                                              }}
                                              inputProps={{
                                                required: true,
                                                onChange: (event) => this.handleChange(event),
                                                value: (this.state.flight ? this.state.flight.number : (this.state.orderData && (this.state.orderData.flight && this.state.orderData.flight.number))),

                                              }}
                                            />
                                          }
                                          {this.state.deliveryType == "Scheduled Air" &&
                                            <PrototypeExploreAssignUser
                                              labelText={"Search Origin Air Carrier"}
                                              collection={"haney-vendors"}
                                              vendorSelector={true}
                                              id={"originBusinessQuery"}
                                              onChange={this.handleChange}
                                              value={this.state.originBusinessQuery ? this.state.originBusinessQuery : ''}
                                              assignUser={this.assignOriginAirCarrier}
                                              stateObj={this.state.arrString}
                                            />
                                          }
                                          {(this.state.deliveryType == "Scheduled Air" && this.state.originAirCarrier['businessName']) &&

                                            this.state.originAirCarrier['businessName'] + " " + this.state.originAirCarrier['airCode']
                                          }
                                          {this.state.deliveryType == "Scheduled Air" &&
                                            <PrototypeExploreAssignUser
                                              labelText={"Search Destination Air Carrier"}
                                              collection={"haney-vendors"}
                                              vendorSelector={true}
                                              id={"destinationBusinessQuery"}
                                              onChange={this.handleChange}
                                              value={this.state.destinationBusinessQuery ? this.state.destinationBusinessQuery : ''}
                                              assignUser={this.assignDestinationAirCarrier}
                                              stateObj={this.state.arrString}
                                            />
                                          }
                                          {(this.state.deliveryType == "Scheduled Air" && this.state.destinationAirCarrier['businessName']) &&

                                            this.state.destinationAirCarrier['businessName'] + " " + this.state.destinationAirCarrier['airCode']
                                          }
                                          <CustomInput
                                            labelText="Booking #"
                                            id="bookingNumber"
                                            formControlProps={{
                                              fullWidth: true
                                            }}
                                            labelProps={{
                                              shrink: true
                                            }}
                                            inputProps={{
                                              required: false,
                                              onChange: (event) => this.handleChange(event),

                                            }}
                                          />
                                          <CustomInput
                                            labelText="Air Waybill #"
                                            id="airWaybillNumber"
                                            formControlProps={{
                                              fullWidth: true
                                            }}
                                            labelProps={{
                                              shrink: true
                                            }}
                                            inputProps={{
                                              required: false,
                                              onChange: (event) => this.handleChange(event),

                                            }}
                                          />
                                          <CustomInput
                                            labelText="Service Level"
                                            id="serviceLevel"
                                            formControlProps={{
                                              fullWidth: true
                                            }}
                                            labelProps={{
                                              shrink: true
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) => this.handleChange(event),

                                            }}
                                          />
                                          <CustomInput
                                            labelText="Carrier Expense"
                                            id="airCarrierExpense"
                                            formControlProps={{
                                              fullWidth: true
                                            }}
                                            labelProps={{
                                              shrink: true
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) => this.handleChange(event),

                                            }}
                                          />
                                          <Button
                                            color="primary"
                                            onClick={() => this.addLeg()}
                                          >
                                            ADD LEG
                                          </Button>
                                        </GridItem>
                                        <GridItem xs={12} sm={4}>
                                          Drop Off Driver

                                          <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}>
                                            <InputLabel
                                              htmlFor="vendorDropOff"
                                              style={{
                                                color: "#000"
                                              }}
                                            //className={classes.selectLabel}
                                            >
                                              Vendor:
                                            </InputLabel>
                                            <Select
                                              // MenuProps={{
                                              //     className: classes.selectMenu
                                              // }}
                                              // classes={{
                                              //     select: classes.select
                                              // }}
                                              style={{
                                                color: "#000"
                                              }}
                                              value={this.state.vendorDropOff}
                                              onChange={this.handleSelectDropOffVendorChange}
                                              inputProps={{
                                                id: 'vendorDropOff',
                                                name: 'vendorDropOff'
                                              }}
                                            >
                                              {this.state.qualifiedDropOffVendors &&
                                                this.state.qualifiedDropOffVendors.map((item) => (
                                                  <MenuItem
                                                    // classes={{
                                                    //     root: classes.selectMenuItem
                                                    // }}
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                    value={item}
                                                    key={item}
                                                  >{item.name}</MenuItem>
                                                ))
                                              }
                                            </Select>
                                          </FormControl>
                                          {this.state.vendorDropOff ?
                                            //   <FormControl
                                            //     fullWidth
                                            //     className={classes.selectFormControl}>
                                            //     <InputLabel
                                            //       htmlFor="driverDropOff"
                                            //       style={{
                                            //         color: "#000"
                                            //       }}
                                            //     //className={classes.selectLabel}
                                            //     >
                                            //       Driver:
                                            //  </InputLabel>
                                            //     <Select
                                            //       // MenuProps={{
                                            //       //     className: classes.selectMenu
                                            //       // }}
                                            //       // classes={{
                                            //       //     select: classes.select
                                            //       // }}
                                            //       style={{
                                            //         color: "#000"
                                            //       }}
                                            //       value={this.state.driver}
                                            //       onChange={this.handleSelectChange}
                                            //       inputProps={{
                                            //         id: 'driverDropOff',
                                            //         name: 'driverDropOff'
                                            //       }}
                                            //     >
                                            //       {this.state.driversDropOffData &&
                                            //         this.state.driversDropOffData.map((item) => (
                                            //           <MenuItem
                                            //             // classes={{
                                            //             //     root: classes.selectMenuItem
                                            //             // }}
                                            //             style={{
                                            //               color: "#000"
                                            //             }}
                                            //             value={item}
                                            //             key={item}
                                            //           >{item.name}</MenuItem>
                                            //         ))
                                            //       }
                                            //     </Select>
                                            //     <CustomInput
                                            //   labelText="Drop Off Rate"
                                            //   id="dropOffRate"
                                            //   formControlProps={{
                                            //     fullWidth: true
                                            //   }}
                                            //   inputProps={{
                                            //     required: true,
                                            //     onChange: (event) => this.handleChange(event)
                                            //   }}
                                            // />
                                            //   </FormControl>
                                            <div>
                                              {!this.state.dropOffDriverSelected &&
                                                <div>
                                                  {this.state.driversDropOffData &&
                                                    this.state.driversDropOffData.map((item) => (
                                                      <div
                                                        onClick={() => this.selectDropOffDriver(item)}
                                                        style={{ cursor: "pointer" }}
                                                      >
                                                        {item.name}
                                                      </div>
                                                    ))
                                                  }
                                                </div>
                                              }

                                            </div>
                                            : null}
                                          <b>{(this.state.dropOffDriverName && this.state.dropOffDriverSelected) &&
                                            this.state.dropOffDriverName
                                          }</b>
                                          <CustomInput
                                            labelText="Drop Off Rate"
                                            id="dropOffRate"
                                            formControlProps={{
                                              fullWidth: true
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) => this.handleChange(event)
                                            }}
                                          />
                                          Pick Up By:
                                          {this.state.destination &&
                                            <div>
                                              {this.state.orderData.status == "Dispatched" ?
                                                <DateTimePicker
                                                  onChange={(e) => this.handleDateTimeChange(e, "destination")}
                                                  value={this.state.orderData.destination.deliverBy ? pickUpBy : null}
                                                />
                                                :
                                                <DateTimePicker
                                                  onChange={(e) => this.handleDateTimeChange(e, "destination")}
                                                  value={this.state.orderData.destination.deliverBy ? pickUpBy : null}
                                                />
                                              }
                                            </div>
                                          }

                                          {/* <FormControl
                                                                                      fullWidth
                                                                                      className={classes.selectFormControl}>
                                                                                      <InputLabel
                                                                                        htmlFor="deliverBy"
                                                                                        className={classes.selectLabel}>
                                                                                        PICK UP BY
                                                                                </InputLabel>
                                                                                      <Select
                                                                                        MenuProps={{
                                                                                          className: classes.selectMenu
                                                                                        }}
                                                                                        classes={{
                                                                                          select: classes.select
                                                                                        }}
                                                                                        value={this.state.orderData.origin['deliverBy']}
                                                                                        onChange={(e) => this.handleSelectChangeObj(e, 'destination')}
                                                                                        defaultValue={this.state.orderData.origin['deliverBy'] ? this.state.orderData.origin['deliverBy'] : ''}
                                                                                        inputProps={{
                                                                                          id: 'deliverBy',
                                                                                          name: 'deliverBy'
                                                                                        }}
                                                                                      >
                                                                                        {
                                                                                          militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                              classes={{
                                                                                                root: classes.selectMenuItem
                                                                                              }}
                                                                                              value={item}
                                                                                              key={item}
                                                                                            >{item}</MenuItem>
                                                                                          ))
                                                                                        }
                                                                                      </Select>
                                                                                    </FormControl> */}
                                        </GridItem>
                                      </GridContainer>
                                      {this.state.leg1 &&
                                        <div>
                                          Transfer Driver #1:
                                          <GridContainer>
                                            <GridItem xs={6} sm={6}>
                                              <FormControl
                                                fullWidth
                                                className={classes.selectFormControl}>
                                                <InputLabel
                                                  htmlFor="vendorTransfer1"
                                                  style={{
                                                    color: "#000"
                                                  }}
                                                //className={classes.selectLabel}
                                                >
                                                  Vendor:
                                                </InputLabel>
                                                <Select
                                                  // MenuProps={{
                                                  //     className: classes.selectMenu
                                                  // }}
                                                  // classes={{
                                                  //     select: classes.select
                                                  // }}
                                                  style={{
                                                    color: "#000"
                                                  }}
                                                  value={this.state.vendorTransfer1}
                                                  onChange={this.handleSelectChange}
                                                  inputProps={{
                                                    id: 'vendorTransfer1',
                                                    name: 'vendorTransfer1'
                                                  }}
                                                >
                                                  {this.state.vendorsData &&
                                                    this.state.vendorsData.map((item) => (
                                                      <MenuItem
                                                        // classes={{
                                                        //     root: classes.selectMenuItem
                                                        // }}
                                                        style={{
                                                          color: "#000"
                                                        }}
                                                        value={item}
                                                        key={item}
                                                      >{item.name}</MenuItem>
                                                    ))
                                                  }
                                                </Select>
                                                <CustomInput
                                                  labelText="Drop Off Rate"
                                                  id="dropOffRate"
                                                  formControlProps={{
                                                    fullWidth: true
                                                  }}
                                                  inputProps={{
                                                    required: true,
                                                    onChange: (event) => this.handleChange(event)
                                                  }}
                                                />
                                              </FormControl>
                                            </GridItem>
                                            {this.state.vendorTransfer1 ?
                                              <GridItem xs={6} sm={6}>
                                                <FormControl
                                                  fullWidth
                                                  className={classes.selectFormControl}>
                                                  <InputLabel
                                                    htmlFor="driverTransfer1"
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                  //className={classes.selectLabel}
                                                  >
                                                    Driver:
                                                  </InputLabel>
                                                  <Select
                                                    // MenuProps={{
                                                    //     className: classes.selectMenu
                                                    // }}
                                                    // classes={{
                                                    //     select: classes.select
                                                    // }}
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                    value={this.state.driver}
                                                    onChange={this.handleSelectChange}
                                                    inputProps={{
                                                      id: 'driverTransfer1',
                                                      name: 'driverTransfer1'
                                                    }}
                                                  >
                                                    {this.state.driversPickUpData &&
                                                      this.state.driversPickUpData.map((item) => (
                                                        <MenuItem
                                                          // classes={{
                                                          //     root: classes.selectMenuItem
                                                          // }}
                                                          style={{
                                                            color: "#000"
                                                          }}
                                                          value={item}
                                                          key={item}
                                                        >{item.name}</MenuItem>
                                                      ))
                                                    }
                                                  </Select>
                                                </FormControl>
                                              </GridItem>

                                              : null}

                                          </GridContainer>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <CustomInput
                                                labelText="Flight Number #2"
                                                id="flightNumber2"
                                                formControlProps={{
                                                  fullWidth: true
                                                }}
                                                inputProps={{
                                                  required: true,
                                                  onChange: (event) => this.handleChange(event)
                                                }}
                                              />

                                            </GridItem>
                                            <GridItem xs={6}>
                                              <Button
                                                color="primary"
                                                onClick={() => this.addLeg2()}
                                              >
                                                ADD LEG
                                              </Button>

                                            </GridItem>
                                            <GridItem xs={6}>
                                              <Button
                                                color="info"
                                                onClick={() => this.removeLeg2()}
                                              >
                                                REMOVE LEG
                                              </Button>

                                            </GridItem>

                                          </GridContainer>
                                        </div>
                                      }
                                    </div>}

                                  {((this.state.deliveryType == "Ground" || this.state.deliveryType == "Additional Options") && (this.state.orderData.status == "booked" || this.state.orderData.status == 'Booked' || this.state.orderData.status == "Dispatched")) &&
                                    <div>
                                      <GridContainer>
                                        <GridItem xs={12} sm={4}>
                                          <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}>
                                            <InputLabel
                                              htmlFor="vendorPickUp"
                                              style={{
                                                color: "#000"
                                              }}
                                            //className={classes.selectLabel}
                                            >
                                              Pick Up Vendor:
                                            </InputLabel>
                                            <Select
                                              // MenuProps={{
                                              //     className: classes.selectMenu
                                              // }}
                                              // classes={{
                                              //     select: classes.select
                                              // }}
                                              style={{
                                                color: "#000"
                                              }}
                                              value={this.state.vendorPickUp}
                                              onChange={this.handleSelectPickUpVendorChange}
                                              inputProps={{
                                                id: 'vendorPickUp',
                                                name: 'vendorPickUp'
                                              }}
                                            >
                                              {this.state.qualifiedGroundPickUpVendors &&
                                                this.state.qualifiedGroundPickUpVendors.map((item) => (
                                                  <MenuItem
                                                    // classes={{
                                                    //     root: classes.selectMenuItem
                                                    // }}
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                    value={item}
                                                    key={item}
                                                  >{item.name}</MenuItem>
                                                ))
                                              }
                                            </Select>
                                          </FormControl>
                                          Pick Up Driver:

                                          {(this.state.vendorPickUp && (this.state.deliveryType == "Ground" || this.state.deliveryType == "Additional Options")) ?
                                            //   <FormControl
                                            //     fullWidth
                                            //     className={classes.selectFormControl}>
                                            //     <InputLabel
                                            //       htmlFor="driverPickUp"
                                            //       style={{
                                            //         color: "#000"
                                            //       }}
                                            //     //className={classes.selectLabel}
                                            //     >
                                            //       Driver:
                                            //  </InputLabel>
                                            //     <Select
                                            //       // MenuProps={{
                                            //       //     className: classes.selectMenu
                                            //       // }}
                                            //       // classes={{
                                            //       //     select: classes.select
                                            //       // }}
                                            //       style={{
                                            //         color: "#000"
                                            //       }}
                                            //       value={this.state.driver ? this.state.driver : null}
                                            //       onChange={this.handleSelectChange}
                                            //       inputProps={{
                                            //         id: 'driverPickUp',
                                            //         name: 'driverPickUp'
                                            //       }}
                                            //     >
                                            //       {this.state.driversPickUpSTAData &&
                                            //         this.state.driversPickUpSTAData.map((item) => (
                                            //           item.sta &&
                                            //           <MenuItem
                                            //           // classes={{
                                            //           //     root: classes.selectMenuItem
                                            //           // }}
                                            //           style={{
                                            //             color: "#000"
                                            //           }}
                                            //           value={item}
                                            //           key={item}
                                            //         >{item.name}</MenuItem>

                                            //         ))
                                            //       }
                                            //     </Select>

                                            //   </FormControl>


                                            <div>
                                              {!this.state.driverSelected &&
                                                <div>
                                                  {this.state.driversPickUpSTAData &&
                                                    this.state.driversPickUpSTAData.map((item) => (
                                                      <div
                                                        onClick={() => this.selectDriver(item)}
                                                        style={{ cursor: "pointer" }}
                                                      >
                                                        {item.name}
                                                      </div>
                                                    ))
                                                  }
                                                </div>
                                              }

                                            </div>
                                            : null}
                                          <b>{(this.state.pickUpDriverName && this.state.driverSelected) &&
                                            this.state.pickUpDriverName
                                          }</b>
                                          <CustomInput
                                            labelText="Pick Up Rate"
                                            id="pickUpRate"
                                            formControlProps={{
                                              fullWidth: true
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) => this.handleChange(event)
                                            }}
                                          />
                                          Deliver By:
                                          {this.state.origin &&
                                            <div>

                                              <DateTimePicker
                                                onChange={(e) => this.handleDateTimeChange(e, "origin")}
                                                value={deliverBy}
                                              />
                                            </div>
                                          }
                                          {/* {this.state.vendorPickUp ?
                                                                                    <FormControl
                                                                                      fullWidth
                                                                                      className={classes.selectFormControl}>
                                                                                      <InputLabel
                                                                                        htmlFor="driverPickUp"
                                                                                        style={{
                                                                                          color: "#000"
                                                                                        }}
                                                                                      //className={classes.selectLabel}
                                                                                      >
                                                                                        Driver:
                                                                                   </InputLabel>
                                                                                      <Select
                                                                                        // MenuProps={{
                                                                                        //     className: classes.selectMenu
                                                                                        // }}
                                                                                        // classes={{
                                                                                        //     select: classes.select
                                                                                        // }}
                                                                                        style={{
                                                                                          color: "#000"
                                                                                        }}
                                                                                        value={this.state.driver}
                                                                                        onChange={this.handleSelectChange}
                                                                                        inputProps={{
                                                                                          id: 'driverPickUp',
                                                                                          name: 'driverPickUp'
                                                                                        }}
                                                                                      >
                                                                                        {this.state.driversPickUpData &&
                                                                                          this.state.driversPickUpData.map((item) => (
                                                                                            <MenuItem
                                                                                              // classes={{
                                                                                              //     root: classes.selectMenuItem
                                                                                              // }}
                                                                                              style={{
                                                                                                color: "#000"
                                                                                              }}
                                                                                              value={item}
                                                                                              key={item}
                                                                                            >{item.name}</MenuItem>
                                                                                          ))
                                                                                        }
                                                                                      </Select>
                                                                                      <CustomInput
                                                                                    labelText="Pick Up Rate"
                                                                                    id="pickUpRate"
                                                                                    formControlProps={{
                                                                                      fullWidth: true
                                                                                    }}
                                                                                    inputProps={{
                                                                                      required: true,
                                                                                      onChange: (event) => this.handleChange(event)
                                                                                    }}/>
                                                                                    </FormControl>
                                     
                                                                                    : null} */}
                                        </GridItem>
                                      </GridContainer>

                                    </div>}

                                  {(this.state.deliveryType == "LTL" && this.state.orderData.status == "booked") &&
                                    <div>
                                      <GridContainer>
                                        <GridItem xs={12} sm={4}>
                                          Pick Up Driver:
                                          <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}>
                                            <InputLabel
                                              htmlFor="vendorPickUp"
                                              style={{
                                                color: "#000"
                                              }}
                                            //className={classes.selectLabel}
                                            >
                                              Vendor:
                                            </InputLabel>
                                            <Select
                                              // MenuProps={{
                                              //     className: classes.selectMenu
                                              // }}
                                              // classes={{
                                              //     select: classes.select
                                              // }}
                                              style={{
                                                color: "#000"
                                              }}
                                              value={this.state.vendorPickUp}
                                              onChange={this.handleSelectChange}
                                              inputProps={{
                                                id: 'vendorPickUp',
                                                name: 'vendorPickUp'
                                              }}
                                            >
                                              {this.state.vendorsData &&
                                                this.state.vendorsData.map((item) => (
                                                  <MenuItem
                                                    // classes={{
                                                    //     root: classes.selectMenuItem
                                                    // }}
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                    value={item}
                                                    key={item}
                                                  >{item.name}</MenuItem>
                                                ))
                                              }
                                            </Select>
                                          </FormControl>
                                          {this.state.vendorPickUp ?
                                            <FormControl
                                              fullWidth
                                              className={classes.selectFormControl}>
                                              <InputLabel
                                                htmlFor="driverPickUp"
                                                style={{
                                                  color: "#000"
                                                }}
                                              //className={classes.selectLabel}
                                              >
                                                Driver:
                                              </InputLabel>
                                              <Select
                                                // MenuProps={{
                                                //     className: classes.selectMenu
                                                // }}
                                                // classes={{
                                                //     select: classes.select
                                                // }}
                                                style={{
                                                  color: "#000"
                                                }}
                                                value={this.state.driver}
                                                onChange={this.handleSelectChange}
                                                inputProps={{
                                                  id: 'driverPickUp',
                                                  name: 'driverPickUp'
                                                }}
                                              >
                                                {this.state.driversPickUpData &&
                                                  this.state.driversPickUpData.map((item) => (
                                                    <MenuItem
                                                      // classes={{
                                                      //     root: classes.selectMenuItem
                                                      // }}
                                                      style={{
                                                        color: "#000"
                                                      }}
                                                      value={item}
                                                      key={item}
                                                    >{item.name}</MenuItem>
                                                  ))
                                                }
                                              </Select>
                                              <CustomInput
                                                labelText="Pick Up Rate"
                                                id="pickUpRate"
                                                formControlProps={{
                                                  fullWidth: true
                                                }}
                                                inputProps={{
                                                  required: true,
                                                  onChange: (event) => this.handleChange(event)
                                                }} />
                                            </FormControl>

                                            : null}
                                        </GridItem>
                                        <GridItem xs={12} md={4}>
                                          <CustomInput
                                            labelText="Terminal Number #1"
                                            id="terminalID"
                                            formControlProps={{
                                              fullWidth: true
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) => this.handleChange(event)
                                            }}
                                          />
                                          <Button
                                            color="primary"
                                            onClick={() => this.addLeg()}
                                          >
                                            ADD LEG
                                          </Button>
                                        </GridItem>
                                        <GridItem xs={12} sm={4}>
                                          Drop Off Driver

                                          <FormControl
                                            fullWidth
                                            className={classes.selectFormControl}>
                                            <InputLabel
                                              htmlFor="vendorDropOff"
                                              style={{
                                                color: "#000"
                                              }}
                                            //className={classes.selectLabel}
                                            >
                                              Vendor:
                                            </InputLabel>
                                            <Select
                                              // MenuProps={{
                                              //     className: classes.selectMenu
                                              // }}
                                              // classes={{
                                              //     select: classes.select
                                              // }}
                                              style={{
                                                color: "#000"
                                              }}
                                              value={this.state.vendorDropOff}
                                              onChange={this.handleSelectChange}
                                              inputProps={{
                                                id: 'vendorDropOff',
                                                name: 'vendorDropOff'
                                              }}
                                            >
                                              {this.state.vendorsData &&
                                                this.state.vendorsData.map((item) => (
                                                  <MenuItem
                                                    // classes={{
                                                    //     root: classes.selectMenuItem
                                                    // }}
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                    value={item}
                                                    key={item}
                                                  >{item.name}</MenuItem>
                                                ))
                                              }
                                            </Select>
                                            <CustomInput
                                              labelText="Drop Off Rate"
                                              id="dropOffRate"
                                              formControlProps={{
                                                fullWidth: true
                                              }}
                                              inputProps={{
                                                required: true,
                                                onChange: (event) => this.handleChange(event)
                                              }} />
                                          </FormControl>
                                          {this.state.vendorDropOff ?
                                            <FormControl
                                              fullWidth
                                              className={classes.selectFormControl}>
                                              <InputLabel
                                                htmlFor="driverDropOff"
                                                style={{
                                                  color: "#000"
                                                }}
                                              //className={classes.selectLabel}
                                              >
                                                Driver:
                                              </InputLabel>
                                              <Select
                                                // MenuProps={{
                                                //     className: classes.selectMenu
                                                // }}
                                                // classes={{
                                                //     select: classes.select
                                                // }}
                                                style={{
                                                  color: "#000"
                                                }}
                                                value={this.state.driver}
                                                onChange={this.handleSelectChange}
                                                inputProps={{
                                                  id: 'driverDropOff',
                                                  name: 'driverDropOff'
                                                }}
                                              >
                                                {this.state.driversDropOffData &&
                                                  this.state.driversDropOffData.map((item) => (
                                                    <MenuItem
                                                      // classes={{
                                                      //     root: classes.selectMenuItem
                                                      // }}
                                                      style={{
                                                        color: "#000"
                                                      }}
                                                      value={item}
                                                      key={item}
                                                    >{item.name}</MenuItem>
                                                  ))
                                                }
                                              </Select>
                                            </FormControl>

                                            : null}
                                        </GridItem>
                                      </GridContainer>
                                      {this.state.leg1 &&
                                        <div>
                                          Transfer Driver #1:
                                          <GridContainer>
                                            <GridItem xs={6} sm={6}>
                                              <FormControl
                                                fullWidth
                                                className={classes.selectFormControl}>
                                                <InputLabel
                                                  htmlFor="vendorTransfer1"
                                                  style={{
                                                    color: "#000"
                                                  }}
                                                //className={classes.selectLabel}
                                                >
                                                  Vendor:
                                                </InputLabel>
                                                <Select
                                                  // MenuProps={{
                                                  //     className: classes.selectMenu
                                                  // }}
                                                  // classes={{
                                                  //     select: classes.select
                                                  // }}
                                                  style={{
                                                    color: "#000"
                                                  }}
                                                  value={this.state.vendorTransfer1}
                                                  onChange={this.handleSelectChange}
                                                  inputProps={{
                                                    id: 'vendorTransfer1',
                                                    name: 'vendorTransfer1'
                                                  }}
                                                >
                                                  {this.state.vendorsData &&
                                                    this.state.vendorsData.map((item) => (
                                                      <MenuItem
                                                        // classes={{
                                                        //     root: classes.selectMenuItem
                                                        // }}
                                                        style={{
                                                          color: "#000"
                                                        }}
                                                        value={item}
                                                        key={item}
                                                      >{item.name}</MenuItem>
                                                    ))
                                                  }
                                                </Select>
                                              </FormControl>
                                            </GridItem>
                                            {this.state.vendorTransfer1 ?
                                              <GridItem xs={6} sm={6}>
                                                <FormControl
                                                  fullWidth
                                                  className={classes.selectFormControl}>
                                                  <InputLabel
                                                    htmlFor="driverTransfer1"
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                  //className={classes.selectLabel}
                                                  >
                                                    Driver:
                                                  </InputLabel>
                                                  <Select
                                                    // MenuProps={{
                                                    //     className: classes.selectMenu
                                                    // }}
                                                    // classes={{
                                                    //     select: classes.select
                                                    // }}
                                                    style={{
                                                      color: "#000"
                                                    }}
                                                    value={this.state.driver}
                                                    onChange={this.handleSelectChange}
                                                    inputProps={{
                                                      id: 'driverTransfer1',
                                                      name: 'driverTransfer1'
                                                    }}
                                                  >
                                                    {this.state.driversPickUpData &&
                                                      this.state.driversPickUpData.map((item) => (
                                                        <MenuItem
                                                          // classes={{
                                                          //     root: classes.selectMenuItem
                                                          // }}
                                                          style={{
                                                            color: "#000"
                                                          }}
                                                          value={item}
                                                          key={item}
                                                        >{item.name}</MenuItem>
                                                      ))
                                                    }
                                                  </Select>
                                                </FormControl>
                                              </GridItem>

                                              : null}

                                          </GridContainer>
                                          <GridContainer>
                                            <GridItem xs={12}>
                                              <CustomInput
                                                labelText="Terminal Number #2"
                                                id="terminalNumber2"
                                                formControlProps={{
                                                  fullWidth: true
                                                }}
                                                inputProps={{
                                                  required: true,
                                                  onChange: (event) => this.handleChange(event)
                                                }}
                                              />

                                            </GridItem>
                                            <GridItem xs={6}>
                                              <Button
                                                color="primary"
                                                onClick={() => this.addLeg2()}
                                              >
                                                ADD LEG
                                              </Button>

                                            </GridItem>
                                            <GridItem xs={6}>
                                              <Button
                                                color="info"
                                                onClick={() => this.removeLeg2()}
                                              >
                                                REMOVE LEG
                                              </Button>

                                            </GridItem>

                                          </GridContainer>
                                        </div>
                                      }
                                    </div>}
                                </div>
                              }

                            </GridItem>
                          </GridContainer>
                          <GridContainer>


                            <GridItem xs={12}>
                              {(pathname == "/completed-orders") ? null :
                                <div>


                                  <br />
                                  {this.state.orderData &&
                                    <GridContainer>
                                      <GridItem xs={12} md={4}>
                                        <FlightSearchForm onSelectFlight={this.selectFlight} originCity={this.state.orderData && this.state.orderData.origin.city} originState={this.state.orderData && this.state.orderData.origin.state} destinationCity={this.state.orderData && this.state.orderData.destination.city} destinationState={this.state.orderData && this.state.orderData.destination.state} />
                                      </GridItem>
                                      <GridItem xs={12} md={8}>
                                        Documents
                                        <GridContainer>
                                          <GridItem xs={12} md={4}>
                                            {this.state.orderData.driverPickUpRateConURL &&
                                              <a href={this.state.orderData.driverPickUpRateConURL && this.state.orderData.driverPickUpRateConURL} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Pick-Up Alert
                                                </Button>
                                              </a>
                                            }
                                            {/* {this.state.orderData.driverPickUpRateConURL &&
                                    <a href={this.state.orderData.driverPickUpRateConURL && this.state.orderData.driverPickUpRateConURL} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Pick-Up Rate Con
                                  </Button>
                                  </a>
                                    } */}
                                            {(this.state.orderData.pickUpRateStatus == "confirmed") ?
                                              <a href={`https://api.eversign.com/api/download_final_document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${this.state.orderData.pickUpRateConfirmHash}&audit_trail=1`} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Pick-Up Rate Con
                                                </Button>
                                              </a>
                                              : null
                                            }

                                            {((this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") && this.state.orderData.driverDropOffRateConURL) &&
                                              <a href={this.state.orderData.driverDropOffRateConURL && this.state.orderData.driverDropOffRateConURL} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Drop Off Alert
                                                </Button>
                                              </a>
                                            }
                                            {(this.state.orderData.dropOffRateStatus == "confirmed") ?
                                              <a href={`https://api.eversign.com/api/download_final_document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${this.state.orderData.dropOffRateConfirmHash}&audit_trail=1`} target="_blank">
                                                <Button
                                                  color="info"
                                                >
                                                  Drop-Off Rate Con
                                                </Button>
                                              </a>
                                              : null
                                            }
                                            {(this.state.orderData.status == "Delivered" || this.state.orderData.status == "Completed" || this.state.orderData.status == "completed") ?
                                              <a href={`https://api.eversign.com/api/download_final_document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${this.state.orderData.bolHash}&audit_trail=1`} target="_blank">
                                                <Button
                                                  color="info"
                                                >Completed {(this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : "Bill of Lading"}</Button>
                                              </a>
                                              : null
                                            }
                                            {this.state.orderData.delivery &&
                                              <a href={this.state.orderData.delivery && this.state.orderData.delivery.BOLPICS[0]} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Proof of Delivery
                                                </Button>
                                              </a>
                                            }
                                            {(this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") &&
                                              <a href={this.state.orderData.signingSampleWaybillURL} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Sample Waybill
                                                </Button>
                                              </a>
                                            }
                                            {(!this.state.orderData.origin.ksms && this.state.orderData.driverIVFURL && this.state.orderData.deliveryType == "Air") &&

                                              <a href={this.state.orderData.driverIVFURL} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Shippers Identification Validation
                                                </Button>
                                              </a>
                                            }

                                            {this.state.orderData.signingURLs &&
                                              <a href={this.state.orderData.signingURLs && this.state.orderData.signingURLs[0]} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Shipper BOL
                                                </Button>
                                              </a>
                                            }
                                            {this.state.orderData.signingURLs &&
                                              <a href={this.state.orderData.signingURLs && this.state.orderData.signingURLs[1]} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Driver BOL
                                                </Button>
                                              </a>
                                            }
                                            {this.state.orderData.signingURLs &&
                                              <a href={this.state.orderData.signingURLs && this.state.orderData.signingURLs[2]} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Consignee BOL
                                                </Button>
                                              </a>
                                            }
                                            <a href={this.state.orderData && ("https://haney-freightways-driver.web.app/pages/upload/" + this.state.orderData.id)} target="_blank">
                                              <Button
                                                color="primary"
                                              >
                                                Driver APP
                                              </Button>
                                            </a>
                                            {this.state.orderData.accufrateURL &&
                                              <a href={this.state.orderData.accufrateURL} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Accufrate
                                                </Button>
                                              </a>
                                            }
                                            {this.state.orderData.labelURL &&
                                              <a href={this.state.orderData.labelURL} target="_blank">
                                                <Button
                                                  color="primary"
                                                >
                                                  Label
                                                </Button>
                                              </a>
                                            }
                                            <VendorPicUpload onAssignPic={this.assignPic2} label="Accufrate" field="accufrateURL" />
                                            <VendorPicUpload onAssignPic={this.assignPic2} label="Label" field="labelURL" />

                                            {/* {(this.state.deliveryType == "Ground" || this.state.deliveryType == "LTL")
                                    &&
                                  <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FGround%20Only%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=f95662dd-c5ad-405f-a70a-0c8479a1faa9" target="_blank">
                                  <Button
                                    color="primary"
                                  >
                                    Ground Only Rate Confirmation
                                  </Button>
                                  </a>}
                                  <br/>
                                  <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Shipper%20Air%20Pick%20Up%20Final%203.3.2020.pdf?alt=media&token=b9bf832c-4c5c-40b0-ac53-bab0b1bd2336" target="_blank">
                                  <Button
                                    color="primary"
                                  >
                                    Known Shipper Air Pick-Up Alert
                                  </Button>
                                  </a><br/>
                                  <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FHouse%20Waybill%20Final%203.4.2020.pdf?alt=media&token=ffcb839a-def3-4ecc-a0f1-3f398aea160d" target="_blank">
                                  <Button
                                    color="primary"
                                  >
                                    House Waybill
                                  </Button>
                                  </a><br/> */}

                                            <br />
                                            {/* <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FHouse%20Waybill%20Final%203.4.2020.pdf?alt=media&token=ffcb839a-def3-4ecc-a0f1-3f398aea160d" target="_blank"> */}
                                            {/* </a> */}

                                          </GridItem>
                                          {this.state.orderData &&


                                            <GridItem xs={12} md={8}>
                                              Submitted At: {this.state.orderData.updatedAt && moment(this.state.orderData.updatedAt.toDate()).format('MM-DD-YYYY HH:ss')}<br />
                                              Quoted At: {this.state.orderData.quotedAt && moment(this.state.orderData.quotedAt.toDate()).format('MM-DD-YYYY HH:ss')}<br />
                                              Booked At: {this.state.orderData.bookedAt && moment(this.state.orderData.bookedAt.toDate()).format('MM-DD-YYYY HH:ss')}<br />
                                              Dispatched At: {this.state.orderData.dispatcherAssigned && (this.state.orderData.dispatcherAssigned && moment(this.state.orderData.dispatcherAssigned.toDate()).format('MM-DD-YYYY HH:mm'))}
                                              {/* Booked At: {this.state.orderData && moment(this.state.orderData.bookedAt._d).format('YYYY-MM-DD HH:SS')}
                                       Booked At: {this.state.orderData && moment(this.state.orderData.bookedAt._d).format('YYYY-MM-DD HH:SS')} */}
                                            </GridItem>


                                          }


                                        </GridContainer>

                                      </GridItem>
                                      {/* <GridItem xs={12} md={4}>
                                                                              <ShipFullScreenMap originCoords={this.state.originCoords} destinationCoords={this.state.destinationCoords} />
                                                                            </GridItem> <br /> */}
                                      {/* <GridItem xs={12} md={4}>
                                                                              <GridContainer>
                                                                                <GridItem xs={12}>
                                                                                  <GridContainer>
                                                                                    <GridItem xs={6}>
                                      
                                                                                      <DatePicker
                                                                                        onChange={this.handlePickUpDateChange}
                                                                                        value={this.state.pickUpDate ? this.state.pickUpDate : ''}
                                                                                      />
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <FormControl
                                                                                        fullWidth
                                                                                        className={classes.selectFormControl}>
                                                                                        <InputLabel
                                                                                          htmlFor="radius"
                                                                                          className={classes.selectLabel}>
                                                                                          Radius:
                                                                </InputLabel>
                                                                                        <Select
                                                                                          MenuProps={{
                                                                                            className: classes.selectMenu
                                                                                          }}
                                                                                          classes={{
                                                                                            select: classes.select
                                                                                          }}
                                                                                          value={this.state.radius}
                                                                                          onChange={this.handleSelectChange}
                                                                                          defaultValue={this.state.radius ? this.state.radius : ''}
                                                                                          inputProps={{
                                                                                            id: 'radius',
                                                                                            name: 'radius'
                                                                                          }}
                                                                                        >
                                                                                          {
                                                                                            radiusOptions.map((item) => (
                                                                                              <MenuItem
                                                                                                classes={{
                                                                                                  root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                              >{item}</MenuItem>
                                                                                            ))
                                                                                          }
                                                                                        </Select>
                                                                                      </FormControl>
                                      
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <CustomInput
                                                                                        labelText="Starting City"
                                                                                        id="originCity"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: false,
                                                                                          type: "text",
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.originCity ? this.state.orderData.originCity : ''
                                                                                        }}
                                                                                      />
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <CustomInput
                                                                                        labelText="Starting State"
                                                                                        id="originState"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: false,
                                                                                          type: "text",
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.originState ? this.state.orderData.originState : ''
                                                                                        }}
                                                                                      />
                                      
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <CustomInput
                                                                                        labelText="Ending City"
                                                                                        id="destinationCity"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: false,
                                                                                          type: "text",
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.destinationCity ? this.state.orderData.destinationCity : ''
                                                                                        }}
                                                                                      />
                                      
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <CustomInput
                                                                                        labelText="Ending State"
                                                                                        id="destinationState"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: false,
                                                                                          type: "text",
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.destinationState ? this.state.orderData.destinationState : ''
                                                                                        }}
                                                                                      />
                                      
                                                                                    </GridItem>
                                                                                  </GridContainer>
                                      
                                      
                                                                                </GridItem>
                                                                                <GridItem xs={6}>
                                                                                  {this.state.pickUpDate &&
                                                                                    <Button
                                                                                      color="primary"
                                                                                      onClick={() => this.getFlights(this.state.originCoords, this.state.destinationCoords)}
                                                                                    >
                                                                                      SEARCH FLIGHTS
                                                                            </Button>
                                                                                  }
                                      
                                      
                                                                                </GridItem>
                                                                                <GridItem xs={6}>
                                                                                  <Button
                                                                                    color="info"
                                                                                    onClick={() => this.hideFlights()}
                                                                                  >
                                                                                    {this.state.hideFlights ? "SHOW" : "HIDE"} FLIGHTS
                                                                            </Button>
                                                                                </GridItem>
                                                                                <GridItem xs={12}>
                                                                                  {!this.state.hideFlights &&
                                                                                    <GridContainer>
                                                                                      {(this.state.matchingFlights.sort((a, b) => (a.movement.scheduledTimeUtc > b.movement.scheduledTimeUtc) ? 1 : -1)).map(flight => {
                                                                                        return (
                                                                                          <GridItem xs={12}>
                                                                                            <Card style={{ backgroundColor: (flight.number == this.state.flightNumber) ? "#efe6e6" : "white", boxShadow: "0px 0px 8px 0px #888888", borderRadius: "5px" }} onClick={() => this.assignFlightNumber(flight.number, flight.originAirport, flight.movement.airport.icao)}>
                                                                                              <GridContainer style={{ textAlign: "center" }}>
                                                                                                <GridItem xs={4}>
                                                                                                  <h4><b>{flight.number}</b></h4>
                                                                                                </GridItem>
                                                                                                <GridItem xs={4}>
                                                                                                  <h6 style={{ marginTop: "10px" }}>{flight.aircraft.model}</h6>
                                                                                                </GridItem>
                                                                                                <GridItem xs={4}>
                                                                                                  <h4><b>{flight.airline.name}</b></h4>
                                                                                                </GridItem>
                                                                                              </GridContainer>
                                                                                              <GridContainer style={{ textAlign: "center" }}>
                                                                                                <GridItem xs={5}>
                                                                                                  <h2 style={{ margin: "0" }}><b>{flight.originAirport}</b></h2>
                                                                                                </GridItem>
                                                                                                <GridItem xs={2}>
                                                                                                  <h4><b>=></b></h4>
                                                                                                </GridItem>
                                                                                                <GridItem xs={5}>
                                                                                                  <h2 style={{ margin: "0" }}><b>{flight.movement.airport.icao}</b></h2>
                                                                                                </GridItem>
                                                                                                <GridItem xs={12}>
                                                                                                  <h5><b>{flight.movement.scheduledTimeLocal.slice(0, -6)}</b></h5>
                                                                                                </GridItem>
                                                                                              </GridContainer>
                                                                                            </Card>
                                                                                          </GridItem>
                                                                                        )
                                                                                      })}
                                                                                    </GridContainer>
                                                                                  }
                                                                                </GridItem>
                                                                              </GridContainer>
                                                                            </GridItem> */}
                                    </GridContainer>

                                  }





                                </div>
                              }

                            </GridItem>
                          </GridContainer>
                          <br /><br />
                          {(pathname == "/completed-orders") ?
                            <div>
                              <h3 style={{}}><b>Delivery Information</b></h3>
                              CONDITION: <b>{this.state.orderData && this.state.orderData.CONDITION}</b>
                              <br />
                              POD: {this.state.orderData &&
                                this.state.orderData.BOLPICS.map((item) => (
                                  <a style={{ color: "#ff0000 !important" }} href={item} target="_blank">Click here for image</a>
                                ))
                              }
                              <br />
                              {
                                this.state.orderData &&
                                <div>
                                  DAMAGE: {this.state.orderData.DAMAGEPIC &&
                                    this.state.orderData.DAMAGEPICS.map((item) => (
                                      <a style={{ color: "#ff0000 !important" }} href={item} target="_blank">Click here for image</a>
                                    ))
                                  }
                                </div>
                              }

                            </div>
                            :
                            null}


                          <GridContainer>
                            <GridItem xs={10}>
                              {/* <Button
                                  color="primary"
                                  style={{ marginTop: "20px" }}
                                  onClick={() => this.step5Back()}
                                >BACK</Button> */}
                            </GridItem>
                            {/* <GridItem xs={4}>
                                <Button

                                  style={{ color: "black", marginTop: "20px", backgroundColor: "#efe6e6" }}
                                  onClick={() => this.saveAsQuote()}
                                >SAVE QUOTE</Button>
                              </GridItem> */}

                            <GridItem xs={2}>
                              {this.state.documentsLoading &&
                                <React.Fragment>
                                  <p>Documents are being created...</p>
                                  <Check style={{ color: this.state.documentsLoaded > 0 ? 'green' : 'initial' }} /><br />
                                  <Check style={{ color: this.state.documentsLoaded > 1 ? 'green' : 'initial' }} /><br />
                                  <Check style={{ color: this.state.documentsLoaded > 2 ? 'green' : 'initial' }} /><br />
                                  <Check style={{ color: this.state.documentsLoaded > 3 ? 'green' : 'initial' }} /><br />
                                  <Check style={{ color: this.state.documentsLoaded > 4 ? 'green' : 'initial' }} /><br />
                                </React.Fragment>
                              }

                              <Button
                                type="submit"
                                color="primary"
                                style={{
                                  marginTop: "20px",
                                  float: "right"
                                }}
                              >
                                DISPATCH
                              </Button>
                            </GridItem>
                          </GridContainer>

                        </div>
                        : null}
                      <br />
                    </GridItem>
                  </GridContainer>

                </form>
              </div>
            </GridItem>
          </GridContainer>

        )}
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
  //console.log(state)
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    // orderID: ownProps.match.params.id
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(Form);


// WEBPACK FOOTER //
// ./src/components/Forms/DispatchOrderForm2.jsx